import { jsx, jsxs, Fragment as Fragment$1 } from "react/jsx-runtime";
import * as React from "react";
import React__default, { memo, Fragment, useCallback, useMemo, useState, useEffect, useRef, useLayoutEffect } from "react";
import { UnfoldLess, UnfoldMore, UnfoldMoreDouble } from "@mui/icons-material";
import { createTheme, ThemeProvider, Tooltip as Tooltip$1, IconButton } from "@mui/material";
import Popper from "@mui/material/Popper";
import Paper from "@mui/material/Paper";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import * as ReactDOM from "react-dom";
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
var formatDistance = function formatDistance2(token, count2, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count2 === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count2.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }
  return result;
};
const formatDistance$1 = formatDistance;
function buildFormatLongFn(args) {
  return function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format2 = args.formats[width] || args.formats[args.defaultWidth];
    return format2;
  };
}
var dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
var timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
const formatLong$1 = formatLong;
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
var formatRelative = function formatRelative2(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
const formatRelative$1 = formatRelative;
function buildLocalizeFn(args) {
  return function(dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
    var valuesArray;
    if (context === "formatting" && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index2 = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index2];
  };
}
var eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
var quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
var monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};
var dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
};
var dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
var ordinalNumber = function ordinalNumber2(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};
var localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
const localize$1 = localize;
function buildMatchFn(args) {
  return function(string) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return void 0;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return void 0;
}
function buildMatchPatternFn(args) {
  return function(string) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult)
      return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult)
      return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: function valueCallback2(index2) {
      return index2 + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
const match$1 = match;
var locale = {
  code: "en-US",
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const enDateLocale = locale;
var ViewMode = /* @__PURE__ */ ((ViewMode2) => {
  ViewMode2["Hour"] = "Hour";
  ViewMode2["QuarterDay"] = "Quarter Day";
  ViewMode2["HalfDay"] = "Half Day";
  ViewMode2["Day"] = "Day";
  ViewMode2["TwoDays"] = "Two Days";
  ViewMode2["Week"] = "Week";
  ViewMode2["Month"] = "Month";
  ViewMode2["QuarterYear"] = "QuarterYear";
  ViewMode2["Year"] = "Year";
  return ViewMode2;
})(ViewMode || {});
var GanttDateRoundingTimeUnit = /* @__PURE__ */ ((GanttDateRoundingTimeUnit2) => {
  GanttDateRoundingTimeUnit2[GanttDateRoundingTimeUnit2["MINUTE"] = 0] = "MINUTE";
  GanttDateRoundingTimeUnit2[GanttDateRoundingTimeUnit2["HOUR"] = 1] = "HOUR";
  GanttDateRoundingTimeUnit2[GanttDateRoundingTimeUnit2["DAY"] = 2] = "DAY";
  return GanttDateRoundingTimeUnit2;
})(GanttDateRoundingTimeUnit || {});
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
  }
}
function _typeof$3(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$3 = function _typeof2(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof$3 = function _typeof2(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof$3(obj);
}
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || _typeof$3(argument) === "object" && argStr === "[object Date]") {
    return new Date(argument.getTime());
  } else if (typeof argument === "number" || argStr === "[object Number]") {
    return new Date(argument);
  } else {
    if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      console.warn(new Error().stack);
    }
    return /* @__PURE__ */ new Date(NaN);
  }
}
function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return /* @__PURE__ */ new Date(NaN);
  }
  if (!amount) {
    return date;
  }
  var dayOfMonth = date.getDate();
  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    return endOfDesiredMonth;
  } else {
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}
function addYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}
function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return /* @__PURE__ */ new Date(NaN);
  }
  if (!amount) {
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}
var MILLISECONDS_IN_HOUR = 36e5;
function addHours(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}
function subYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addYears(dirtyDate, -amount);
}
function subMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, -amount);
}
function subDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addDays(dirtyDate, -amount);
}
function subHours(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addHours(dirtyDate, -amount);
}
function addWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  var days = amount * 7;
  return addDays(dirtyDate, days);
}
function subWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addWeeks(dirtyDate, -amount);
}
function startOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var cleanDate = toDate(dirtyDate);
  var date = /* @__PURE__ */ new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
function startOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}
function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}
function startOfHour(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setMinutes(0, 0, 0);
  return date;
}
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function startOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}
function startOfQuarter(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3;
  date.setMonth(month, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}
var MILLISECONDS_IN_DAY$1 = 864e5;
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight);
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY$1);
}
function compareLocalAsc(dateLeft, dateRight) {
  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
  } else {
    return diff;
  }
}
function differenceInDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareLocalAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight));
  dateLeft.setDate(dateLeft.getDate() - sign * difference);
  var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
  var result = sign * (difference - isLastDayNotFull);
  return result === 0 ? 0 : result;
}
var millisecondsInMinute = 6e4;
var millisecondsInHour = 36e5;
function differenceInMilliseconds(dateLeft, dateRight) {
  requiredArgs(2, arguments);
  return toDate(dateLeft).getTime() - toDate(dateRight).getTime();
}
var roundingMap = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function trunc(value) {
    return value < 0 ? Math.ceil(value) : Math.floor(value);
  }
  // Math.trunc is not supported by IE
};
var defaultRoundingMethod = "trunc";
function getRoundingMethod(method) {
  return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}
function differenceInHours(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInHour;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}
function compareAsc(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
  } else {
    return diff;
  }
}
function endOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}
function endOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}
function isLastDayOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  return endOfDay(date).getTime() === endOfMonth(date).getTime();
}
function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight));
  var result;
  if (difference < 1) {
    result = 0;
  } else {
    if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
      dateLeft.setDate(30);
    }
    dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
    var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign;
    if (isLastDayOfMonth(toDate(dirtyDateLeft)) && difference === 1 && compareAsc(dirtyDateLeft, dateRight) === 1) {
      isLastMonthNotFull = false;
    }
    result = sign * (difference - Number(isLastMonthNotFull));
  }
  return result === 0 ? 0 : result;
}
function differenceInWeeks(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInDays(dateLeft, dateRight) / 7;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}
function differenceInYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight));
  dateLeft.setFullYear(1584);
  dateRight.setFullYear(1584);
  var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign;
  var result = sign * (difference - Number(isLastYearNotFull));
  return result === 0 ? 0 : result;
}
function differenceInQuarters(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMonths(dateLeft, dateRight) / 3;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
const getDatesDiff = (dateFrom, dateTo, viewMode) => {
  switch (viewMode) {
    case ViewMode.Day:
      return differenceInDays(dateFrom, dateTo);
    case ViewMode.TwoDays:
      return Math.round(differenceInDays(dateFrom, dateTo) / 2);
    case ViewMode.HalfDay:
      return Math.round(differenceInHours(dateFrom, dateTo) / 12);
    case ViewMode.QuarterDay:
      return Math.round(differenceInHours(dateFrom, dateTo) / 6);
    case ViewMode.Hour:
      return differenceInHours(dateFrom, dateTo);
    case ViewMode.Month:
      return differenceInMonths(dateFrom, dateTo);
    case ViewMode.Week:
      return differenceInWeeks(dateFrom, dateTo);
    case ViewMode.QuarterYear:
      return differenceInQuarters(dateFrom, dateTo);
    case ViewMode.Year:
      return differenceInYears(dateFrom, dateTo);
    default:
      throw new Error("Unknown view mode");
  }
};
const ganttDateRange = (tasks, viewMode, preStepsCount) => {
  let minTaskDate = null;
  let maxTaskDate = null;
  for (const task of tasks) {
    if (task.type !== "empty") {
      if (!minTaskDate || task.start < minTaskDate) {
        minTaskDate = task.start;
      }
      if (!maxTaskDate || task.end > maxTaskDate) {
        maxTaskDate = task.end;
      }
    }
  }
  if (!minTaskDate || !maxTaskDate) {
    return [/* @__PURE__ */ new Date(), /* @__PURE__ */ new Date(), 2];
  }
  let newStartDate = null;
  let newEndDate = null;
  switch (viewMode) {
    case ViewMode.Year:
      newStartDate = subYears(minTaskDate, preStepsCount);
      newStartDate = startOfYear(newStartDate);
      newEndDate = addYears(maxTaskDate, 1);
      newEndDate = startOfYear(newEndDate);
      break;
    case ViewMode.QuarterYear:
      newStartDate = subMonths(minTaskDate, preStepsCount * 3);
      newStartDate = startOfQuarter(newStartDate);
      newEndDate = addMonths(maxTaskDate, 3);
      newEndDate = startOfQuarter(addMonths(newEndDate, 3));
      break;
    case ViewMode.Month:
      newStartDate = subMonths(minTaskDate, preStepsCount);
      newStartDate = startOfMonth(newStartDate);
      newEndDate = addYears(maxTaskDate, 1);
      newEndDate = startOfYear(newEndDate);
      break;
    case ViewMode.Week:
      newStartDate = startOfWeek(minTaskDate);
      newStartDate = subWeeks(newStartDate, preStepsCount);
      newEndDate = startOfDay(maxTaskDate);
      newEndDate = addMonths(newEndDate, 1.5);
      break;
    case ViewMode.TwoDays:
      newStartDate = startOfDay(minTaskDate);
      newStartDate = subDays(newStartDate, preStepsCount);
      newEndDate = startOfDay(maxTaskDate);
      newEndDate = addDays(newEndDate, 19);
      break;
    case ViewMode.Day:
      newStartDate = startOfDay(minTaskDate);
      newStartDate = subDays(newStartDate, preStepsCount);
      newEndDate = startOfDay(maxTaskDate);
      newEndDate = addDays(newEndDate, 30);
      break;
    case ViewMode.QuarterDay:
      newStartDate = startOfDay(minTaskDate);
      newStartDate = subHours(newStartDate, preStepsCount * 6);
      newEndDate = startOfDay(maxTaskDate);
      newEndDate = addHours(newEndDate, 66);
      break;
    case ViewMode.HalfDay:
      newStartDate = startOfDay(minTaskDate);
      newStartDate = subHours(newStartDate, preStepsCount * 12);
      newEndDate = startOfDay(maxTaskDate);
      newEndDate = addHours(newEndDate, 108);
      break;
    case ViewMode.Hour:
      newStartDate = startOfHour(minTaskDate);
      newStartDate = subHours(newStartDate, preStepsCount);
      newEndDate = startOfDay(maxTaskDate);
      newEndDate = addDays(newEndDate, 1);
      break;
  }
  return [
    newStartDate,
    minTaskDate,
    getDatesDiff(newEndDate, newStartDate, viewMode)
  ];
};
const getWeekNumberISO8601 = (date) => {
  const tmpDate = new Date(date.valueOf());
  const dayNumber = (tmpDate.getDay() + 6) % 7;
  tmpDate.setDate(tmpDate.getDate() - dayNumber + 3);
  const firstThursday = tmpDate.valueOf();
  tmpDate.setMonth(0, 1);
  if (tmpDate.getDay() !== 4) {
    tmpDate.setMonth(0, 1 + (4 - tmpDate.getDay() + 7) % 7);
  }
  const weekNumber = (1 + Math.ceil((firstThursday - tmpDate.valueOf()) / 6048e5)).toString();
  if (weekNumber.length === 1) {
    return `0${weekNumber}`;
  } else {
    return weekNumber;
  }
};
const getDaysInMonth = (month, year) => {
  return new Date(year, month + 1, 0).getDate();
};
const ganttTable_Header = "_ganttTable_Header_7mmcq_1";
const ganttTable_HeaderSeparator = "_ganttTable_HeaderSeparator_7mmcq_8";
const ganttTable_HeaderContent = "_ganttTable_HeaderContent_7mmcq_15";
const ganttTable_HeaderTitle = "_ganttTable_HeaderTitle_7mmcq_21";
const ganttTable_HeaderItem = "_ganttTable_HeaderItem_7mmcq_25";
const resizer = "_resizer_7mmcq_38";
const styles$j = {
  ganttTable_Header,
  ganttTable_HeaderSeparator,
  ganttTable_HeaderContent,
  ganttTable_HeaderTitle,
  ganttTable_HeaderItem,
  resizer
};
const taskListHeaderAction = "_taskListHeaderAction_j1iwy_1";
const style$1 = {
  taskListHeaderAction
};
const TaskListHeaderActions = ({
  onCollapseAll,
  onExpandFirstLevel,
  onExpandAll,
  colors
}) => {
  let themeOptions = {
    palette: {
      primary: {
        main: colors.barLabelColor
        // Maps to a primary color (e.g., task bar background)
      },
      secondary: {
        main: colors.barLabelColor
        // Maps to a secondary color (e.g., task progress)
      },
      background: {
        default: colors.evenTaskBackgroundColor,
        // Background color for even tasks
        paper: colors.oddTaskBackgroundColor
        // Background color for odd tasks or paper elements
      },
      text: {
        primary: colors.barLabelColor,
        // Main text color (bar labels, etc.)
        secondary: colors.barLabelColor
        // Context menu text color
      }
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            color: colors.barLabelColor
            // Use the bar label color for button text
          }
        }
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: colors.contextMenuBgColor,
            // Tooltip background color
            color: colors.contextMenuTextColor
            // Tooltip text color
          }
        }
      },
      MuiSvgIcon: {
        styleOverrides: {
          root: {
            color: colors.barLabelColor,
            // Apply primary icon color to all icons
            "&.MuiSvgIcon-colorSecondary": {
              color: colors.barLabelWhenOutsideColor
              // Apply secondary color to icons
            }
          }
        }
      }
    }
  };
  const materialLightTheme = createTheme(themeOptions);
  return /* @__PURE__ */ jsx(ThemeProvider, { theme: materialLightTheme, children: /* @__PURE__ */ jsxs("div", { className: style$1.taskListHeaderAction, children: [
    /* @__PURE__ */ jsx(Tooltip$1, { title: "Collapse All", children: /* @__PURE__ */ jsx(IconButton, { onClick: onCollapseAll, children: /* @__PURE__ */ jsx(UnfoldLess, {}) }) }),
    /* @__PURE__ */ jsx(Tooltip$1, { title: "Expand First Level", children: /* @__PURE__ */ jsx(IconButton, { onClick: onExpandFirstLevel, children: /* @__PURE__ */ jsx(UnfoldMore, {}) }) }),
    /* @__PURE__ */ jsx(Tooltip$1, { title: "Expand All", children: /* @__PURE__ */ jsx(IconButton, { onClick: onExpandAll, children: /* @__PURE__ */ jsx(UnfoldMoreDouble, {}) }) })
  ] }) });
};
const TaskListHeaderDefaultInner = (props) => {
  const {
    headerHeight,
    fontFamily,
    fontSize,
    columns,
    canResizeColumns,
    onColumnResizeStart,
    onCollapseAll,
    onExpandFirstLevel,
    onExpandAll,
    colors
  } = props;
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: styles$j.ganttTable_Header,
      style: {
        height: headerHeight,
        fontFamily,
        fontSize
      },
      children: columns.map(({ title, width, canResize }, index2) => {
        return /* @__PURE__ */ jsxs(Fragment, { children: [
          index2 > 0 && /* @__PURE__ */ jsx(
            "div",
            {
              className: styles$j.ganttTable_HeaderSeparator,
              style: {
                height: headerHeight * 0.5,
                marginTop: headerHeight * 0.2
              }
            }
          ),
          /* @__PURE__ */ jsxs(
            "div",
            {
              "data-testid": `table-column-header-${title}`,
              className: styles$j.ganttTable_HeaderItem,
              style: {
                minWidth: width,
                maxWidth: width
              },
              children: [
                /* @__PURE__ */ jsxs("div", { className: styles$j.ganttTable_HeaderContent, children: [
                  /* @__PURE__ */ jsx("div", { className: styles$j.ganttTable_HeaderTitle, children: title }),
                  title === "Name" && /* @__PURE__ */ jsx(
                    TaskListHeaderActions,
                    {
                      onCollapseAll,
                      onExpandFirstLevel,
                      onExpandAll,
                      colors
                    }
                  )
                ] }),
                canResizeColumns && canResize !== false && /* @__PURE__ */ jsx(
                  "div",
                  {
                    "data-testid": `table-column-header-resize-handle-${title}`,
                    className: styles$j.resizer,
                    onMouseDown: (event) => {
                      onColumnResizeStart(index2, event.clientX);
                    },
                    onTouchStart: (event) => {
                      const firstTouch = event.touches[0];
                      if (firstTouch) {
                        onColumnResizeStart(index2, firstTouch.clientX);
                      }
                    }
                  }
                )
              ]
            }
          )
        ] }, index2);
      })
    }
  );
};
const TaskListHeaderDefault = memo(TaskListHeaderDefaultInner);
const checkHasChildren = (task, childTasksMap) => {
  const {
    id,
    comparisonLevel = 1
  } = task;
  const childIdsByLevel = childTasksMap.get(comparisonLevel);
  if (!childIdsByLevel) {
    return false;
  }
  const childs = childIdsByLevel.get(id);
  if (!childs) {
    return false;
  }
  return childs.length > 0;
};
const taskListTableRow = "_taskListTableRow_w35p0_1";
const taskListTableRowGrabbing = "_taskListTableRowGrabbing_w35p0_7";
const cut = "_cut_w35p0_11";
const taskListCell = "_taskListCell_w35p0_15";
const taskListCellInner = "_taskListCellInner_w35p0_24";
const dropAfter = "_dropAfter_w35p0_29";
const dropAfterLighten = "_dropAfterLighten_w35p0_41";
const dropBefore = "_dropBefore_w35p0_53";
const dropBeforeLighten = "_dropBeforeLighten_w35p0_64";
const styles$i = {
  taskListTableRow,
  taskListTableRowGrabbing,
  cut,
  taskListCell,
  taskListCellInner,
  dropAfter,
  dropAfterLighten,
  dropBefore,
  dropBeforeLighten
};
const TaskListTableRowInner = ({
  canMoveTasks,
  colors,
  columns,
  dateSetup,
  dependencyMap,
  depth,
  distances,
  fullRowHeight,
  getTaskCurrentState,
  handleAddTask,
  handleDeleteTasks,
  handleEditTask,
  handleMoveTaskBefore,
  handleMoveTaskAfter,
  handleMoveTasksInside,
  handleOpenContextMenu,
  hasChildren,
  icons = void 0,
  indexStr,
  isClosed,
  isCut,
  isEven,
  isSelected,
  isShowTaskNumbers,
  onClick,
  onExpanderClick,
  scrollToTask,
  selectTaskOnMouseDown,
  style: style2 = void 0,
  task,
  tasks,
  draggedTask,
  setDraggedTask
}) => {
  const { id, comparisonLevel = 1 } = task;
  const onRootMouseDown = useCallback(
    (event) => {
      if (event.button !== 0) {
        return;
      }
      if (task.type !== "empty") {
        scrollToTask(task);
      }
      selectTaskOnMouseDown(task.id, event);
      onClick(task);
    },
    [scrollToTask, selectTaskOnMouseDown, task]
  );
  const onContextMenu = useCallback(
    (event) => {
      event.preventDefault();
      handleOpenContextMenu(task, event.clientX, event.clientY);
    },
    [handleOpenContextMenu, task]
  );
  const isDraggedTaskAncestorOfDropTarget = (draggedItem) => {
    let idToTaskIndex = new Map(tasks.map((task2, index2) => [task2.id, index2]));
    let parentId = task.parent;
    const parentsId = [];
    while (parentId) {
      parentsId.push(parentId);
      parentId = tasks[idToTaskIndex.get(parentId)].parent;
    }
    return parentsId.includes(draggedItem.id);
  };
  const dependencies = useMemo(() => {
    const dependenciesAtLevel = dependencyMap.get(comparisonLevel);
    if (!dependenciesAtLevel) {
      return [];
    }
    const dependenciesByTask = dependenciesAtLevel.get(id);
    if (!dependenciesByTask) {
      return [];
    }
    return dependenciesByTask.map(({ source }) => source);
  }, [comparisonLevel, dependencyMap, id]);
  const columnData = useMemo(
    () => ({
      canMoveTasks,
      dateSetup,
      dependencies,
      depth,
      distances,
      handleDeleteTasks,
      handleAddTask,
      handleEditTask,
      hasChildren,
      icons,
      indexStr,
      isClosed,
      isShowTaskNumbers,
      onExpanderClick,
      task,
      //: task.type === "empty" ? task : getTaskCurrentState(task),
      colors
    }),
    [
      canMoveTasks,
      dateSetup,
      dependencies,
      depth,
      distances,
      getTaskCurrentState,
      handleDeleteTasks,
      handleAddTask,
      handleEditTask,
      hasChildren,
      icons,
      indexStr,
      isClosed,
      isShowTaskNumbers,
      onExpanderClick,
      task,
      colors
    ]
  );
  const dropPreviewOffset = distances.nestedTaskNameOffset * depth + distances.expandIconWidth;
  const [hoveringState, setHoveringState] = useState({
    hoveringBefore: false,
    hoveringInside: false,
    hoveringAfter: false
  });
  let backgroundColor = isSelected ? colors.selectedTaskBackgroundColor : isEven && !hoveringState.hoveringInside ? colors.evenTaskBackgroundColor : colors.oddTaskBackgroundColor;
  if (hoveringState.hoveringInside && !hoveringState.hoveringAfter && !hoveringState.hoveringBefore) {
    backgroundColor = colors.taskDragColor;
  }
  const handleDragStart = (event) => {
    setDraggedTask(task);
    event.dataTransfer.setData("draggedTask", task == null ? void 0 : task.id);
  };
  const handleDragOver = (event) => {
    event.preventDefault();
  };
  const handleDragEnd = () => {
    setDraggedTask(null);
  };
  const canDropBefore = () => {
    let canDropBefore2 = false;
    if (draggedTask) {
      const hoveringOnBrother = draggedTask.parent === task.parent && tasks.findIndex((t2) => t2.id === draggedTask.id) === tasks.findIndex((t2) => t2.id === task.id) - 1;
      if (!hoveringOnBrother && draggedTask.id !== task.id) {
        canDropBefore2 = !isDraggedTaskAncestorOfDropTarget(draggedTask);
      }
    }
    return canDropBefore2;
  };
  const dropBefore2 = () => {
    if (canDropBefore()) {
      handleMoveTaskBefore(task, draggedTask);
    }
    setHoveringState({
      hoveringBefore: false,
      hoveringInside: false,
      hoveringAfter: false
    });
  };
  const canDropAfter = () => {
    let canDropAfter2 = false;
    if (draggedTask) {
      const hoveringOnBrother = draggedTask.parent === task.parent && tasks.findIndex((t2) => t2.id === draggedTask.id) === tasks.findIndex((t2) => t2.id === task.id) + 1;
      if (!hoveringOnBrother && draggedTask.id !== task.id) {
        canDropAfter2 = !isDraggedTaskAncestorOfDropTarget(draggedTask);
      }
    }
    return canDropAfter2;
  };
  const dropAfter2 = () => {
    if (canDropAfter()) {
      handleMoveTaskAfter(task, draggedTask);
    }
    setHoveringState({
      hoveringBefore: false,
      hoveringInside: false,
      hoveringAfter: false
    });
  };
  const canDropInside = () => {
    let canDropInside2 = false;
    if (task.type !== "empty" && task.type !== "milestone") {
      if (draggedTask) {
        if (!isDraggedTaskAncestorOfDropTarget(draggedTask)) {
          canDropInside2 = draggedTask.id !== id || (draggedTask.comparisonLevel || 1) !== comparisonLevel;
        }
      }
    }
    return canDropInside2;
  };
  const dropInside = () => {
    if (canDropInside() && task.type !== "empty") {
      handleMoveTasksInside(task, [draggedTask]);
    }
    setHoveringState({
      hoveringBefore: false,
      hoveringInside: false,
      hoveringAfter: false
    });
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: `${styles$i.taskListTableRow} ${isCut ? styles$i.cut : ""}`,
      onMouseDown: onRootMouseDown,
      style: {
        height: fullRowHeight,
        backgroundColor,
        ...style2
      },
      onContextMenu,
      draggable: true,
      onDragStart: handleDragStart,
      onDragOver: handleDragOver,
      onDragEnd: handleDragEnd,
      children: [
        columns.map((column, index2) => {
          const { Cell, width } = column;
          return /* @__PURE__ */ jsx(
            "div",
            {
              className: styles$i.taskListCell,
              style: {
                minWidth: width,
                maxWidth: width
              },
              children: /* @__PURE__ */ jsx(
                "div",
                {
                  className: styles$i.taskListCellInner,
                  onDragEnter: () => {
                    setHoveringState({
                      hoveringBefore: false,
                      hoveringInside: canDropInside(),
                      hoveringAfter: false
                    });
                  },
                  onDragLeave: () => {
                    setHoveringState((prevState) => {
                      return { ...prevState, hoveringInside: false };
                    });
                  },
                  onDragOver: (event) => {
                    event.preventDefault();
                    event.dataTransfer.dropEffect = canDropInside() ? "move" : "none";
                  },
                  onDrop: dropInside,
                  style: {
                    height: Math.max(0, fullRowHeight - 2 * 8)
                  },
                  children: /* @__PURE__ */ jsx(
                    "div",
                    {
                      style: {
                        pointerEvents: hoveringState.hoveringInside ? "none" : "auto"
                      },
                      children: /* @__PURE__ */ jsx(Cell, { data: columnData })
                    }
                  )
                }
              )
            },
            index2
          );
        }),
        /* @__PURE__ */ jsx(
          "div",
          {
            "data-testid": `table-row-drop-before-${task.name}`,
            className: `${styles$i.dropBefore} ${hoveringState.hoveringBefore ? styles$i.dropBeforeLighten : ""}`,
            style: {
              left: dropPreviewOffset,
              backgroundColor: hoveringState.hoveringBefore ? colors.taskDragColor : void 0,
              color: hoveringState.hoveringBefore ? colors.taskDragColor : void 0
            },
            onDragEnter: (event) => {
              event.preventDefault();
              setHoveringState({
                hoveringBefore: canDropBefore(),
                hoveringInside: false,
                hoveringAfter: false
              });
            },
            onDragLeave: () => {
              setHoveringState((prevState) => {
                return { ...prevState, hoveringBefore: false };
              });
            },
            onDragOver: (event) => {
              event.preventDefault();
              event.dataTransfer.dropEffect = canDropBefore() ? "move" : "none";
            },
            onDrop: dropBefore2
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            "data-testid": `table-row-drop-after-${task.name}`,
            className: `${styles$i.dropAfter} ${hoveringState.hoveringAfter ? styles$i.dropBeforeLighten : ""}`,
            style: {
              left: dropPreviewOffset,
              backgroundColor: hoveringState.hoveringAfter ? colors.taskDragColor : void 0,
              color: hoveringState.hoveringAfter ? colors.taskDragColor : void 0
            },
            onDragEnter: () => setHoveringState({
              hoveringBefore: false,
              hoveringInside: false,
              hoveringAfter: canDropAfter()
            }),
            onDragLeave: () => setHoveringState((prevState) => {
              return { ...prevState, hoveringAfter: false };
            }),
            onDragOver: (event) => {
              event.preventDefault();
              event.dataTransfer.dropEffect = canDropAfter() ? "move" : "none";
            },
            onDrop: dropAfter2
          }
        )
      ]
    }
  );
};
const TaskListTableRow = memo(TaskListTableRowInner);
const taskListWrapper = "_taskListWrapper_yx1w7_1";
const styles$h = {
  taskListWrapper
};
const TaskListTableDefaultInner = ({
  canMoveTasks,
  childTasksMap,
  colors,
  columns,
  cutIdsMirror,
  dateSetup,
  dependencyMap,
  distances,
  fontFamily,
  fontSize,
  fullRowHeight,
  getTaskCurrentState,
  handleAddTask,
  handleDeleteTasks,
  handleEditTask,
  handleMoveTaskBefore,
  handleMoveTaskAfter,
  handleMoveTasksInside,
  handleOpenContextMenu,
  icons,
  isShowTaskNumbers,
  mapTaskToNestedIndex,
  onClick,
  onExpanderClick,
  renderedIndexes,
  scrollToTask,
  selectTaskOnMouseDown,
  selectedIdsMirror,
  tasks
}) => {
  const renderedTasks = useMemo(
    /**
     * TO DO: maybe consider tasks on other levels?
     */
    () => tasks.filter((task) => !task.comparisonLevel || task.comparisonLevel === 1),
    [tasks]
  );
  const [draggedTask, setDraggedTask] = useState(null);
  const renderedListWithOffset = useMemo(() => {
    if (!renderedIndexes) {
      return null;
    }
    const [start, end] = renderedIndexes;
    const renderedList = [];
    for (let index2 = start; index2 <= end; ++index2) {
      const task = renderedTasks[index2];
      if (!task) {
        break;
      }
      const { id, comparisonLevel = 1 } = task;
      const indexesOnLevel = mapTaskToNestedIndex.get(comparisonLevel);
      if (!indexesOnLevel) {
        throw new Error(`Indexes are not found for level ${comparisonLevel}`);
      }
      const taskIndex = indexesOnLevel.get(id);
      if (!taskIndex) {
        throw new Error(`Index is not found for task ${id}`);
      }
      const [depth, indexStr] = taskIndex;
      renderedList.push(
        /* @__PURE__ */ jsx(
          TaskListTableRow,
          {
            canMoveTasks,
            colors,
            columns,
            dateSetup,
            dependencyMap,
            depth,
            distances,
            fullRowHeight,
            getTaskCurrentState,
            handleAddTask,
            handleDeleteTasks,
            handleEditTask,
            handleMoveTaskBefore,
            handleMoveTaskAfter,
            handleMoveTasksInside,
            handleOpenContextMenu,
            hasChildren: checkHasChildren(task, childTasksMap),
            icons,
            indexStr,
            isClosed: Boolean(task == null ? void 0 : task.hideChildren),
            isCut: cutIdsMirror[id],
            isEven: index2 % 2 === 1,
            isSelected: selectedIdsMirror[id],
            isShowTaskNumbers,
            onClick,
            onExpanderClick,
            scrollToTask,
            selectTaskOnMouseDown,
            task,
            tasks,
            draggedTask,
            setDraggedTask
          },
          id
        )
      );
    }
    return /* @__PURE__ */ jsxs(Fragment$1, { children: [
      /* @__PURE__ */ jsx(
        "div",
        {
          style: {
            height: fullRowHeight * start
          }
        }
      ),
      renderedList
    ] });
  }, [
    colors,
    columns,
    cutIdsMirror,
    fullRowHeight,
    getTaskCurrentState,
    renderedIndexes,
    renderedTasks,
    selectTaskOnMouseDown,
    selectedIdsMirror,
    draggedTask
  ]);
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: styles$h.taskListWrapper,
      style: {
        fontFamily,
        fontSize
      },
      children: renderedListWithOffset
    }
  );
};
const TaskListTableDefault = memo(TaskListTableDefaultInner);
const tooltipDefaultContainer = "_tooltipDefaultContainer_juje4_1";
const tooltipDefaultContainerParagraph = "_tooltipDefaultContainerParagraph_juje4_7";
const tooltipDetailsContainer = "_tooltipDetailsContainer_juje4_13";
const tooltipDetailsContainerHidden = "_tooltipDetailsContainerHidden_juje4_25";
const styles$g = {
  tooltipDefaultContainer,
  tooltipDefaultContainerParagraph,
  tooltipDetailsContainer,
  tooltipDetailsContainerHidden
};
const Tooltip = ({
  tooltipX,
  tooltipY,
  tooltipStrategy,
  setFloatingRef,
  getFloatingProps,
  task,
  fontSize,
  fontFamily,
  TooltipContent
}) => {
  return /* @__PURE__ */ jsx(
    "div",
    {
      ref: setFloatingRef,
      style: {
        position: tooltipStrategy,
        top: tooltipY ?? 0,
        left: tooltipX ?? 0,
        width: "max-content"
      },
      ...getFloatingProps(),
      children: /* @__PURE__ */ jsx(TooltipContent, { task, fontSize, fontFamily })
    }
  );
};
const StandardTooltipContent = ({ task, fontSize, fontFamily }) => {
  const style2 = {
    fontSize,
    fontFamily
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: styles$g.tooltipDefaultContainer,
      style: style2,
      children: [
        /* @__PURE__ */ jsx("b", { style: { fontSize: fontSize + 6 }, children: `${task.name}: ${task.start.getDate()}-${task.start.getMonth() + 1}-${task.start.getFullYear()} - ${task.end.getDate()}-${task.end.getMonth() + 1}-${task.end.getFullYear()}` }),
        task.end.getTime() - task.start.getTime() !== 0 && /* @__PURE__ */ jsx("p", { className: styles$g.tooltipDefaultContainerParagraph, children: `Duration: ${~~((task.end.getTime() - task.start.getTime()) / (1e3 * 60 * 60 * 24))} day(s)` }),
        /* @__PURE__ */ jsx("p", { className: styles$g.tooltipDefaultContainerParagraph, children: !!task.progress && `Progress: ${task.progress} %` })
      ]
    }
  );
};
const DELTA = 5;
const getStartAndEnd = (containerEl, property, cellSize) => {
  if (!containerEl) {
    return null;
  }
  const scrollValue = containerEl[property];
  const maxScrollValue = property === "scrollLeft" ? containerEl.scrollWidth : containerEl.scrollHeight;
  const fullValue = property === "scrollLeft" ? containerEl.clientWidth : containerEl.clientHeight;
  const firstIndex = Math.floor(scrollValue / cellSize);
  const lastIndex = Math.ceil((scrollValue + fullValue) / cellSize) - 1;
  const isStartOfScroll = scrollValue < DELTA;
  const isEndOfScroll = scrollValue + fullValue > maxScrollValue - DELTA;
  return [
    firstIndex,
    lastIndex,
    isStartOfScroll,
    isEndOfScroll,
    fullValue
  ];
};
const useOptimizedList = (containerRef, property, cellSize) => {
  const [indexes, setIndexes] = useState(
    () => getStartAndEnd(containerRef.current, property, cellSize)
  );
  useEffect(() => {
    let rafId = null;
    let prevIndexes = indexes;
    const handler = () => {
      const nextIndexes = getStartAndEnd(containerRef.current, property, cellSize);
      const isChanged = prevIndexes ? nextIndexes ? nextIndexes.some((value, index2) => !prevIndexes || prevIndexes[index2] !== value) : true : Boolean(nextIndexes);
      if (isChanged) {
        prevIndexes = nextIndexes;
        setIndexes(nextIndexes);
      }
      rafId = requestAnimationFrame(handler);
    };
    rafId = requestAnimationFrame(handler);
    return () => {
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
      }
    };
  }, [
    containerRef,
    cellSize
  ]);
  return indexes;
};
const ganttTableRoot = "_ganttTableRoot_v4xjz_1";
const ganttTableWrapper = "_ganttTableWrapper_v4xjz_8";
const taskListResizer = "_taskListResizer_v4xjz_40";
const taskListContent = "_taskListContent_v4xjz_64";
const hidden = "_hidden_v4xjz_74";
const styles$f = {
  ganttTableRoot,
  ganttTableWrapper,
  taskListResizer,
  taskListContent,
  hidden
};
const button$2 = "_button_ts3e8_1";
const styles$e = {
  button: button$2
};
const AddColumn = (props) => {
  const {
    data: { handleAddTask, icons, colors, task }
  } = props;
  const onClick = useCallback(() => {
    if (task.type === "empty") {
      return;
    }
    handleAddTask(task);
  }, [task, handleAddTask]);
  if (task.type === "empty" || task.type === "milestone") {
    return null;
  }
  return /* @__PURE__ */ jsx("button", { type: "button", onClick, style: {
    "color": colors.barLabelColor
  }, className: styles$e.button, children: (icons == null ? void 0 : icons.renderAddIcon) ? icons.renderAddIcon(task) : "+" });
};
const taskListNameWrapper = "_taskListNameWrapper_x4oe5_1";
const dragging = "_dragging_x4oe5_6";
const taskListExpander = "_taskListExpander_x4oe5_10";
const taskListEmptyExpander = "_taskListEmptyExpander_x4oe5_18";
const taskName = "_taskName_x4oe5_23";
const styles$d = {
  taskListNameWrapper,
  dragging,
  taskListExpander,
  taskListEmptyExpander,
  taskName
};
const getExpanderSymbol = (task, hasChildren, isClosed, icons) => {
  if (!hasChildren) {
    return (icons == null ? void 0 : icons.renderNoChildrenIcon) ? icons.renderNoChildrenIcon(task) : "";
  }
  if (isClosed) {
    return (icons == null ? void 0 : icons.renderClosedIcon) ? icons.renderClosedIcon(task) : "⊞";
  }
  return (icons == null ? void 0 : icons.renderOpenedIcon) ? icons.renderOpenedIcon(task) : "⊟";
};
const TitleColumn = (props) => {
  const {
    data: {
      colors,
      distances: { expandIconWidth, nestedTaskNameOffset },
      icons,
      isShowTaskNumbers,
      hasChildren,
      isClosed,
      depth,
      indexStr,
      task,
      onExpanderClick
    }
  } = props;
  const { name } = task;
  const expanderSymbol = getExpanderSymbol(task, hasChildren, isClosed, icons);
  const title = isShowTaskNumbers ? `${indexStr} ${name}` : name;
  const onClick = useCallback(() => {
    if (task.type !== "empty") {
      onExpanderClick(task);
    }
  }, [onExpanderClick, task]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      "data-testid": `title-table-cell-${name}`,
      className: `${styles$d.taskListNameWrapper}`,
      style: {
        paddingLeft: depth * nestedTaskNameOffset
      },
      title,
      children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            className: `${styles$d.taskListExpander} ${!hasChildren ? styles$d.taskListEmptyExpander : ""}`,
            onClick,
            style: {
              width: expandIconWidth
            },
            children: expanderSymbol
          }
        ),
        /* @__PURE__ */ jsxs("div", { style: {
          color: colors.barLabelColor
        }, className: styles$d.taskName, children: [
          isShowTaskNumbers && /* @__PURE__ */ jsxs("b", { children: [
            indexStr,
            " "
          ] }),
          name
        ] })
      ]
    }
  );
};
function _typeof$2(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$2 = function _typeof2(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof$2 = function _typeof2(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof$2(obj);
}
function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || _typeof$2(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== "number") {
    return false;
  }
  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}
var MILLISECONDS_IN_DAY = 864e5;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = /* @__PURE__ */ new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}
var MILLISECONDS_IN_WEEK$1 = 6048e5;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}
function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var firstWeekOfNextYear = /* @__PURE__ */ new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = /* @__PURE__ */ new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = /* @__PURE__ */ new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}
var MILLISECONDS_IN_WEEK = 6048e5;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? "-" : "";
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = "0" + output;
  }
  return sign + output;
}
var formatters$2 = {
  // Year
  y: function y(date, token) {
    var signedYear = date.getUTCFullYear();
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
const formatters$3 = formatters$2;
var dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
var formatters = {
  // Era
  G: function G(date, token, localize2) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      case "G":
      case "GG":
      case "GGG":
        return localize2.era(era, {
          width: "abbreviated"
        });
      case "GGGGG":
        return localize2.era(era, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return localize2.era(era, {
          width: "wide"
        });
    }
  },
  // Year
  y: function y2(date, token, localize2) {
    if (token === "yo") {
      var signedYear = date.getUTCFullYear();
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize2.ordinalNumber(year, {
        unit: "year"
      });
    }
    return formatters$3.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize2, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token === "YY") {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token === "Yo") {
      return localize2.ordinalNumber(weekYear, {
        unit: "year"
      });
    }
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize2) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      case "Q":
        return String(quarter);
      case "QQ":
        return addLeadingZeros(quarter, 2);
      case "Qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "QQQ":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize2) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      case "q":
        return String(quarter);
      case "qq":
        return addLeadingZeros(quarter, 2);
      case "qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "qqq":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function M2(date, token, localize2) {
    var month = date.getUTCMonth();
    switch (token) {
      case "M":
      case "MM":
        return formatters$3.M(date, token);
      case "Mo":
        return localize2.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "MMM":
        return localize2.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return localize2.month(month, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return localize2.month(month, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize2) {
    var month = date.getUTCMonth();
    switch (token) {
      case "L":
        return String(month + 1);
      case "LL":
        return addLeadingZeros(month + 1, 2);
      case "Lo":
        return localize2.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "LLL":
        return localize2.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return localize2.month(month, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return localize2.month(month, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize2, options) {
    var week = getUTCWeek(date, options);
    if (token === "wo") {
      return localize2.ordinalNumber(week, {
        unit: "week"
      });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize2) {
    var isoWeek = getUTCISOWeek(date);
    if (token === "Io") {
      return localize2.ordinalNumber(isoWeek, {
        unit: "week"
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d2(date, token, localize2) {
    if (token === "do") {
      return localize2.ordinalNumber(date.getUTCDate(), {
        unit: "date"
      });
    }
    return formatters$3.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize2) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === "Do") {
      return localize2.ordinalNumber(dayOfYear, {
        unit: "dayOfYear"
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize2) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      case "E":
      case "EE":
      case "EEE":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize2, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "e":
        return String(localDayOfWeek);
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      case "eo":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "eee":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize2, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "c":
        return String(localDayOfWeek);
      case "cc":
        return addLeadingZeros(localDayOfWeek, token.length);
      case "co":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "ccc":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize2) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      case "i":
        return String(isoDayOfWeek);
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token.length);
      case "io":
        return localize2.ordinalNumber(isoDayOfWeek, {
          unit: "day"
        });
      case "iii":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function a2(date, token, localize2) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize2) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }
    switch (token) {
      case "b":
      case "bb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize2) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function h2(date, token, localize2) {
    if (token === "ho") {
      var hours = date.getUTCHours() % 12;
      if (hours === 0)
        hours = 12;
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return formatters$3.h(date, token);
  },
  // Hour [0-23]
  H: function H2(date, token, localize2) {
    if (token === "Ho") {
      return localize2.ordinalNumber(date.getUTCHours(), {
        unit: "hour"
      });
    }
    return formatters$3.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize2) {
    var hours = date.getUTCHours() % 12;
    if (token === "Ko") {
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize2) {
    var hours = date.getUTCHours();
    if (hours === 0)
      hours = 24;
    if (token === "ko") {
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m2(date, token, localize2) {
    if (token === "mo") {
      return localize2.ordinalNumber(date.getUTCMinutes(), {
        unit: "minute"
      });
    }
    return formatters$3.m(date, token);
  },
  // Second
  s: function s2(date, token, localize2) {
    if (token === "so") {
      return localize2.ordinalNumber(date.getUTCSeconds(), {
        unit: "second"
      });
    }
    return formatters$3.s(date, token);
  },
  // Fraction of second
  S: function S2(date, token) {
    return formatters$3.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token) {
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "XXXX":
      case "XX":
        return formatTimezone(timezoneOffset);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "xxxx":
      case "xx":
        return formatTimezone(timezoneOffset);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1e3);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset2, dirtyDelimiter) {
  var sign = offset2 > 0 ? "-" : "+";
  var absOffset = Math.abs(offset2);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || "";
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset2, dirtyDelimiter) {
  if (offset2 % 60 === 0) {
    var sign = offset2 > 0 ? "-" : "+";
    return sign + addLeadingZeros(Math.abs(offset2) / 60, 2);
  }
  return formatTimezone(offset2, dirtyDelimiter);
}
function formatTimezone(offset2, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || "";
  var sign = offset2 > 0 ? "-" : "+";
  var absOffset = Math.abs(offset2);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
const formatters$1 = formatters;
var dateLongFormatter = function dateLongFormatter2(pattern, formatLong2) {
  switch (pattern) {
    case "P":
      return formatLong2.date({
        width: "short"
      });
    case "PP":
      return formatLong2.date({
        width: "medium"
      });
    case "PPP":
      return formatLong2.date({
        width: "long"
      });
    case "PPPP":
    default:
      return formatLong2.date({
        width: "full"
      });
  }
};
var timeLongFormatter = function timeLongFormatter2(pattern, formatLong2) {
  switch (pattern) {
    case "p":
      return formatLong2.time({
        width: "short"
      });
    case "pp":
      return formatLong2.time({
        width: "medium"
      });
    case "ppp":
      return formatLong2.time({
        width: "long"
      });
    case "pppp":
    default:
      return formatLong2.time({
        width: "full"
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter2(pattern, formatLong2) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong2);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong2.dateTime({
        width: "short"
      });
      break;
    case "PP":
      dateTimeFormat = formatLong2.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      dateTimeFormat = formatLong2.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong2.dateTime({
        width: "full"
      });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter(timePattern, formatLong2));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
const longFormatters$1 = longFormatters;
var protectedDayOfYearTokens = ["D", "DD"];
var protectedWeekYearTokens = ["YY", "YYYY"];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format2, input) {
  if (token === "YYYY") {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === "YY") {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === "D") {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === "DD") {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions2 = getDefaultOptions();
  var locale2 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref !== void 0 ? _ref : enDateLocale;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions2.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions2.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions2.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  if (!locale2.localize) {
    throw new RangeError("locale must contain localize property");
  }
  if (!locale2.formatLong) {
    throw new RangeError("locale must contain formatLong property");
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale2,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale2.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp).map(function(substring) {
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = formatters$1[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale2.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return substring;
  }).join("");
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}
const DateStartColumn = ({
  data: {
    dateSetup: {
      dateFormats: dateFormats2,
      dateLocale
    },
    colors,
    task
  }
}) => {
  if (task.type === "empty") {
    return null;
  }
  try {
    return /* @__PURE__ */ jsx("div", { style: {
      "color": colors.barLabelColor
    }, children: format(task.start, dateFormats2.dateColumnFormat, {
      locale: dateLocale
    }) });
  } catch (e2) {
    return /* @__PURE__ */ jsx("div", { style: {
      "color": colors.barLabelColor
    }, children: task.start.toString() });
  }
};
const DateEndColumn = ({
  data: {
    dateSetup: {
      dateFormats: dateFormats2,
      dateLocale
    },
    colors,
    task
  }
}) => {
  if (task.type === "empty") {
    return null;
  }
  try {
    return /* @__PURE__ */ jsx("div", { style: {
      "color": colors.barLabelColor
    }, children: format(task.end, dateFormats2.dateColumnFormat, {
      locale: dateLocale
    }) });
  } catch (e2) {
    return /* @__PURE__ */ jsx("div", { style: {
      "color": colors.barLabelColor
    }, children: task.end.toString() });
  }
};
const DependenciesColumn = ({
  data: {
    dependencies,
    colors
  }
}) => {
  return /* @__PURE__ */ jsx("div", { style: {
    "color": colors.barLabelColor
  }, children: dependencies.map(({ name }) => name).join(", ") });
};
const button$1 = "_button_ts3e8_1";
const styles$c = {
  button: button$1
};
const DeleteColumn = (props) => {
  const {
    data: { handleDeleteTasks, icons, colors, task }
  } = props;
  const onClick = useCallback(() => {
    handleDeleteTasks([task]);
  }, [task, handleDeleteTasks]);
  return /* @__PURE__ */ jsx("button", { type: "button", onClick, style: {
    "color": colors.barLabelColor
  }, className: styles$c.button, children: (icons == null ? void 0 : icons.renderDeleteIcon) ? icons.renderDeleteIcon(task) : "-" });
};
const button = "_button_5sg45_1";
const styles$b = {
  button
};
const EditColumn = (props) => {
  const {
    data: { handleEditTask, icons, colors, task }
  } = props;
  const onClick = useCallback(() => {
    handleEditTask(task);
  }, [task, handleEditTask]);
  return /* @__PURE__ */ jsx("button", { type: "button", onClick, style: {
    "color": colors.barLabelColor
  }, className: styles$b.button, children: (icons == null ? void 0 : icons.renderEditIcon) ? icons.renderEditIcon(task) : "✎" });
};
const useTableListResize = (columnsProp, distances, onResizeColumn) => {
  const [columnsState, setColumns] = useState(() => {
    if (columnsProp) {
      return [...columnsProp];
    }
    const {
      titleCellWidth,
      dateCellWidth,
      dependenciesCellWidth,
      actionColumnWidth
    } = distances;
    return [
      {
        id: "TitleColumn",
        Cell: TitleColumn,
        width: titleCellWidth,
        title: "Name"
      },
      {
        id: "DateStartColumn",
        Cell: DateStartColumn,
        width: dateCellWidth,
        title: "From"
      },
      {
        id: "DateEndColumn",
        Cell: DateEndColumn,
        width: dateCellWidth,
        title: "To"
      },
      {
        id: "DependenciesColumn",
        Cell: DependenciesColumn,
        width: dependenciesCellWidth,
        title: "Dependencies"
      },
      {
        id: "DeleteColumn",
        Cell: DeleteColumn,
        width: actionColumnWidth,
        canResize: false
      },
      {
        id: "EditColumn",
        Cell: EditColumn,
        width: actionColumnWidth,
        canResize: false
      },
      {
        id: "AddColumn",
        Cell: AddColumn,
        width: actionColumnWidth,
        canResize: false
      }
    ];
  });
  useEffect(() => {
    if (columnsProp) {
      setColumns([...columnsProp]);
      const currentColumnIds = columnsState.map((col) => col.id);
      const newColumnIds = columnsProp.map((col) => col.id);
      const widthOfAddedColumns = columnsProp.filter((col) => !currentColumnIds.includes(col.id)).reduce((res, { width }) => res + width, 0);
      const widthOfRemovedColumns = columnsState.filter((col) => !newColumnIds.includes(col.id)).reduce((res, { width }) => res + width, 0);
      setTableWidth(
        (prev) => Math.min(
          prev + widthOfAddedColumns - widthOfRemovedColumns,
          columnsProp.reduce((res, { width }) => res + width, 0)
        )
      );
    }
  }, [columnsProp]);
  const [tableResizeEvent, setTableResizeEvent] = useState(null);
  const [columnResizeEvent, setColumnResizeEvent] = useState(null);
  const [tableWidthState, setTableWidth] = useState(
    () => columnsState.reduce((res, { width }) => res + width, 0)
  );
  const onTableResizeStart = (clientX) => {
    const newTableResizeEvent = {
      initialClientX: clientX,
      initialTableWidth: tableWidthState
    };
    setTableResizeEvent(newTableResizeEvent);
  };
  const onColumnResizeStart = (columnIndex, clientX) => {
    setColumnResizeEvent({
      columnIndex,
      startX: clientX,
      endX: clientX,
      initialColumnWidth: columnsState[columnIndex].width,
      initialTableWidth: tableWidthState
    });
  };
  const isResizeTableInProgress = Boolean(tableResizeEvent);
  const isResizeColumnInProgress = Boolean(columnResizeEvent);
  const taskListWidth = columnsState.reduce((res, { width }) => res + width, 0);
  useEffect(() => {
    if (!isResizeTableInProgress) {
      return void 0;
    }
    const handleMove = (clientX) => {
      const moveDelta = clientX - tableResizeEvent.initialClientX;
      setTableWidth(() => {
        return Math.min(
          Math.max(tableResizeEvent.initialTableWidth + moveDelta, 50),
          taskListWidth
        );
      });
    };
    const handleMouseMove = (event) => {
      handleMove(event.clientX);
    };
    const handleTouchMove = (event) => {
      const firstTouch = event.touches[0];
      if (firstTouch) {
        handleMove(firstTouch.clientX);
      }
    };
    const handleUp = () => {
      setTableResizeEvent(null);
    };
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("touchmove", handleTouchMove);
    document.addEventListener("mouseup", handleUp);
    document.addEventListener("touchend", handleUp);
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("touchmove", handleTouchMove);
      document.removeEventListener("mouseup", handleUp);
      document.removeEventListener("touchend", handleUp);
    };
  }, [isResizeTableInProgress, tableWidthState, tableResizeEvent]);
  useEffect(() => {
    if (!isResizeColumnInProgress) {
      return void 0;
    }
    const handleMove = (clientX) => {
      const moveDelta = clientX - columnResizeEvent.startX;
      const newColumnwidth = Math.max(
        10,
        columnResizeEvent.initialColumnWidth + moveDelta
      );
      let previousColumnWidth = null;
      setColumns((prevColumns) => {
        const newColumns = prevColumns.map((column, index2) => {
          if (index2 === columnResizeEvent.columnIndex) {
            previousColumnWidth = column.width;
            return { ...column, width: newColumnwidth };
          }
          return column;
        });
        return newColumns;
      });
      if (previousColumnWidth !== newColumnwidth) {
        setTableWidth(
          () => Math.min(
            Math.max(columnResizeEvent.initialTableWidth + moveDelta, 50),
            taskListWidth
          )
        );
      }
    };
    const handleMouseMove = (event) => {
      handleMove(event.clientX);
    };
    const handleTouchMove = (event) => {
      const firstTouch = event.touches[0];
      if (firstTouch) {
        handleMove(firstTouch.clientX);
      }
    };
    const handleUp = () => {
      if (onResizeColumn) {
        onResizeColumn(
          columnsState,
          columnResizeEvent.columnIndex,
          columnsState[columnResizeEvent.columnIndex].width - columnResizeEvent.initialColumnWidth
        );
      }
      setColumnResizeEvent(null);
    };
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("touchmove", handleTouchMove);
    document.addEventListener("mouseup", handleUp);
    document.addEventListener("touchend", handleUp);
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("touchmove", handleTouchMove);
      document.removeEventListener("mouseup", handleUp);
      document.removeEventListener("touchend", handleUp);
    };
  }, [isResizeColumnInProgress, columnResizeEvent, columnsState]);
  return [
    columnsState,
    taskListWidth,
    tableWidthState,
    onTableResizeStart,
    onColumnResizeStart
  ];
};
const TaskListInner = ({
  canMoveTasks,
  canResizeColumns,
  childTasksMap,
  colors,
  columnsProp,
  cutIdsMirror,
  dateSetup,
  dependencyMap,
  distances,
  fontFamily,
  fontSize,
  fullRowHeight,
  ganttFullHeight,
  getTaskCurrentState,
  handleAddTask,
  handleDeleteTasks,
  handleEditTask,
  handleMoveTaskBefore,
  handleMoveTaskAfter,
  handleMoveTasksInside,
  handleOpenContextMenu,
  icons = void 0,
  isShowTaskNumbers,
  mapTaskToNestedIndex,
  onExpanderClick,
  onClick,
  scrollToTask,
  selectTaskOnMouseDown,
  selectedIdsMirror,
  taskListContentRef,
  taskListRef,
  tasks,
  TaskListHeader,
  TaskListTable,
  onResizeColumn,
  onScrollTableListContentVertically,
  onCollapseAll,
  onExpandFirstLevel,
  onExpandAll
}) => {
  const [
    columns,
    taskListWidth,
    tableWidth,
    onTableResizeStart,
    onColumnResizeStart
  ] = useTableListResize(columnsProp, distances, onResizeColumn);
  const renderedIndexes = useOptimizedList(
    taskListContentRef,
    "scrollTop",
    fullRowHeight
  );
  return /* @__PURE__ */ jsxs("div", { className: styles$f.ganttTableRoot, ref: taskListRef, children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: styles$f.ganttTableWrapper,
        style: {
          width: tableWidth
        },
        children: [
          /* @__PURE__ */ jsx(
            TaskListHeader,
            {
              headerHeight: distances.headerHeight,
              fontFamily,
              fontSize,
              columns,
              onColumnResizeStart,
              canResizeColumns,
              onCollapseAll,
              onExpandFirstLevel,
              onExpandAll,
              colors
            }
          ),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: styles$f.taskListContent,
              ref: taskListContentRef,
              onScroll: onScrollTableListContentVertically,
              children: /* @__PURE__ */ jsx(
                "div",
                {
                  style: {
                    height: Math.max(
                      ganttFullHeight,
                      distances.minimumRowDisplayed * distances.rowHeight
                    ),
                    backgroundSize: `100% ${fullRowHeight * 2}px`,
                    backgroundImage: `linear-gradient(to bottom, transparent ${fullRowHeight}px, #f5f5f5 ${fullRowHeight}px)`,
                    overflow: "hidden"
                  },
                  children: /* @__PURE__ */ jsx(
                    TaskListTable,
                    {
                      canMoveTasks,
                      childTasksMap,
                      colors,
                      columns,
                      cutIdsMirror,
                      dateSetup,
                      dependencyMap,
                      distances,
                      fontFamily,
                      fontSize,
                      fullRowHeight,
                      ganttFullHeight,
                      getTaskCurrentState,
                      handleAddTask,
                      handleDeleteTasks,
                      handleEditTask,
                      handleMoveTaskBefore,
                      handleMoveTaskAfter,
                      handleMoveTasksInside,
                      handleOpenContextMenu,
                      icons,
                      isShowTaskNumbers,
                      mapTaskToNestedIndex,
                      onClick,
                      onExpanderClick,
                      renderedIndexes,
                      scrollToTask,
                      selectTaskOnMouseDown,
                      selectedIdsMirror,
                      taskListWidth,
                      tasks
                    }
                  )
                }
              )
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      "div",
      {
        className: styles$f.taskListResizer,
        onMouseDown: (event) => {
          onTableResizeStart(event.clientX);
        },
        onTouchStart: (event) => {
          const firstTouch = event.touches[0];
          if (firstTouch) {
            onTableResizeStart(firstTouch.clientX);
          }
        }
      }
    )
  ] });
};
const TaskList = memo(TaskListInner);
const GridBodyInner = ({
  additionalLeftSpace,
  columnWidth,
  ganttFullHeight,
  isUnknownDates,
  todayColor,
  rtl,
  startDate,
  viewMode
}) => {
  const today = useMemo(() => {
    if (isUnknownDates) {
      return null;
    }
    const todayIndex = getDatesDiff(/* @__PURE__ */ new Date(), startDate, viewMode);
    const tickX = todayIndex * columnWidth;
    const x3 = rtl ? tickX + columnWidth : tickX;
    return /* @__PURE__ */ jsx(
      "rect",
      {
        x: additionalLeftSpace + x3,
        y: 0,
        width: columnWidth,
        height: ganttFullHeight,
        fill: todayColor
      }
    );
  }, [
    additionalLeftSpace,
    columnWidth,
    ganttFullHeight,
    isUnknownDates,
    rtl,
    startDate,
    todayColor,
    viewMode
  ]);
  return /* @__PURE__ */ jsx("g", { className: "gridBody", children: /* @__PURE__ */ jsx("g", { className: "today", children: today }) });
};
const GridBody = memo(GridBodyInner);
function isWeekend(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var day = date.getDay();
  return day === 0 || day === 6;
}
function startOfISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  return startOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}
function addQuarters(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  var months = amount * 3;
  return addMonths(dirtyDate, months);
}
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$1 = function _typeof2(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof$1 = function _typeof2(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof$1(obj);
}
function max$1(dirtyDatesArray) {
  requiredArgs(1, arguments);
  var datesArray;
  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") {
    datesArray = dirtyDatesArray;
  } else if (_typeof$1(dirtyDatesArray) === "object" && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    return /* @__PURE__ */ new Date(NaN);
  }
  var result;
  datesArray.forEach(function(dirtyDate) {
    var currentDate = toDate(dirtyDate);
    if (result === void 0 || result < currentDate || isNaN(Number(currentDate))) {
      result = currentDate;
    }
  });
  return result || /* @__PURE__ */ new Date(NaN);
}
function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof2(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof = function _typeof2(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof(obj);
}
function min$1(dirtyDatesArray) {
  requiredArgs(1, arguments);
  var datesArray;
  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") {
    datesArray = dirtyDatesArray;
  } else if (_typeof(dirtyDatesArray) === "object" && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    return /* @__PURE__ */ new Date(NaN);
  }
  var result;
  datesArray.forEach(function(dirtyDate) {
    var currentDate = toDate(dirtyDate);
    if (result === void 0 || result > currentDate || isNaN(currentDate.getDate())) {
      result = currentDate;
    }
  });
  return result || /* @__PURE__ */ new Date(NaN);
}
function differenceInMinutes(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInMinute;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
function endOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  date.setFullYear(year + 1, 0, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}
function endOfHour(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setMinutes(59, 59, 999);
  return date;
}
function endOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}
function endOfISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  return endOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}
function endOfQuarter(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3 + 3;
  date.setMonth(month, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}
function subQuarters(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addQuarters(dirtyDate, -amount);
}
const Grid = (props) => {
  const {
    viewMode,
    isUnknownDates,
    startColumnIndex,
    endColumnIndex,
    additionalLeftSpace,
    columnWidth,
    getDate,
    checkIsHoliday,
    holidayBackgroundColor,
    minTaskDate
  } = props;
  const viewModesForDetectHolidays2 = /* @__PURE__ */ new Set([
    ViewMode.Day,
    ViewMode.HalfDay,
    ViewMode.QuarterDay,
    ViewMode.Hour
  ]);
  const displayHoliday = (date, minTaskDate2) => {
    if (isUnknownDates) {
      const daysDiff = differenceInDays(date, minTaskDate2);
      const rest = daysDiff % 7;
      if (daysDiff >= 0) {
        return rest === 5 || rest === 6;
      }
      return rest === -1 || rest === -2;
    }
    return checkIsHoliday(date, "startOfTask");
  };
  const renderedHolidays = useMemo(() => {
    const res = [];
    if (viewModesForDetectHolidays2.has(viewMode)) {
      for (let i2 = startColumnIndex; i2 <= endColumnIndex; ++i2) {
        const date = getDate(i2);
        if (displayHoliday(date, minTaskDate)) {
          res.push(
            /* @__PURE__ */ jsx(
              "rect",
              {
                height: "100%",
                width: columnWidth,
                x: additionalLeftSpace + i2 * columnWidth,
                y: 0,
                fill: holidayBackgroundColor
              },
              i2
            )
          );
        }
      }
    }
    return res;
  }, [
    viewMode,
    additionalLeftSpace,
    checkIsHoliday,
    columnWidth,
    startColumnIndex,
    endColumnIndex,
    getDate,
    holidayBackgroundColor
  ]);
  return /* @__PURE__ */ jsxs("g", { className: "grid", children: [
    renderedHolidays,
    /* @__PURE__ */ jsx(GridBody, { ...props })
  ] });
};
const calendarMain = "_calendarMain_14og3_1";
const calendarBottomText = "_calendarBottomText_14og3_7";
const calendarTopTick = "_calendarTopTick_14og3_18";
const calendarTopText = "_calendarTopText_14og3_22";
const calendarHeader = "_calendarHeader_14og3_33";
const styles$a = {
  calendarMain,
  calendarBottomText,
  calendarTopTick,
  calendarTopText,
  calendarHeader
};
const TopPartOfCalendar = ({
  value,
  x1Line,
  y1Line,
  y2Line,
  xText,
  yText,
  colors
}) => {
  return /* @__PURE__ */ jsxs("g", { className: "calendarTop", children: [
    /* @__PURE__ */ jsx(
      "line",
      {
        x1: x1Line,
        y1: y1Line,
        x2: x1Line,
        y2: y2Line,
        className: styles$a.calendarTopTick
      }
    ),
    value !== null && /* @__PURE__ */ jsx(
      "text",
      {
        y: yText,
        x: xText,
        className: styles$a.calendarTopText,
        style: { fill: colors.barLabelColor },
        children: value
      }
    )
  ] });
};
const defaultRenderBottomHeader = (date, viewMode, dateSetup, index2, isUnknownDates) => {
  if (isUnknownDates) {
    const {
      dateLocale: { formatDistance: formatDistance3 },
      preStepsCount
    } = dateSetup;
    const offsetFromStart = index2 - preStepsCount;
    if (offsetFromStart === 0) {
      return "0";
    }
    let value = "";
    if (!formatDistance3) {
      value = `${offsetFromStart}`;
    } else {
      switch (viewMode) {
        case ViewMode.Year:
          value = formatDistance3("xYears", offsetFromStart);
          break;
        case ViewMode.Month:
          value = formatDistance3("xMonths", offsetFromStart);
          break;
        case ViewMode.Week:
          value = formatDistance3("xWeeks", offsetFromStart);
          break;
        case ViewMode.TwoDays:
          value = formatDistance3("xDays", offsetFromStart);
          break;
        case ViewMode.Day:
          value = formatDistance3("xDays", offsetFromStart);
          break;
        case ViewMode.QuarterDay:
          value = formatDistance3("xHours", offsetFromStart * 6);
          break;
        case ViewMode.HalfDay:
          value = formatDistance3("xHours", offsetFromStart * 12);
          break;
        case ViewMode.Hour:
          value = formatDistance3("xHours", offsetFromStart);
          break;
        default:
          throw new Error("Unknown viewMode");
      }
    }
    if (offsetFromStart > 0) {
      return `+${value}`;
    }
    return value;
  }
  switch (viewMode) {
    case ViewMode.Year:
      return date.getFullYear();
    case ViewMode.Month:
      try {
        return format(date, dateSetup.dateFormats.monthBottomHeaderFormat, {
          locale: dateSetup.dateLocale
        });
      } catch (e2) {
        return date.toLocaleString("default", { month: "long" });
      }
    case ViewMode.Week:
      return `W${getWeekNumberISO8601(date)}`;
    case ViewMode.Day:
    case ViewMode.TwoDays:
      try {
        return format(date, dateSetup.dateFormats.dayBottomHeaderFormat, {
          locale: dateSetup.dateLocale
        });
      } catch (e2) {
        return String(date.getDate());
      }
    case ViewMode.QuarterDay:
    case ViewMode.HalfDay:
    case ViewMode.Hour:
      try {
        return format(date, dateSetup.dateFormats.hourBottomHeaderFormat, {
          locale: dateSetup.dateLocale
        });
      } catch (e2) {
        return String(date.getDate());
      }
    default:
      throw new Error("Unknown viewMode");
  }
};
const getDayText = (date, dateSetup) => {
  try {
    return format(date, dateSetup.dateFormats.dayTopHeaderFormat, {
      locale: dateSetup.dateLocale
    });
  } catch (e2) {
    return String(date.getDate());
  }
};
const getMonthText = (date, dateSetup) => {
  try {
    return format(date, dateSetup.dateFormats.monthTopHeaderFormat, {
      locale: dateSetup.dateLocale
    });
  } catch (e2) {
    return date.toLocaleString("default", { month: "long" });
  }
};
const getQuarterText = (date) => {
  const quarter = Math.ceil((date.getMonth() + 1) / 3);
  return `Q${quarter}`;
};
const defaultRenderTopHeader = (date, viewMode, dateSetup) => {
  switch (viewMode) {
    case ViewMode.Year:
      return date.getFullYear().toString();
    case ViewMode.QuarterYear:
      return `${getQuarterText(date)} ${date.getFullYear()}`;
    case ViewMode.Month:
      return date.getFullYear().toString();
    case ViewMode.Week:
      return `${getMonthText(date, dateSetup)}, ${date.getFullYear()}`;
    case ViewMode.TwoDays:
      return getMonthText(date, dateSetup);
    case ViewMode.Day:
      return getMonthText(date, dateSetup);
    case ViewMode.QuarterDay:
    case ViewMode.HalfDay:
      return `${getDayText(date, dateSetup)} ${getMonthText(date, dateSetup)}`;
    case ViewMode.Hour:
      return `${getDayText(date, dateSetup)} ${getMonthText(date, dateSetup)}`;
    default:
      throw new Error("Unknown viewMode");
  }
};
const Calendar = ({
  additionalLeftSpace,
  dateSetup,
  distances: { columnWidth, headerHeight },
  endColumnIndex,
  getDate,
  isUnknownDates,
  fontFamily,
  fontSize,
  fullSvgWidth,
  renderBottomHeader = defaultRenderBottomHeader,
  renderTopHeader = defaultRenderTopHeader,
  rtl,
  startColumnIndex,
  colors
}) => {
  const renderBottomHeaderByDate = useCallback(
    (date, index2) => renderBottomHeader(
      date,
      dateSetup.viewMode,
      dateSetup,
      index2,
      isUnknownDates
    ),
    [renderBottomHeader, dateSetup, isUnknownDates]
  );
  const renderTopHeaderByDate = useCallback(
    (date) => renderTopHeader(date, dateSetup.viewMode, dateSetup),
    [renderTopHeader, dateSetup]
  );
  const getCalendarValuesForYear = () => {
    const topValues2 = [];
    const bottomValues2 = [];
    for (let i2 = startColumnIndex; i2 <= endColumnIndex; i2++) {
      const date = getDate(i2);
      const bottomValue = renderBottomHeaderByDate(date, i2);
      bottomValues2.push(
        /* @__PURE__ */ jsx(
          "text",
          {
            y: headerHeight * 0.8,
            x: columnWidth * i2 + columnWidth * 0.5,
            className: styles$a.calendarBottomText,
            style: { fill: colors.barLabelColor },
            children: bottomValue
          },
          date.getFullYear()
        )
      );
      if (!isUnknownDates && (i2 === startColumnIndex || date.getFullYear() !== getDate(i2 - 1).getFullYear())) {
        const topValue = date.getFullYear().toString();
        topValues2.push(
          /* @__PURE__ */ jsx(
            TopPartOfCalendar,
            {
              value: null,
              x1Line: additionalLeftSpace + columnWidth * i2,
              y1Line: 0,
              y2Line: headerHeight,
              xText: 0,
              yText: 0,
              colors
            },
            topValue
          )
        );
      }
    }
    return [topValues2, bottomValues2];
  };
  const getCalendarValuesForQuarterYear = () => {
    const topValues2 = [];
    const bottomValues2 = [];
    const topDefaultHeight = headerHeight * 0.5;
    for (let i2 = startColumnIndex; i2 <= endColumnIndex; i2++) {
      const date = getDate(i2);
      const quarter = "Q" + Math.ceil((date.getMonth() + 1) / 3);
      bottomValues2.push(
        /* @__PURE__ */ jsx(
          "text",
          {
            y: headerHeight * 0.8,
            x: additionalLeftSpace + columnWidth * i2 + columnWidth * 0.5,
            className: styles$a.calendarBottomText,
            style: { fill: colors.barLabelColor },
            children: quarter
          },
          `${quarter}-${date.getFullYear()}`
        )
      );
      if (!isUnknownDates && (i2 === startColumnIndex || date.getFullYear() !== getDate(i2 - 1).getFullYear())) {
        const topValue = date.getFullYear().toString();
        const startQuarter = Math.floor(i2 / 3) * 3;
        topValues2.push(
          /* @__PURE__ */ jsx(
            TopPartOfCalendar,
            {
              value: topValue,
              x1Line: additionalLeftSpace + columnWidth * startQuarter,
              y1Line: 0,
              y2Line: topDefaultHeight,
              xText: additionalLeftSpace + columnWidth * (startQuarter + 1.5),
              yText: topDefaultHeight * 0.9,
              colors
            },
            topValue
          )
        );
      }
    }
    return [topValues2, bottomValues2];
  };
  const getCalendarValuesForMonth = () => {
    const topValues2 = [];
    const bottomValues2 = [];
    const topDefaultHeight = headerHeight * 0.5;
    for (let i2 = startColumnIndex; i2 <= endColumnIndex; i2++) {
      const date = getDate(i2);
      const bottomValue = renderBottomHeaderByDate(date, i2);
      bottomValues2.push(
        /* @__PURE__ */ jsx(
          "text",
          {
            y: headerHeight * 0.8,
            x: additionalLeftSpace + columnWidth * i2 + columnWidth * 0.5,
            className: styles$a.calendarBottomText,
            style: { fill: colors.barLabelColor },
            children: bottomValue
          },
          `${date.getMonth()}-${date.getFullYear()}`
        )
      );
      const fullYear = date.getFullYear();
      if (!isUnknownDates && (i2 === startColumnIndex || fullYear !== getDate(i2 - 1).getFullYear())) {
        const topValue = renderTopHeaderByDate(date);
        let xText;
        if (rtl) {
          xText = (6 + i2 + date.getMonth() + 1) * columnWidth;
        } else {
          xText = (6 + i2 - date.getMonth()) * columnWidth;
        }
        topValues2.push(
          /* @__PURE__ */ jsx(
            TopPartOfCalendar,
            {
              value: topValue,
              x1Line: additionalLeftSpace + columnWidth * i2,
              y1Line: 0,
              y2Line: topDefaultHeight,
              xText: additionalLeftSpace + xText,
              yText: topDefaultHeight * 0.9,
              colors
            },
            fullYear
          )
        );
      }
    }
    return [topValues2, bottomValues2];
  };
  const getCalendarValuesForWeek = () => {
    const topValues2 = [];
    const bottomValues2 = [];
    let weeksCount = 1;
    const topDefaultHeight = headerHeight * 0.5;
    for (let i2 = endColumnIndex; i2 >= startColumnIndex; i2--) {
      const date = getDate(i2);
      const month = date.getMonth();
      const fullYear = date.getFullYear();
      let topValue = "";
      if (!isUnknownDates && (i2 === startColumnIndex || month !== getDate(i2 - 1).getMonth())) {
        topValue = renderTopHeaderByDate(date);
      }
      const bottomValue = renderBottomHeaderByDate(date, i2);
      bottomValues2.push(
        /* @__PURE__ */ jsx(
          "text",
          {
            y: headerHeight * 0.8,
            x: additionalLeftSpace + columnWidth * (i2 + +rtl),
            className: styles$a.calendarBottomText,
            style: { fill: colors.barLabelColor },
            children: bottomValue
          },
          date.getTime()
        )
      );
      if (topValue) {
        topValues2.push(
          /* @__PURE__ */ jsx(
            TopPartOfCalendar,
            {
              value: topValue,
              x1Line: additionalLeftSpace + columnWidth * i2 + weeksCount * columnWidth,
              y1Line: 0,
              y2Line: topDefaultHeight,
              xText: additionalLeftSpace + columnWidth * i2 + columnWidth * weeksCount * 0.5,
              yText: topDefaultHeight * 0.9,
              colors
            },
            `${month}_${fullYear}`
          )
        );
        weeksCount = 0;
      }
      weeksCount++;
    }
    return [topValues2, bottomValues2];
  };
  const getCalendarValuesForDay = () => {
    const topValues2 = [];
    const bottomValues2 = [];
    const topDefaultHeight = headerHeight * 0.5;
    const renderedMonths = /* @__PURE__ */ new Set();
    for (let i2 = startColumnIndex; i2 <= endColumnIndex; i2++) {
      const date = getDate(i2);
      const bottomValue = renderBottomHeaderByDate(date, i2);
      const month = date.getMonth();
      const fullYear = date.getFullYear();
      bottomValues2.push(
        /* @__PURE__ */ jsx(
          "text",
          {
            y: headerHeight * 0.8,
            x: additionalLeftSpace + columnWidth * i2 + columnWidth * 0.5,
            className: styles$a.calendarBottomText,
            style: { fill: colors.barLabelColor },
            children: bottomValue
          },
          date.getTime()
        )
      );
      const monthKey = `${month}/${fullYear}`;
      if (!isUnknownDates && !renderedMonths.has(monthKey)) {
        renderedMonths.add(monthKey);
        const topValue = renderTopHeaderByDate(date);
        const startIndex = i2 + 1 - date.getDate();
        const endIndex = startIndex + getDaysInMonth(month, fullYear);
        const startIndexOrZero = Math.max(startIndex, 0);
        topValues2.push(
          /* @__PURE__ */ jsx(
            TopPartOfCalendar,
            {
              value: topValue,
              x1Line: additionalLeftSpace + columnWidth * endIndex,
              y1Line: 0,
              y2Line: topDefaultHeight,
              xText: additionalLeftSpace + columnWidth * (startIndexOrZero + (endIndex - startIndexOrZero) / 2),
              yText: topDefaultHeight * 0.9,
              colors
            },
            `${month}_${fullYear}`
          )
        );
      }
    }
    return [topValues2, bottomValues2];
  };
  const getCalendarValuesForPartOfDay = () => {
    const topValues2 = [];
    const bottomValues2 = [];
    const ticks = dateSetup.viewMode === ViewMode.HalfDay ? 2 : 4;
    const topDefaultHeight = headerHeight * 0.5;
    for (let i2 = startColumnIndex; i2 <= endColumnIndex; i2++) {
      const date = getDate(i2);
      const bottomValue = renderBottomHeaderByDate(date, i2);
      bottomValues2.push(
        /* @__PURE__ */ jsx(
          "text",
          {
            y: headerHeight * 0.8,
            x: additionalLeftSpace + columnWidth * (i2 + +rtl),
            className: styles$a.calendarBottomText,
            fontFamily,
            style: { fill: colors.barLabelColor },
            children: bottomValue
          },
          date.getTime()
        )
      );
      const dayOfMonth = date.getDate();
      const prevDate = getDate(i2 - 1);
      if (!isUnknownDates && dayOfMonth !== prevDate.getDate()) {
        const topValue = renderTopHeaderByDate(date);
        topValues2.push(
          /* @__PURE__ */ jsx(
            TopPartOfCalendar,
            {
              value: topValue,
              x1Line: additionalLeftSpace + columnWidth * i2,
              y1Line: 0,
              y2Line: topDefaultHeight,
              xText: additionalLeftSpace + columnWidth * i2 + ticks * columnWidth * 0.5,
              yText: topDefaultHeight * 0.9,
              colors
            },
            `${prevDate.getDate()}_${prevDate.getMonth()}_${prevDate.getFullYear()}`
          )
        );
      }
    }
    return [topValues2, bottomValues2];
  };
  const getCalendarValuesForHour = () => {
    const topValues2 = [];
    const bottomValues2 = [];
    const topDefaultHeight = headerHeight * 0.5;
    const renderedDates = /* @__PURE__ */ new Set();
    for (let i2 = startColumnIndex; i2 <= endColumnIndex; i2++) {
      const date = getDate(i2);
      const bottomValue = renderBottomHeaderByDate(date, i2);
      bottomValues2.push(
        /* @__PURE__ */ jsx(
          "text",
          {
            y: headerHeight * 0.8,
            x: additionalLeftSpace + columnWidth * (i2 + +rtl),
            className: styles$a.calendarBottomText,
            fontFamily,
            style: { fill: colors.barLabelColor },
            children: bottomValue
          },
          date.getTime()
        )
      );
      const dayOfMonth = date.getDate();
      const dateKey = `${dayOfMonth}/${date.getMonth()}/${date.getFullYear()}`;
      if (!isUnknownDates && !renderedDates.has(dateKey)) {
        renderedDates.add(dateKey);
        const topValue = renderTopHeaderByDate(date);
        const topPosition = date.getHours() / 2;
        topValues2.push(
          /* @__PURE__ */ jsx(
            TopPartOfCalendar,
            {
              value: topValue,
              x1Line: additionalLeftSpace + columnWidth * i2,
              y1Line: 0,
              y2Line: topDefaultHeight,
              xText: additionalLeftSpace + columnWidth * (i2 + topPosition),
              yText: topDefaultHeight * 0.9,
              colors
            },
            dateKey
          )
        );
      }
    }
    return [topValues2, bottomValues2];
  };
  let topValues = [];
  let bottomValues = [];
  switch (dateSetup.viewMode) {
    case ViewMode.Year:
      [topValues, bottomValues] = getCalendarValuesForYear();
      break;
    case ViewMode.QuarterYear:
      [topValues, bottomValues] = getCalendarValuesForQuarterYear();
      break;
    case ViewMode.Month:
      [topValues, bottomValues] = getCalendarValuesForMonth();
      break;
    case ViewMode.Week:
      [topValues, bottomValues] = getCalendarValuesForWeek();
      break;
    case ViewMode.TwoDays:
      [topValues, bottomValues] = getCalendarValuesForDay();
      break;
    case ViewMode.Day:
      [topValues, bottomValues] = getCalendarValuesForDay();
      break;
    case ViewMode.QuarterDay:
    case ViewMode.HalfDay:
      [topValues, bottomValues] = getCalendarValuesForPartOfDay();
      break;
    case ViewMode.Hour:
      [topValues, bottomValues] = getCalendarValuesForHour();
  }
  return /* @__PURE__ */ jsx("div", { className: styles$a.calendarMain, style: { width: fullSvgWidth }, children: /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: fullSvgWidth,
      height: headerHeight,
      fontFamily,
      children: /* @__PURE__ */ jsxs("g", { className: "calendar", fontSize, fontFamily, children: [
        topValues,
        bottomValues
      ] })
    }
  ) });
};
const generateTrianglePoints = (x3, y3, width, isLeftDirected) => {
  if (isLeftDirected) {
    return `${x3},${y3} 
    ${x3 + width},${y3 + width} 
    ${x3 + width},${y3 - width}`;
  }
  return `${x3},${y3} 
    ${x3 - width},${y3 - width} 
    ${x3 - width},${y3 + width}`;
};
const hoverVisibleWrapper$1 = "_hoverVisibleWrapper_19ebs_1";
const wrapper$2 = "_wrapper_19ebs_1";
const mainPath$2 = "_mainPath_19ebs_9";
const clickZone$2 = "_clickZone_19ebs_18";
const styles$9 = {
  hoverVisibleWrapper: hoverVisibleWrapper$1,
  wrapper: wrapper$2,
  mainPath: mainPath$2,
  clickZone: clickZone$2
};
const fixPositionContainerClass = styles$9.hoverVisibleWrapper;
const FixDependencyPositionInner = ({
  color,
  dependencyFixIndent,
  handleFixPosition,
  height,
  isLeft,
  width,
  x: x3,
  y: y3
}) => {
  const halfHeight = useMemo(
    () => Math.round(height / 2),
    [height]
  );
  const d4 = useMemo(() => {
    return `M ${x3} ${y3}
      v ${height}
      M ${x3} ${y3 + halfHeight}
      h ${isLeft ? -width : width}
    `;
  }, [
    x3,
    y3,
    width,
    height,
    halfHeight,
    isLeft
  ]);
  const trianglePoints = useMemo(
    () => generateTrianglePoints(
      isLeft ? x3 - width : x3 + width,
      y3 + halfHeight,
      5,
      isLeft
    ),
    [
      x3,
      y3,
      width,
      halfHeight,
      isLeft
    ]
  );
  return /* @__PURE__ */ jsxs(
    "g",
    {
      className: styles$9.wrapper,
      fill: color,
      stroke: color,
      onMouseDown: handleFixPosition,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: d4,
            className: styles$9.mainPath
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            x: isLeft ? x3 - width - dependencyFixIndent : x3,
            y: y3,
            width: width + dependencyFixIndent,
            height,
            className: styles$9.clickZone
          }
        ),
        /* @__PURE__ */ jsx("polygon", { points: trianglePoints })
      ]
    }
  );
};
const FixDependencyPosition = memo(FixDependencyPositionInner);
const arrow_clickable = "_arrow_clickable_16evi_1";
const mainPath$1 = "_mainPath_16evi_5";
const clickZone$1 = "_clickZone_16evi_14";
const styles$8 = {
  arrow_clickable,
  mainPath: mainPath$1,
  clickZone: clickZone$1
};
const ArrowInner = ({
  colorStyles: { arrowColor, arrowWarningColor, arrowCriticalColor },
  distances: {
    arrowIndent,
    dependencyFixWidth,
    dependencyFixHeight,
    dependencyFixIndent
  },
  taskFrom,
  extremityFrom,
  fromX1,
  fromX2,
  fromY,
  taskTo,
  extremityTo,
  toX1,
  toX2,
  toY,
  marginBetweenTasks = void 0,
  fullRowHeight,
  taskHeight,
  isShowDependencyWarnings,
  isCritical,
  rtl,
  onArrowDoubleClick = void 0,
  onArrowClick = void 0,
  handleFixDependency
}) => {
  const indexFrom = useMemo(
    () => Math.floor(fromY / fullRowHeight),
    [fromY, fullRowHeight]
  );
  const indexTo = useMemo(
    () => Math.floor(toY / fullRowHeight),
    [toY, fullRowHeight]
  );
  const onDoubleClick = useCallback(() => {
    if (onArrowDoubleClick) {
      onArrowDoubleClick(taskFrom, taskTo);
    }
  }, [taskFrom, taskTo, onArrowDoubleClick]);
  const onClick = useCallback(
    (event) => {
      if (onArrowClick) {
        onArrowClick(taskFrom, extremityFrom, taskTo, extremityTo, event);
      }
    },
    [taskFrom, taskTo, onArrowDoubleClick]
  );
  const [path, trianglePoints] = useMemo(
    () => drownPathAndTriangle(
      indexFrom,
      fromX1,
      fromX2,
      fromY,
      extremityFrom === "startOfTask" !== rtl,
      indexTo,
      toX1,
      toX2,
      toY,
      extremityTo === "startOfTask" !== rtl,
      fullRowHeight,
      taskHeight,
      arrowIndent
    ),
    [
      indexFrom,
      fromX1,
      fromX2,
      fromY,
      extremityFrom,
      indexTo,
      toX1,
      toX2,
      toY,
      extremityTo,
      rtl,
      fullRowHeight,
      taskHeight,
      arrowIndent
    ]
  );
  const taskFromFixerPosition = useMemo(() => {
    const isLeft = extremityFrom === "startOfTask" !== rtl;
    if (isLeft) {
      return fromX1 - dependencyFixIndent;
    }
    return fromX2 + dependencyFixIndent;
  }, [fromX1, fromX2, extremityFrom, rtl, dependencyFixIndent]);
  const taskToFixerPosition = useMemo(() => {
    const isLeft = extremityTo === "startOfTask" !== rtl;
    if (isLeft) {
      return toX1 - dependencyFixIndent;
    }
    return toX2 + dependencyFixIndent;
  }, [toX1, toX2, extremityTo, rtl, dependencyFixIndent]);
  const fixDependencyTaskFrom = useCallback(() => {
    if (typeof marginBetweenTasks !== "number") {
      return;
    }
    handleFixDependency(taskFrom, marginBetweenTasks);
  }, [taskFrom, handleFixDependency, marginBetweenTasks]);
  const fixDependencyTaskTo = useCallback(() => {
    if (typeof marginBetweenTasks !== "number") {
      return;
    }
    handleFixDependency(taskTo, -marginBetweenTasks);
  }, [taskTo, handleFixDependency, marginBetweenTasks]);
  const hasWarning = useMemo(
    () => isShowDependencyWarnings && typeof marginBetweenTasks === "number" && marginBetweenTasks < 0,
    [marginBetweenTasks, isShowDependencyWarnings]
  );
  const color = useMemo(() => {
    if (isCritical) {
      return arrowCriticalColor;
    }
    if (hasWarning) {
      return arrowWarningColor;
    }
    return arrowColor;
  }, [
    hasWarning,
    isCritical,
    arrowColor,
    arrowCriticalColor,
    arrowWarningColor
  ]);
  return /* @__PURE__ */ jsxs("g", { className: fixPositionContainerClass, fill: color, stroke: color, children: [
    /* @__PURE__ */ jsxs(
      "g",
      {
        "data-testid": `task-arrow-${extremityFrom}-${taskFrom.name}-${extremityTo}-${taskTo.name}`,
        className: `"arrow" ${styles$8.arrow_clickable}`,
        onDoubleClick,
        onClick,
        children: [
          onArrowDoubleClick && /* @__PURE__ */ jsx("path", { d: path, className: styles$8.clickZone }),
          /* @__PURE__ */ jsx("path", { className: styles$8.mainPath, d: path }),
          /* @__PURE__ */ jsx("polygon", { points: trianglePoints })
        ]
      }
    ),
    hasWarning && /* @__PURE__ */ jsxs(Fragment$1, { children: [
      /* @__PURE__ */ jsx(
        FixDependencyPosition,
        {
          x: taskToFixerPosition,
          y: toY,
          dependencyFixIndent,
          isLeft: rtl,
          color: "grey",
          width: dependencyFixWidth,
          height: dependencyFixHeight,
          handleFixPosition: fixDependencyTaskTo
        }
      ),
      /* @__PURE__ */ jsx(
        FixDependencyPosition,
        {
          x: taskFromFixerPosition,
          y: fromY,
          dependencyFixIndent,
          isLeft: !rtl,
          color: "grey",
          width: dependencyFixWidth,
          height: dependencyFixHeight,
          handleFixPosition: fixDependencyTaskFrom
        }
      )
    ] })
  ] });
};
const Arrow = memo(ArrowInner);
const drownPathAndTriangle = (indexForm, fromX1, fromX2, fromY, isTaskFromLeftSide, indexTo, toX1, toX2, toY, isTaskToLeftSide, fullRowHeight, taskHeight, arrowIndent) => {
  const isDownDirected = indexTo > indexForm;
  const horizontalDockingY = isDownDirected ? (indexForm + 1) * fullRowHeight : indexForm * fullRowHeight;
  const taskFromEndPositionX = isTaskFromLeftSide ? fromX1 - arrowIndent : fromX2 + arrowIndent;
  const taskToEndPositionX = isTaskToLeftSide ? toX1 - arrowIndent : toX2 + arrowIndent;
  const taskToEndPositionY = toY + taskHeight / 2;
  const path = `M ${isTaskFromLeftSide ? fromX1 : fromX2} ${fromY + taskHeight / 2}
  H ${taskFromEndPositionX}
  V ${horizontalDockingY}
  H ${taskToEndPositionX}
  V ${taskToEndPositionY}
  H ${isTaskToLeftSide ? toX1 : toX2}`;
  const trianglePoints = isTaskToLeftSide ? generateTrianglePoints(toX1, taskToEndPositionY, 5, false) : generateTrianglePoints(toX2, taskToEndPositionY, 5, true);
  return [path, trianglePoints];
};
const relationLine = "_relationLine_1nqzz_1";
const styles$7 = {
  relationLine
};
const RelationLine = ({
  x1,
  x2: x22,
  y1,
  y2: y22
}) => {
  return /* @__PURE__ */ jsx(
    "line",
    {
      x1,
      x2: x22,
      y1,
      y2: y22,
      className: styles$7.relationLine
    }
  );
};
const getDateByOffset = (startDate, offset2, viewMode) => {
  switch (viewMode) {
    case ViewMode.Day:
      return addDays(startDate, offset2);
    case ViewMode.TwoDays:
      return addDays(startDate, offset2 * 2);
    case ViewMode.HalfDay:
      return addHours(startDate, offset2 * 12);
    case ViewMode.QuarterDay:
      return addHours(startDate, offset2 * 6);
    case ViewMode.Hour:
      return addHours(startDate, offset2);
    case ViewMode.Month:
      return addMonths(startDate, offset2);
    case ViewMode.Week:
      return addWeeks(startDate, offset2);
    case ViewMode.QuarterYear:
      return addQuarters(startDate, offset2);
    case ViewMode.Year:
      return addYears(startDate, offset2);
    default:
      throw new Error("Unknown view mode");
  }
};
const taskXCoordinate = (xDate, startDate, viewMode, columnWidth) => {
  const index2 = getDatesDiff(xDate, startDate, viewMode);
  const currentDate = getDateByOffset(startDate, index2, viewMode);
  const nextDate = getDateByOffset(startDate, index2 + 1, viewMode);
  const remainderMillis = xDate.getTime() - currentDate.getTime();
  const percentOfInterval = remainderMillis / (nextDate.getTime() - currentDate.getTime());
  const x3 = index2 * columnWidth + percentOfInterval * columnWidth;
  return x3;
};
const progressWithByParams = (taskX1, taskX2, progress, rtl) => {
  const progressWidth = (taskX2 - taskX1) * progress * 0.01;
  let progressX;
  if (rtl) {
    progressX = taskX2 - progressWidth;
  } else {
    progressX = taskX1;
  }
  return [progressWidth, progressX];
};
const getProgressPoint = (progressX, taskY, taskHeight) => {
  const point = [
    progressX - 7,
    taskY + taskHeight,
    progressX + 7,
    taskY + taskHeight,
    progressX,
    taskY + taskHeight - 11
  ];
  return point.join(",");
};
const dateByX = (x3, taskX, taskDate, xStep, timeStep) => {
  let newDate = new Date((x3 - taskX) / xStep * timeStep + taskDate.getTime());
  newDate = new Date(
    newDate.getTime() + (newDate.getTimezoneOffset() - taskDate.getTimezoneOffset()) * 6e4
  );
  return newDate;
};
const handleTaskBySVGMouseEvent = (action, selectedTask, initialCoordinates, coordinates, xStep, timeStep, rtl) => {
  let result;
  switch (selectedTask.type) {
    case "milestone":
      result = handleTaskBySVGMouseEventForMilestone(
        action,
        selectedTask,
        initialCoordinates,
        coordinates,
        xStep,
        timeStep
      );
      break;
    default:
      result = handleTaskBySVGMouseEventForBar(
        action,
        selectedTask,
        initialCoordinates,
        coordinates,
        xStep,
        timeStep,
        rtl
      );
      break;
  }
  return result;
};
const handleTaskBySVGMouseEventForBar = (action, selectedTask, initialCoordinates, coordinates, xStep, timeStep, rtl) => {
  const changedTask = { ...selectedTask };
  let isChanged = false;
  switch (action) {
    case "progress":
      isChanged = initialCoordinates.progressWidth !== coordinates.progressWidth;
      if (isChanged) {
        changedTask.progress = Math.round(
          coordinates.progressWidth * 100 / (coordinates.x2 - coordinates.x1)
        );
      }
      break;
    case "start": {
      isChanged = initialCoordinates.x1 !== coordinates.x1;
      if (isChanged) {
        if (rtl) {
          changedTask.end = dateByX(
            coordinates.x1,
            initialCoordinates.x1,
            selectedTask.end,
            xStep,
            timeStep
          );
        } else {
          changedTask.start = dateByX(
            coordinates.x1,
            initialCoordinates.x1,
            selectedTask.start,
            xStep,
            timeStep
          );
        }
      }
      break;
    }
    case "end": {
      isChanged = initialCoordinates.x2 !== coordinates.x2;
      if (isChanged) {
        if (rtl) {
          changedTask.start = dateByX(
            coordinates.x2,
            initialCoordinates.x2,
            selectedTask.start,
            xStep,
            timeStep
          );
        } else {
          changedTask.end = dateByX(
            coordinates.x2,
            initialCoordinates.x2,
            selectedTask.end,
            xStep,
            timeStep
          );
        }
      }
      break;
    }
    case "move": {
      isChanged = initialCoordinates.x1 !== coordinates.x1;
      if (isChanged) {
        if (rtl) {
          changedTask.end = dateByX(
            coordinates.x1,
            initialCoordinates.x1,
            selectedTask.end,
            xStep,
            timeStep
          );
          changedTask.start = dateByX(
            coordinates.x2,
            initialCoordinates.x2,
            selectedTask.start,
            xStep,
            timeStep
          );
        } else {
          changedTask.start = dateByX(
            coordinates.x1,
            initialCoordinates.x1,
            selectedTask.start,
            xStep,
            timeStep
          );
          changedTask.end = dateByX(
            coordinates.x2,
            initialCoordinates.x2,
            selectedTask.end,
            xStep,
            timeStep
          );
        }
      }
      break;
    }
  }
  return { isChanged, changedTask };
};
const handleTaskBySVGMouseEventForMilestone = (action, selectedTask, initialCoordinates, coordinates, xStep, timeStep) => {
  const changedTask = { ...selectedTask };
  const isChanged = coordinates.x1 !== initialCoordinates.x1;
  if (isChanged) {
    switch (action) {
      case "move": {
        changedTask.start = dateByX(
          coordinates.x1,
          initialCoordinates.x1,
          selectedTask.start,
          xStep,
          timeStep
        );
        changedTask.end = changedTask.start;
        break;
      }
    }
  }
  return { isChanged, changedTask };
};
const barWrapper = "_barWrapper_hr87b_1";
const barHandle = "_barHandle_hr87b_6";
const barBackground = "_barBackground_hr87b_22";
const styles$6 = {
  barWrapper,
  barHandle,
  barBackground
};
const BarDisplay = ({
  taskName: taskName2,
  barCornerRadius,
  isCritical,
  isSelected,
  hasChildren,
  height,
  progressWidth,
  progressX,
  startMoveFullTask,
  styles: styles2,
  width,
  x: x3,
  y: y3
}) => {
  const processColor = useMemo(() => {
    if (isCritical) {
      if (hasChildren) {
        if (isSelected) {
          return styles2.groupProgressSelectedCriticalColor;
        }
        return styles2.groupProgressCriticalColor;
      }
      if (isSelected) {
        return styles2.barProgressSelectedCriticalColor;
      }
      return styles2.barProgressCriticalColor;
    }
    if (hasChildren) {
      if (isSelected) {
        return styles2.groupProgressSelectedColor;
      }
      return styles2.groupProgressColor;
    }
    if (isSelected) {
      return styles2.barProgressSelectedColor;
    }
    return styles2.barProgressColor;
  }, [isSelected, isCritical, hasChildren, styles2]);
  const barColor = useMemo(() => {
    if (isCritical) {
      if (hasChildren) {
        if (isSelected) {
          return styles2.groupBackgroundSelectedCriticalColor;
        }
        return styles2.groupBackgroundCriticalColor;
      }
      if (isSelected) {
        return styles2.barBackgroundSelectedCriticalColor;
      }
      return styles2.barBackgroundCriticalColor;
    }
    if (hasChildren) {
      if (isSelected) {
        return styles2.groupBackgroundSelectedColor;
      }
      return styles2.groupBackgroundColor;
    }
    if (isSelected) {
      return styles2.barBackgroundSelectedColor;
    }
    return styles2.barBackgroundColor;
  }, [isSelected, isCritical, hasChildren, styles2]);
  return /* @__PURE__ */ jsxs(
    "g",
    {
      "data-testid": `task-bar-${taskName2}`,
      onMouseDown: (e2) => {
        startMoveFullTask(e2.clientX);
      },
      onTouchStart: (e2) => {
        const firstTouch = e2.touches[0];
        if (firstTouch) {
          startMoveFullTask(firstTouch.clientX);
        }
      },
      children: [
        /* @__PURE__ */ jsx(
          "rect",
          {
            x: x3,
            width,
            y: y3,
            height,
            ry: barCornerRadius,
            rx: barCornerRadius,
            fill: barColor,
            className: styles$6.barBackground
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            x: progressX,
            width: progressWidth,
            y: y3,
            height,
            ry: barCornerRadius,
            rx: barCornerRadius,
            fill: processColor
          }
        )
      ]
    }
  );
};
const BarDateHandle = ({
  dataTestid,
  barCornerRadius,
  height,
  startMove,
  width,
  x: x3,
  y: y3
}) => {
  return /* @__PURE__ */ jsx(
    "rect",
    {
      "data-testid": dataTestid,
      x: x3,
      y: y3,
      width,
      height,
      className: styles$6.barHandle,
      ry: barCornerRadius,
      rx: barCornerRadius,
      onMouseDown: (e2) => {
        startMove(e2.clientX);
      },
      onTouchStart: (e2) => {
        const firstTouch = e2.touches[0];
        if (firstTouch) {
          startMove(firstTouch.clientX);
        }
      }
    }
  );
};
const BarProgressHandle = ({
  taskName: taskName2,
  progressPoint,
  startMoveProgress
}) => {
  return /* @__PURE__ */ jsx(
    "polygon",
    {
      "data-testid": `task-progress-handle-${taskName2}`,
      className: styles$6.barHandle,
      points: progressPoint,
      onMouseDown: (e2) => {
        startMoveProgress(e2.clientX);
      },
      onTouchStart: (e2) => {
        const firstTouch = e2.touches[0];
        if (firstTouch) {
          startMoveProgress(firstTouch.clientX);
        }
      }
    }
  );
};
const barRelationHandleWrapper = "_barRelationHandleWrapper_tmzzo_1";
const barRelationHandle = "_barRelationHandle_tmzzo_1";
const barRelationHandle_drawMode = "_barRelationHandle_drawMode_tmzzo_1";
const styles$5 = {
  barRelationHandleWrapper,
  barRelationHandle,
  barRelationHandle_drawMode
};
const projectWrapper = "_projectWrapper_19i2s_1";
const projectBackground = "_projectBackground_19i2s_6";
const projectTop = "_projectTop_19i2s_11";
const styles$4 = {
  projectWrapper,
  projectBackground,
  projectTop
};
const ProjectDisplay = ({
  barCornerRadius,
  taskName: taskName2,
  taskHalfHeight,
  taskHeight,
  isSelected,
  isCritical,
  colorStyles,
  progressWidth,
  progressX,
  taskYOffset,
  width,
  x1,
  x2: x22,
  startMoveFullTask
}) => {
  const barColor = useMemo(() => {
    if (isCritical) {
      if (isSelected) {
        return colorStyles.projectBackgroundSelectedCriticalColor;
      }
      return colorStyles.projectBackgroundCriticalColor;
    }
    if (isSelected) {
      return colorStyles.projectBackgroundSelectedColor;
    }
    return colorStyles.projectBackgroundColor;
  }, [isSelected, isCritical, colorStyles]);
  const processColor = useMemo(() => {
    if (isCritical) {
      if (isSelected) {
        return colorStyles.projectProgressSelectedCriticalColor;
      }
      return colorStyles.projectProgressCriticalColor;
    }
    if (isSelected) {
      return colorStyles.projectProgressSelectedColor;
    }
    return colorStyles.projectProgressColor;
  }, [isSelected, isCritical, colorStyles]);
  const projectLeftTriangle = [
    x1,
    taskYOffset + taskHeight / 2 - 1,
    x1,
    taskYOffset + taskHeight,
    x1 + 15,
    taskYOffset + taskHeight / 2 - 1
  ].join(",");
  const projectRightTriangle = [
    x22,
    taskYOffset + taskHeight / 2 - 1,
    x22,
    taskYOffset + taskHeight,
    x22 - 15,
    taskYOffset + taskHeight / 2 - 1
  ].join(",");
  return /* @__PURE__ */ jsxs(
    "g",
    {
      "data-testid": `task-project-${taskName2}`,
      onMouseDown: (e2) => {
        startMoveFullTask(e2.clientX);
      },
      onTouchStart: (e2) => {
        const firstTouch = e2.touches[0];
        if (firstTouch) {
          startMoveFullTask(firstTouch.clientX);
        }
      },
      tabIndex: 0,
      className: styles$4.projectWrapper,
      children: [
        /* @__PURE__ */ jsx(
          "rect",
          {
            fill: barColor,
            x: x1,
            width,
            y: taskYOffset,
            height: taskHeight,
            rx: barCornerRadius,
            ry: barCornerRadius,
            className: styles$4.projectBackground
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            x: progressX,
            width: progressWidth,
            y: taskYOffset,
            height: taskHeight,
            ry: barCornerRadius,
            rx: barCornerRadius,
            fill: processColor
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            fill: barColor,
            x: x1,
            width,
            y: taskYOffset,
            height: taskHalfHeight,
            rx: barCornerRadius,
            ry: barCornerRadius,
            className: styles$4.projectTop
          }
        ),
        /* @__PURE__ */ jsx(
          "polygon",
          {
            className: styles$4.projectTop,
            points: projectLeftTriangle,
            fill: barColor
          }
        ),
        /* @__PURE__ */ jsx(
          "polygon",
          {
            className: styles$4.projectTop,
            points: projectRightTriangle,
            fill: barColor
          }
        )
      ]
    }
  );
};
const Bar = ({
  children: relationhandles,
  colorStyles,
  distances: { barCornerRadius, handleWidth },
  hasChildren,
  isCritical,
  isDateChangeable,
  isProgressChangeable,
  isSelected,
  onTaskEventStart,
  progressWidth,
  progressX,
  rtl,
  task,
  taskHalfHeight,
  taskHeight,
  taskYOffset,
  width,
  x1,
  x2: x22
}) => {
  const startMoveFullTask = useCallback(
    (clientX) => {
      onTaskEventStart("move", clientX);
    },
    [onTaskEventStart]
  );
  const startMoveStartOfTask = useCallback(
    (clientX) => {
      onTaskEventStart("start", clientX);
    },
    [onTaskEventStart]
  );
  const startMoveEndOfTask = useCallback(
    (clientX) => {
      onTaskEventStart("end", clientX);
    },
    [onTaskEventStart]
  );
  const startMoveProgress = useCallback(
    (clientX) => {
      onTaskEventStart("progress", clientX);
    },
    [onTaskEventStart]
  );
  const progressPoint = getProgressPoint(
    +!rtl * progressWidth + progressX,
    taskYOffset,
    taskHeight
  );
  const handleHeight = taskHeight - 2;
  let barDisplay = null;
  if (task.type === "project") {
    barDisplay = /* @__PURE__ */ jsx(
      ProjectDisplay,
      {
        taskName: task.name,
        x1,
        x2: x22,
        taskYOffset,
        width,
        taskHeight,
        taskHalfHeight,
        progressX,
        progressWidth,
        barCornerRadius,
        colorStyles,
        isSelected,
        isCritical,
        hasChildren,
        startMoveFullTask
      }
    );
  } else {
    barDisplay = /* @__PURE__ */ jsx(
      BarDisplay,
      {
        taskName: task.name,
        x: x1,
        y: taskYOffset,
        width,
        height: taskHeight,
        progressX,
        progressWidth,
        barCornerRadius,
        styles: colorStyles,
        isSelected,
        isCritical,
        hasChildren,
        startMoveFullTask
      }
    );
  }
  return /* @__PURE__ */ jsxs(
    "g",
    {
      className: `${styles$6.barWrapper} ${styles$5.barRelationHandleWrapper}`,
      tabIndex: 0,
      children: [
        barDisplay,
        isDateChangeable && /* @__PURE__ */ jsx(
          BarDateHandle,
          {
            dataTestid: `task-date-handle-left-${task.name}`,
            barCornerRadius,
            height: handleHeight,
            startMove: startMoveStartOfTask,
            width: handleWidth,
            x: x1 + 1,
            y: taskYOffset + 1
          }
        ),
        isDateChangeable && /* @__PURE__ */ jsx(
          BarDateHandle,
          {
            dataTestid: `task-date-handle-right-${task.name}`,
            barCornerRadius,
            height: handleHeight,
            startMove: startMoveEndOfTask,
            width: handleWidth,
            x: x22 - handleWidth - 1,
            y: taskYOffset + 1
          }
        ),
        relationhandles,
        isProgressChangeable && /* @__PURE__ */ jsx(
          BarProgressHandle,
          {
            taskName: task.name,
            progressPoint,
            startMoveProgress
          }
        )
      ]
    }
  );
};
const BarSmall = ({
  children: relationhandles,
  colorStyles,
  distances: { barCornerRadius, handleWidth },
  hasChildren,
  isSelected,
  isCritical,
  isDateChangeable,
  onTaskEventStart,
  progressWidth,
  progressX,
  taskYOffset,
  task,
  taskHeight,
  x1
}) => {
  const startMoveFullTask = useCallback(
    (clientX) => {
      onTaskEventStart("move", clientX);
    },
    [onTaskEventStart]
  );
  const startMoveEndOfTask = useCallback(
    (clientX) => {
      onTaskEventStart("end", clientX);
    },
    [onTaskEventStart]
  );
  return /* @__PURE__ */ jsxs(
    "g",
    {
      className: `${styles$6.barWrapper} ${styles$5.barRelationHandleWrapper}`,
      tabIndex: 0,
      children: [
        /* @__PURE__ */ jsx(
          BarDisplay,
          {
            taskName: task.name,
            barCornerRadius,
            hasChildren,
            height: taskHeight,
            isCritical,
            isSelected,
            progressWidth,
            progressX,
            startMoveFullTask,
            styles: colorStyles,
            width: handleWidth * 2,
            x: x1,
            y: taskYOffset
          }
        ),
        isDateChangeable && /* @__PURE__ */ jsx(
          BarDateHandle,
          {
            dataTestid: `task-date-handle-right-${task.name}`,
            barCornerRadius,
            height: taskHeight - 2,
            startMove: startMoveEndOfTask,
            width: handleWidth,
            x: x1 + handleWidth,
            y: taskYOffset + 1
          }
        ),
        relationhandles
      ]
    }
  );
};
const milestoneWrapper = "_milestoneWrapper_xr9to_1";
const milestoneBackground = "_milestoneBackground_xr9to_6";
const styles$3 = {
  milestoneWrapper,
  milestoneBackground
};
const Milestone = ({
  children: relationhandles,
  task,
  taskYOffset,
  distances: { barCornerRadius },
  taskHeight,
  onTaskEventStart,
  isSelected,
  isCritical,
  colorStyles,
  x1
}) => {
  const rotatedHeight = taskHeight / 1.414;
  const transform = `rotate(45 ${x1 + rotatedHeight * 0.356} 
    ${taskYOffset + rotatedHeight * 0.85})`;
  const barColor = useMemo(() => {
    if (isCritical) {
      if (isSelected) {
        return colorStyles.milestoneBackgroundSelectedCriticalColor;
      }
      return colorStyles.milestoneBackgroundCriticalColor;
    }
    if (isSelected) {
      return colorStyles.milestoneBackgroundSelectedColor;
    }
    return colorStyles.milestoneBackgroundColor;
  }, [isSelected, isCritical, colorStyles]);
  return /* @__PURE__ */ jsxs(
    "g",
    {
      tabIndex: 0,
      className: `${styles$3.milestoneWrapper} ${styles$5.barRelationHandleWrapper}`,
      children: [
        /* @__PURE__ */ jsx(
          "rect",
          {
            "data-testid": `task-milestone-${task.name}`,
            fill: barColor,
            x: x1,
            width: rotatedHeight,
            y: taskYOffset,
            height: rotatedHeight,
            rx: barCornerRadius,
            ry: barCornerRadius,
            transform,
            className: styles$3.milestoneBackground,
            onMouseDown: (e2) => {
              onTaskEventStart("move", e2.clientX);
            },
            onTouchStart: (e2) => {
              const firstTouch = e2.touches[0];
              if (firstTouch) {
                onTaskEventStart("move", firstTouch.clientX);
              }
            }
          }
        ),
        relationhandles
      ]
    }
  );
};
const TaskWarningInner = ({
  rtl,
  outOfParentWarnings = void 0,
  hasDependencyWarning,
  taskWarningOffset,
  taskHalfHeight,
  taskYOffset,
  x1,
  x2: x22
}) => {
  const isError = useMemo(
    () => {
      if (hasDependencyWarning) {
        return true;
      }
      if (outOfParentWarnings) {
        const {
          start,
          end
        } = outOfParentWarnings;
        return Boolean((start == null ? void 0 : start.isOutside) || (end == null ? void 0 : end.isOutside));
      }
      return false;
    },
    [outOfParentWarnings, hasDependencyWarning]
  );
  const centerX = useMemo(() => {
    if (rtl) {
      return x1 - taskWarningOffset;
    }
    return x22 + taskWarningOffset;
  }, [
    rtl,
    taskWarningOffset,
    x1,
    x22
  ]);
  return /* @__PURE__ */ jsxs("g", { children: [
    /* @__PURE__ */ jsx(
      "circle",
      {
        cx: centerX,
        cy: taskYOffset + taskHalfHeight,
        r: 12,
        fill: isError ? "#ff0000" : "#e1ca24",
        strokeWidth: 5
      }
    ),
    /* @__PURE__ */ jsx(
      "rect",
      {
        fill: "#ffffff",
        x: centerX - 2,
        y: taskYOffset + taskHalfHeight - 7,
        width: 4,
        height: 4
      }
    ),
    /* @__PURE__ */ jsx(
      "rect",
      {
        fill: "#ffffff",
        x: centerX - 2,
        y: taskYOffset + taskHalfHeight,
        width: 4,
        height: 8
      }
    )
  ] });
};
const TaskWarning = memo(TaskWarningInner);
const barLabel = "_barLabel_pu5db_1";
const barLabelOutside = "_barLabelOutside_pu5db_13";
const style = {
  barLabel,
  barLabelOutside
};
const hoverVisibleWrapper = "_hoverVisibleWrapper_19ebs_1";
const wrapper$1 = "_wrapper_19ebs_1";
const mainPath = "_mainPath_19ebs_9";
const clickZone = "_clickZone_19ebs_18";
const styles$2 = {
  hoverVisibleWrapper,
  wrapper: wrapper$1,
  mainPath,
  clickZone
};
const fixWidthContainerClass = styles$2.hoverVisibleWrapper;
const BarFixWidthInner = ({
  x: x3,
  y: y3,
  width,
  height,
  isLeft,
  color,
  handleFixWidth
}) => {
  const halfHeight = useMemo(
    () => Math.round(height / 2),
    [height]
  );
  const d4 = useMemo(() => {
    return `M ${x3} ${y3}
      v ${height}
      M ${x3} ${y3 + halfHeight}
      h ${isLeft ? -width : width}
    `;
  }, [
    x3,
    y3,
    width,
    height,
    halfHeight,
    isLeft
  ]);
  const trianglePoints = useMemo(
    () => generateTrianglePoints(
      isLeft ? x3 - width : x3 + width,
      y3 + halfHeight,
      5,
      isLeft
    ),
    [
      x3,
      y3,
      width,
      halfHeight,
      isLeft
    ]
  );
  return /* @__PURE__ */ jsxs(
    "g",
    {
      className: styles$2.wrapper,
      fill: color,
      stroke: color,
      onMouseDown: handleFixWidth,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: d4,
            className: styles$2.mainPath
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            x: isLeft ? x3 - width - 2 : x3 - 2,
            y: y3 - 5,
            width: width + 5,
            height: height + 5,
            className: styles$2.clickZone
          }
        ),
        /* @__PURE__ */ jsx("polygon", { points: trianglePoints })
      ]
    }
  );
};
const BarFixWidth = memo(BarFixWidthInner);
const BarRelationHandleInner = ({
  dataTestid,
  isRelationDrawMode,
  radius,
  startDrawRelation,
  x: x3,
  y: y3
}) => {
  return /* @__PURE__ */ jsx(
    "circle",
    {
      "data-testid": dataTestid,
      cx: x3,
      cy: y3,
      r: radius,
      className: `${styles$5.barRelationHandle} ${isRelationDrawMode ? styles$5.barRelationHandle_drawMode : ""}`,
      onMouseDown: startDrawRelation,
      onTouchStart: startDrawRelation
    }
  );
};
const BarRelationHandle = memo(BarRelationHandleInner);
const TaskItemInner = (props) => {
  const {
    childOutOfParentWarnings,
    colorStyles: stylesProp,
    distances: {
      arrowIndent,
      handleWidth,
      taskWarningOffset,
      relationCircleOffset,
      relationCircleRadius
    },
    fixEndPosition = void 0,
    fixStartPosition = void 0,
    getTaskGlobalIndexByRef,
    handleDeleteTasks,
    hasDependencyWarning,
    isDateChangeable,
    isDelete,
    isSelected,
    onClick = void 0,
    onDoubleClick = void 0,
    onEventStart,
    onRelationStart,
    authorizedRelations,
    isRelationChangeable,
    ganttRelationEvent,
    rtl,
    selectTaskOnMouseDown,
    setTooltipTask,
    task,
    task: { styles: taskStyles },
    taskHalfHeight,
    taskHeight,
    taskYOffset,
    width,
    x1,
    x2: x22
  } = props;
  const taskRootRef = useRef(null);
  const styles2 = useMemo(() => {
    if (taskStyles) {
      return {
        ...stylesProp,
        ...taskStyles
      };
    }
    return stylesProp;
  }, [taskStyles, stylesProp]);
  const outOfParentWarnings = useMemo(() => {
    if (!childOutOfParentWarnings) {
      return void 0;
    }
    const { id, comparisonLevel = 1 } = task;
    const warningsByLevel = childOutOfParentWarnings.get(comparisonLevel);
    if (!warningsByLevel) {
      return void 0;
    }
    return warningsByLevel.get(id);
  }, [task, childOutOfParentWarnings]);
  const handleFixStartPosition = useCallback(() => {
    if (!outOfParentWarnings || !fixStartPosition) {
      return;
    }
    const { start } = outOfParentWarnings;
    if (!start) {
      return;
    }
    const globalIndex = getTaskGlobalIndexByRef(task);
    fixStartPosition(task, start.date, globalIndex);
  }, [task, fixStartPosition, outOfParentWarnings, getTaskGlobalIndexByRef]);
  const handleFixEndPosition = useCallback(() => {
    if (!outOfParentWarnings || !fixEndPosition) {
      return;
    }
    const { end } = outOfParentWarnings;
    if (!end) {
      return;
    }
    const globalIndex = getTaskGlobalIndexByRef(task);
    fixEndPosition(task, end.date, globalIndex);
  }, [task, fixEndPosition, outOfParentWarnings, getTaskGlobalIndexByRef]);
  const handleClick = useCallback(
    (event) => {
      if (onClick) {
        onClick(task, event);
      }
    },
    [onClick, task]
  );
  const handleDoubleClick = useCallback(() => {
    if (onDoubleClick) {
      onDoubleClick(task);
    }
  }, [onDoubleClick, task]);
  const onTaskEventStart = useCallback(
    (action, clientX) => {
      if (!isDateChangeable) {
        return;
      }
      const taskRootNode = taskRootRef.current;
      if (taskRootNode) {
        onEventStart(action, task, clientX, taskRootNode);
      }
    },
    [isDateChangeable, onEventStart, task]
  );
  const onLeftRelationTriggerMouseDown = useCallback(() => {
    onRelationStart(rtl ? "endOfTask" : "startOfTask", task);
  }, [onRelationStart, rtl, task]);
  const onRightRelationTriggerMouseDown = useCallback(() => {
    onRelationStart(rtl ? "startOfTask" : "endOfTask", task);
  }, [onRelationStart, rtl, task]);
  const textRef = useRef(null);
  const [isTextInside, setIsTextInside] = useState(true);
  const taskItem = useMemo(() => {
    const isFromStartRelationAuthorized = authorizedRelations.includes("startToStart") || authorizedRelations.includes("startToEnd");
    const isFromEndRelationAuthorized = authorizedRelations.includes("endToEnd") || authorizedRelations.includes("endToStart");
    const isToStartRelationAuthorized = (ganttRelationEvent == null ? void 0 : ganttRelationEvent.extremity) === "startOfTask" && authorizedRelations.includes("startToStart") || (ganttRelationEvent == null ? void 0 : ganttRelationEvent.extremity) === "endOfTask" && authorizedRelations.includes("endToStart");
    const isToEndRelationAuthorized = (ganttRelationEvent == null ? void 0 : ganttRelationEvent.extremity) === "startOfTask" && authorizedRelations.includes("startToEnd") || (ganttRelationEvent == null ? void 0 : ganttRelationEvent.extremity) === "endOfTask" && authorizedRelations.includes("endToEnd");
    let displayLeftRelationHandle = false;
    if (ganttRelationEvent && task !== ganttRelationEvent.task) {
      displayLeftRelationHandle = rtl ? isToEndRelationAuthorized : isToStartRelationAuthorized;
    } else {
      displayLeftRelationHandle = rtl ? isFromEndRelationAuthorized : isFromStartRelationAuthorized;
    }
    let displayRightRelationHandle = false;
    if (ganttRelationEvent && task !== ganttRelationEvent.task) {
      displayRightRelationHandle = rtl ? isToStartRelationAuthorized : isToEndRelationAuthorized;
    } else {
      displayRightRelationHandle = rtl ? isFromStartRelationAuthorized : isFromEndRelationAuthorized;
    }
    const isSmallBar = width < handleWidth * 2;
    const relationhandles = /* @__PURE__ */ jsxs(Fragment$1, { children: [
      isRelationChangeable && displayLeftRelationHandle && /* @__PURE__ */ jsx(
        BarRelationHandle,
        {
          dataTestid: `task-relation-handle-left-${task.name}`,
          isRelationDrawMode: !!ganttRelationEvent,
          x: x1 - relationCircleOffset,
          y: taskYOffset + taskHalfHeight,
          radius: relationCircleRadius,
          startDrawRelation: onLeftRelationTriggerMouseDown
        }
      ),
      isRelationChangeable && displayRightRelationHandle && /* @__PURE__ */ jsx(
        BarRelationHandle,
        {
          dataTestid: `task-relation-handle-right-${task.name}`,
          isRelationDrawMode: !!ganttRelationEvent,
          x: !isSmallBar ? x22 + relationCircleOffset : x1 + 2 * handleWidth + relationCircleOffset,
          y: taskYOffset + taskHalfHeight,
          radius: relationCircleRadius,
          startDrawRelation: onRightRelationTriggerMouseDown
        }
      )
    ] });
    if (task.type === "milestone") {
      return /* @__PURE__ */ jsx(
        Milestone,
        {
          ...props,
          colorStyles: styles2,
          onTaskEventStart,
          children: relationhandles
        }
      );
    } else if (isSmallBar) {
      return /* @__PURE__ */ jsx(
        BarSmall,
        {
          ...props,
          colorStyles: styles2,
          onTaskEventStart,
          children: relationhandles
        }
      );
    } else
      return /* @__PURE__ */ jsx(
        Bar,
        {
          ...props,
          onTaskEventStart,
          colorStyles: styles2,
          children: relationhandles
        }
      );
  }, [
    handleWidth,
    isSelected,
    outOfParentWarnings,
    props,
    styles2,
    task,
    width
  ]);
  useEffect(() => {
    if (textRef.current) {
      setIsTextInside(textRef.current.getBBox().width < width);
    }
  }, [textRef, width]);
  const x3 = useMemo(() => {
    if (isTextInside) {
      return x1 + width * 0.5;
    }
    if (rtl && textRef.current) {
      return x1 - textRef.current.getBBox().width - arrowIndent * 0.8;
    }
    return x1 + width + arrowIndent * 1.2;
  }, [x1, width, isTextInside, rtl, arrowIndent]);
  const onMouseDown = useCallback(
    (event) => {
      selectTaskOnMouseDown(task.id, event);
    },
    [selectTaskOnMouseDown, task]
  );
  const onMouseEnter = useCallback(
    (event) => {
      setTooltipTask(task, event.currentTarget);
    },
    [setTooltipTask, task]
  );
  const onMouseLeave = useCallback(() => {
    setTooltipTask(null, null);
  }, [setTooltipTask]);
  let barLabelFill = isTextInside || task.type == "milestone" ? styles2.barLabelColor : styles2.barLabelWhenOutsideColor;
  return /* @__PURE__ */ jsxs(
    "g",
    {
      className: fixWidthContainerClass,
      onKeyDown: (e2) => {
        switch (e2.key) {
          case "Delete": {
            if (isDelete) {
              handleDeleteTasks([task]);
            }
            break;
          }
        }
        e2.stopPropagation();
      },
      onMouseDown,
      onMouseEnter,
      onMouseLeave,
      onClick: handleClick,
      onDoubleClick: handleDoubleClick,
      ref: taskRootRef,
      children: [
        taskItem,
        /* @__PURE__ */ jsx(
          "text",
          {
            fill: barLabelFill,
            x: x3,
            y: taskYOffset + taskHeight * 0.5,
            className: isTextInside ? style.barLabel : style.barLabel && style.barLabelOutside,
            ref: textRef,
            children: task.name
          }
        ),
        (outOfParentWarnings || hasDependencyWarning) && /* @__PURE__ */ jsx(
          TaskWarning,
          {
            taskHalfHeight,
            taskWarningOffset,
            rtl,
            outOfParentWarnings,
            hasDependencyWarning,
            taskYOffset,
            x1,
            x2: x22
          }
        ),
        outOfParentWarnings && /* @__PURE__ */ jsxs(Fragment$1, { children: [
          outOfParentWarnings.start && /* @__PURE__ */ jsx(
            BarFixWidth,
            {
              x: rtl ? x22 : x1,
              y: taskYOffset + taskHeight,
              height: 16,
              width: 10,
              isLeft: outOfParentWarnings.start.isOutside !== rtl,
              color: "grey",
              handleFixWidth: handleFixStartPosition
            }
          ),
          outOfParentWarnings.end && /* @__PURE__ */ jsx(
            BarFixWidth,
            {
              x: rtl ? x1 : x22,
              y: taskYOffset + taskHeight,
              height: 16,
              width: 10,
              isLeft: outOfParentWarnings.end.isOutside === rtl,
              color: "grey",
              handleFixWidth: handleFixEndPosition
            }
          )
        ] })
      ]
    }
  );
};
const TaskItem = memo(TaskItemInner);
const checkTaskHasDependencyWarning = (task, taskToHasDependencyWarningMap) => {
  const {
    id,
    comparisonLevel = 1
  } = task;
  const hasWarningsAtLevelSet = taskToHasDependencyWarningMap.get(comparisonLevel);
  if (!hasWarningsAtLevelSet) {
    return false;
  }
  return hasWarningsAtLevelSet.has(id) || false;
};
const TaskGanttContent = ({
  authorizedRelations,
  additionalLeftSpace,
  additionalRightSpace,
  childOutOfParentWarnings,
  childTasksMap,
  colorStyles,
  comparisonLevels,
  criticalPaths,
  dependencyMap,
  dependentMap,
  distances,
  fixEndPosition = void 0,
  fixStartPosition = void 0,
  fontFamily,
  fontSize,
  fullRowHeight,
  ganttRelationEvent,
  getTaskCoordinates: getTaskCoordinates2,
  getTaskGlobalIndexByRef,
  handleBarRelationStart,
  handleDeleteTasks,
  handleFixDependency,
  handleTaskDragStart,
  isShowDependencyWarnings,
  mapGlobalRowIndexToTask,
  onArrowDoubleClick,
  onArrowClick,
  onDoubleClick,
  onClick,
  renderedRowIndexes,
  rtl,
  selectTaskOnMouseDown,
  selectedIdsMirror,
  setTooltipTask,
  taskToHasDependencyWarningMap,
  taskYOffset,
  taskHeight,
  taskHalfHeight,
  visibleTasksMirror
}) => {
  const [renderedTasks, renderedArrows, renderedSelectedTasks] = useMemo(() => {
    if (!renderedRowIndexes) {
      return [null, null, null];
    }
    const [start, end] = renderedRowIndexes;
    const tasksRes = [];
    const arrowsRes = [];
    const selectedTasksRes = [];
    const addedSelectedTasks = {};
    const addedDependencies = {};
    for (let index2 = start; index2 <= end; ++index2) {
      const task = mapGlobalRowIndexToTask.get(index2);
      if (!task) {
        continue;
      }
      const { comparisonLevel = 1, id: taskId } = task;
      if (selectedIdsMirror[taskId] && !addedSelectedTasks[taskId]) {
        addedSelectedTasks[taskId] = true;
        selectedTasksRes.push(
          /* @__PURE__ */ jsx(
            "rect",
            {
              x: 0,
              y: Math.floor(index2 / comparisonLevels) * fullRowHeight,
              width: "100%",
              height: fullRowHeight,
              fill: colorStyles.selectedTaskBackgroundColor
            },
            taskId
          )
        );
      }
      if (comparisonLevel > comparisonLevels) {
        continue;
      }
      if (task.type === "empty") {
        continue;
      }
      const key = `${comparisonLevel}_${task.id}`;
      const criticalPathOnLevel = criticalPaths ? criticalPaths.get(comparisonLevel) : void 0;
      const isCritical = criticalPathOnLevel ? criticalPathOnLevel.tasks.has(task.id) : false;
      const {
        containerX,
        containerWidth,
        innerX1,
        innerX2,
        width,
        levelY,
        progressWidth,
        x1: taskX1,
        x2: taskX2
      } = getTaskCoordinates2(task);
      tasksRes.push(
        /* @__PURE__ */ jsx(
          "svg",
          {
            id: task.id,
            className: "TaskItemClassName",
            x: containerX + (additionalLeftSpace || 0),
            y: levelY,
            width: containerWidth,
            height: fullRowHeight,
            children: /* @__PURE__ */ jsx(
              TaskItem,
              {
                getTaskGlobalIndexByRef,
                hasChildren: checkHasChildren(task, childTasksMap),
                hasDependencyWarning: taskToHasDependencyWarningMap ? checkTaskHasDependencyWarning(
                  task,
                  taskToHasDependencyWarningMap
                ) : false,
                progressWidth,
                progressX: rtl ? innerX2 : innerX1,
                selectTaskOnMouseDown,
                task,
                taskYOffset,
                width,
                x1: innerX1,
                x2: innerX2,
                childOutOfParentWarnings,
                distances,
                taskHeight,
                taskHalfHeight,
                isProgressChangeable: !task.isDisabled,
                isDateChangeable: !task.isDisabled,
                isRelationChangeable: !task.isRelationDisabled,
                authorizedRelations,
                ganttRelationEvent,
                isDelete: !task.isDisabled,
                onDoubleClick,
                onClick,
                onEventStart: handleTaskDragStart,
                setTooltipTask,
                onRelationStart: handleBarRelationStart,
                isSelected: Boolean(selectedIdsMirror[taskId]),
                isCritical,
                rtl,
                fixStartPosition,
                fixEndPosition,
                handleDeleteTasks,
                colorStyles
              }
            )
          },
          key
        )
      );
      const addedDependenciesAtLevel = addedDependencies[comparisonLevel] || {};
      if (!addedDependencies[comparisonLevel]) {
        addedDependencies[comparisonLevel] = addedDependenciesAtLevel;
      }
      const addedDependenciesAtTask = addedDependenciesAtLevel[taskId] || {};
      if (!addedDependenciesAtLevel[taskId]) {
        addedDependenciesAtLevel[taskId] = addedDependenciesAtTask;
      }
      const dependenciesAtLevel = dependencyMap.get(comparisonLevel);
      if (!dependenciesAtLevel) {
        continue;
      }
      const dependenciesByTask = dependenciesAtLevel.get(taskId);
      if (dependenciesByTask) {
        const criticalPathForTask = criticalPathOnLevel ? criticalPathOnLevel.dependencies.get(task.id) : void 0;
        dependenciesByTask.filter(({ source }) => visibleTasksMirror[source.id]).forEach(
          ({
            containerHeight,
            containerY,
            innerFromY,
            innerToY,
            marginBetweenTasks,
            ownTarget,
            source,
            sourceTarget
          }) => {
            if (addedDependenciesAtTask[source.id]) {
              return;
            }
            addedDependenciesAtTask[source.id] = true;
            const isCritical2 = criticalPathForTask ? criticalPathForTask.has(source.id) : false;
            const { x1: fromX1, x2: fromX2 } = getTaskCoordinates2(source);
            const containerX2 = Math.min(fromX1, taskX1) - 300;
            const containerWidth2 = Math.max(fromX2, taskX2) - containerX2 + 300;
            arrowsRes.push(
              /* @__PURE__ */ jsx(
                "svg",
                {
                  className: "ArrowClassName",
                  x: containerX2 + (additionalLeftSpace || 0),
                  y: containerY,
                  width: containerWidth2,
                  height: containerHeight,
                  children: /* @__PURE__ */ jsx(
                    Arrow,
                    {
                      colorStyles,
                      distances,
                      taskFrom: source,
                      extremityFrom: sourceTarget,
                      fromX1: fromX1 - containerX2,
                      fromX2: fromX2 - containerX2,
                      fromY: innerFromY,
                      taskTo: task,
                      extremityTo: ownTarget,
                      toX1: taskX1 - containerX2,
                      toX2: taskX2 - containerX2,
                      toY: innerToY,
                      marginBetweenTasks,
                      fullRowHeight,
                      taskHeight,
                      isShowDependencyWarnings,
                      isCritical: isCritical2,
                      rtl,
                      onArrowDoubleClick,
                      onArrowClick,
                      handleFixDependency
                    }
                  )
                },
                `Arrow from ${source.id} to ${taskId} on ${comparisonLevel}`
              )
            );
          }
        );
      }
      const dependentsAtLevel = dependentMap.get(comparisonLevel);
      if (!dependentsAtLevel) {
        continue;
      }
      const dependentsByTask = dependentsAtLevel.get(taskId);
      if (dependentsByTask) {
        dependentsByTask.filter(({ dependent }) => visibleTasksMirror[dependent.id]).forEach(
          ({
            containerHeight,
            containerY,
            innerFromY,
            innerToY,
            marginBetweenTasks,
            ownTarget,
            dependent,
            dependentTarget
          }) => {
            const addedDependenciesAtDependent = addedDependenciesAtLevel[dependent.id] || {};
            if (!addedDependenciesAtLevel[dependent.id]) {
              addedDependenciesAtLevel[dependent.id] = addedDependenciesAtDependent;
            }
            if (addedDependenciesAtDependent[taskId]) {
              return;
            }
            addedDependenciesAtDependent[taskId] = true;
            const criticalPathForTask = criticalPathOnLevel ? criticalPathOnLevel.dependencies.get(dependent.id) : void 0;
            const isCritical2 = criticalPathForTask ? criticalPathForTask.has(task.id) : false;
            const { x1: toX1, x2: toX2 } = getTaskCoordinates2(dependent);
            const containerX2 = Math.min(toX1, taskX1) - 300;
            const containerWidth2 = Math.max(toX2, taskX2) - containerX2 + 300;
            arrowsRes.push(
              /* @__PURE__ */ jsx(
                "svg",
                {
                  x: containerX2 + (additionalLeftSpace || 0),
                  y: containerY,
                  width: containerWidth2,
                  height: containerHeight,
                  children: /* @__PURE__ */ jsx(
                    Arrow,
                    {
                      colorStyles,
                      distances,
                      taskFrom: task,
                      extremityFrom: ownTarget,
                      fromX1: taskX1 - containerX2,
                      fromX2: taskX2 - containerX2,
                      fromY: innerFromY,
                      taskTo: dependent,
                      extremityTo: dependentTarget,
                      toX1: toX1 - containerX2,
                      toX2: toX2 - containerX2,
                      toY: innerToY,
                      marginBetweenTasks,
                      fullRowHeight,
                      taskHeight,
                      isShowDependencyWarnings,
                      isCritical: isCritical2,
                      rtl,
                      onArrowDoubleClick,
                      onArrowClick,
                      handleFixDependency
                    }
                  )
                },
                `Arrow from ${taskId} to ${dependent.id} on ${comparisonLevel}`
              )
            );
          }
        );
      }
    }
    return [tasksRes, arrowsRes, selectedTasksRes];
  }, [
    additionalLeftSpace,
    additionalRightSpace,
    colorStyles,
    dependencyMap,
    dependentMap,
    fullRowHeight,
    ganttRelationEvent,
    getTaskCoordinates2,
    mapGlobalRowIndexToTask,
    renderedRowIndexes,
    selectTaskOnMouseDown,
    selectedIdsMirror,
    visibleTasksMirror
  ]);
  return /* @__PURE__ */ jsxs("g", { className: "content", children: [
    renderedSelectedTasks,
    /* @__PURE__ */ jsx(
      "g",
      {
        className: "arrows",
        fill: colorStyles.arrowColor,
        stroke: colorStyles.arrowColor,
        children: renderedArrows
      }
    ),
    /* @__PURE__ */ jsx("g", { className: "bar", fontFamily, fontSize, children: renderedTasks }),
    ganttRelationEvent && /* @__PURE__ */ jsx(
      RelationLine,
      {
        x1: ganttRelationEvent.startX,
        x2: ganttRelationEvent.endX,
        y1: ganttRelationEvent.startY,
        y2: ganttRelationEvent.endY
      }
    )
  ] });
};
const ganttTaskRoot = "_ganttTaskRoot_1sr1d_1";
const ganttTaskContent = "_ganttTaskContent_1sr1d_41";
const wrapper = "_wrapper_1sr1d_54";
const styles$1 = {
  ganttTaskRoot,
  ganttTaskContent,
  wrapper
};
const TaskGanttInner = (props) => {
  const {
    barProps,
    barProps: { additionalLeftSpace },
    calendarProps,
    fullRowHeight,
    fullSvgWidth,
    ganttFullHeight,
    ganttSVGRef,
    gridProps,
    distances: { columnWidth, rowHeight, minimumRowDisplayed },
    ganttTaskContentRef,
    onVerticalScrollbarScrollX,
    ganttTaskRootRef,
    onScrollGanttContentVertically: onScrollVertically,
    colors
  } = props;
  const containerStyle = {
    // In order to see the vertical scrollbar of the gantt content,
    // we resize dynamically the width of the gantt content
    height: Math.max(ganttFullHeight, minimumRowDisplayed * rowHeight),
    width: (ganttTaskRootRef == null ? void 0 : ganttTaskRootRef.current) ? ganttTaskRootRef.current.clientWidth + ganttTaskRootRef.current.scrollLeft : fullSvgWidth
  };
  const gridStyle = useMemo(
    () => ({
      height: Math.max(ganttFullHeight, minimumRowDisplayed * rowHeight),
      width: fullSvgWidth,
      backgroundSize: `${columnWidth}px ${fullRowHeight * 2}px`,
      backgroundPositionX: additionalLeftSpace || void 0,
      backgroundImage: [
        `linear-gradient(to right, #ebeff2 1px, transparent 2px)`,
        `linear-gradient(to bottom, transparent ${fullRowHeight}px, #f5f5f5 ${fullRowHeight}px)`
      ].join(", ")
    }),
    [
      additionalLeftSpace,
      columnWidth,
      fullRowHeight,
      fullSvgWidth,
      ganttFullHeight
    ]
  );
  const [arrowAnchorEl, setArrowAnchorEl] = React__default.useState(
    null
  );
  const [selectedDependency, setSelectedDependency] = React__default.useState(null);
  const isArrowContextualPaletteOpened = Boolean(arrowAnchorEl);
  const onClickArrow = (taskFrom, extremityFrom, taskTo, extremityTo, event) => {
    setArrowAnchorEl(event.currentTarget);
    setSelectedDependency({ taskFrom, extremityFrom, taskTo, extremityTo });
  };
  const onCloseArrowContextualPalette = () => {
    setArrowAnchorEl(null);
  };
  let arrowContextualPalette = void 0;
  if (barProps.TaskDependencyContextualPalette && selectedDependency) {
    arrowContextualPalette = React__default.createElement(
      barProps.TaskDependencyContextualPalette,
      {
        taskFrom: selectedDependency.taskFrom,
        extremityFrom: selectedDependency.extremityFrom,
        taskTo: selectedDependency.taskTo,
        extremityTo: selectedDependency.extremityTo,
        onClosePalette: onCloseArrowContextualPalette
      }
    );
  } else {
    arrowContextualPalette = /* @__PURE__ */ jsx("div", {});
  }
  const onArrowClickAway = (e2) => {
    var _a;
    const svgElement = e2.target;
    if (svgElement) {
      const keepPalette = (_a = svgElement.ownerSVGElement) == null ? void 0 : _a.classList.contains("ArrowClassName");
      if (!keepPalette) {
        setArrowAnchorEl(null);
        setSelectedDependency(null);
      }
    }
  };
  const [anchorEl, setAnchorEl] = React__default.useState(null);
  const [selectedTask, setSelectedTask] = React__default.useState(null);
  const open = Boolean(anchorEl);
  const onClickTask = (task, event) => {
    setAnchorEl(event.currentTarget);
    setSelectedTask(task);
    barProps.onClick(task, event);
  };
  const onClose = () => {
    setAnchorEl(null);
  };
  let contextualPalette = void 0;
  if (barProps.ContextualPalette && selectedTask) {
    contextualPalette = React__default.createElement(barProps.ContextualPalette, {
      selectedTask,
      onClosePalette: onClose
    });
  } else {
    contextualPalette = /* @__PURE__ */ jsx("div", {});
  }
  const onClickAway = (e2) => {
    var _a;
    const svgElement = e2.target;
    if (svgElement) {
      const keepPalette = (_a = svgElement.ownerSVGElement) == null ? void 0 : _a.classList.contains("TaskItemClassName");
      if (!keepPalette) {
        setAnchorEl(null);
        setSelectedTask(null);
      }
    }
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: styles$1.ganttTaskRoot,
      ref: ganttTaskRootRef,
      onScroll: onVerticalScrollbarScrollX,
      dir: "ltr",
      children: [
        /* @__PURE__ */ jsx(Calendar, { ...calendarProps, colors }),
        /* @__PURE__ */ jsxs(
          "div",
          {
            ref: ganttTaskContentRef,
            className: styles$1.ganttTaskContent,
            style: containerStyle,
            onScroll: onScrollVertically,
            children: [
              /* @__PURE__ */ jsx("div", { style: gridStyle, children: /* @__PURE__ */ jsxs(
                "svg",
                {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: fullSvgWidth,
                  height: ganttFullHeight,
                  fontFamily: barProps.fontFamily,
                  ref: ganttSVGRef,
                  style: {
                    background: colors.oddTaskBackgroundColor
                  },
                  children: [
                    /* @__PURE__ */ jsx(Grid, { ...gridProps }),
                    /* @__PURE__ */ jsx(
                      TaskGanttContent,
                      {
                        ...barProps,
                        onClick: onClickTask,
                        onArrowClick: onClickArrow
                      }
                    )
                  ]
                }
              ) }),
              barProps.ContextualPalette && open && /* @__PURE__ */ jsx(ClickAwayListener, { onClickAway, children: /* @__PURE__ */ jsx(
                Popper,
                {
                  open,
                  anchorEl,
                  disablePortal: true,
                  placement: "top",
                  children: /* @__PURE__ */ jsx(Paper, { children: contextualPalette })
                },
                `contextual-palette`
              ) }),
              barProps.TaskDependencyContextualPalette && isArrowContextualPaletteOpened && /* @__PURE__ */ jsx(ClickAwayListener, { onClickAway: onArrowClickAway, children: /* @__PURE__ */ jsx(
                Popper,
                {
                  open: isArrowContextualPaletteOpened,
                  anchorEl: arrowAnchorEl,
                  disablePortal: true,
                  placement: "top",
                  children: /* @__PURE__ */ jsx(Paper, { children: arrowContextualPalette })
                },
                `dependency-contextual-palette`
              ) })
            ]
          }
        )
      ]
    }
  );
};
const TaskGantt = memo(TaskGanttInner);
const sortTasks = (taskA, taskB) => {
  const orderA = taskA.displayOrder || Number.MAX_VALUE;
  const orderB = taskB.displayOrder || Number.MAX_VALUE;
  if (orderA > orderB) {
    return 1;
  }
  if (orderA < orderB) {
    return -1;
  }
  return 0;
};
const getChildsAndRoots = (tasks, checkIsRoot) => {
  const childRes = /* @__PURE__ */ new Map();
  const rootRes = /* @__PURE__ */ new Map();
  tasks.forEach((task) => {
    const {
      parent,
      comparisonLevel = 1
    } = task;
    if (!parent || checkIsRoot && checkIsRoot(task)) {
      const rootOnLevel = rootRes.get(comparisonLevel) || [];
      rootRes.set(comparisonLevel, [...rootOnLevel, task]);
      return;
    }
    const parentsByLevel = childRes.get(comparisonLevel) || /* @__PURE__ */ new Map();
    const prevValue = parentsByLevel.get(parent) || [];
    parentsByLevel.set(parent, [...prevValue, task]);
    childRes.set(comparisonLevel, parentsByLevel);
  });
  return [childRes, rootRes];
};
const getMapTaskToCoordinatesOnLevel = (task, mapTaskToCoordinates) => {
  const {
    comparisonLevel = 1
  } = task;
  const mapTaskToCoordinatesOnLevel = mapTaskToCoordinates.get(comparisonLevel);
  if (!mapTaskToCoordinatesOnLevel) {
    throw new Error(`Coordinates on level ${comparisonLevel} are not found`);
  }
  return mapTaskToCoordinatesOnLevel;
};
const getCoordinatesOnLevel = (taskId, mapTaskToCoordinatesOnLevel) => {
  const coordinates = mapTaskToCoordinatesOnLevel.get(taskId);
  if (!coordinates) {
    throw new Error(`Coordinates are not found for task ${taskId}`);
  }
  return coordinates;
};
const getTaskCoordinates = (task, mapTaskToCoordinates) => {
  const {
    id
  } = task;
  const mapTaskToCoordinatesOnLevel = getMapTaskToCoordinatesOnLevel(task, mapTaskToCoordinates);
  return getCoordinatesOnLevel(id, mapTaskToCoordinatesOnLevel);
};
const getTasksMap = (tasks) => {
  const res = /* @__PURE__ */ new Map();
  tasks.forEach((task) => {
    const {
      comparisonLevel = 1,
      id
    } = task;
    const tasksByLevel = res.get(comparisonLevel) || /* @__PURE__ */ new Map();
    tasksByLevel.set(id, task);
    res.set(comparisonLevel, tasksByLevel);
  });
  return res;
};
const getMapTaskToGlobalIndex = (tasks) => {
  const res = /* @__PURE__ */ new Map();
  tasks.forEach((task, index2) => {
    const {
      id,
      comparisonLevel = 1
    } = task;
    const indexesByLevel = res.get(comparisonLevel) || /* @__PURE__ */ new Map();
    indexesByLevel.set(id, index2);
    res.set(comparisonLevel, indexesByLevel);
  });
  return res;
};
const getMapTaskToRowIndex = (visibleTasks, comparisonLevels) => {
  const taskToRowIndexRes = /* @__PURE__ */ new Map();
  const rowIndexToTaskRes = /* @__PURE__ */ new Map();
  const globalIndexToTaskRes = /* @__PURE__ */ new Map();
  const indexesByLevels = {};
  visibleTasks.forEach((task) => {
    const {
      id,
      comparisonLevel = 1
    } = task;
    if (!indexesByLevels[comparisonLevel]) {
      indexesByLevels[comparisonLevel] = 0;
    }
    const index2 = indexesByLevels[comparisonLevel];
    ++indexesByLevels[comparisonLevel];
    const indexesMapByLevel = taskToRowIndexRes.get(comparisonLevel) || /* @__PURE__ */ new Map();
    indexesMapByLevel.set(id, index2);
    taskToRowIndexRes.set(comparisonLevel, indexesMapByLevel);
    const rowIndexToTaskAtLevelMap = rowIndexToTaskRes.get(comparisonLevel) || /* @__PURE__ */ new Map();
    rowIndexToTaskAtLevelMap.set(index2, task);
    rowIndexToTaskRes.set(comparisonLevel, rowIndexToTaskAtLevelMap);
    const absoluteIndex = index2 * comparisonLevels + (comparisonLevel - 1);
    globalIndexToTaskRes.set(absoluteIndex, task);
  });
  return [taskToRowIndexRes, rowIndexToTaskRes, globalIndexToTaskRes];
};
const compareDates = (date1, date2) => {
  const time1 = date1.getTime();
  const time2 = date2.getTime();
  if (time1 < time2) {
    return -1;
  }
  if (time1 > time2) {
    return 1;
  }
  return 0;
};
const getChildOutOfParentWarnings = (tasks, childTasksMap) => {
  const res = /* @__PURE__ */ new Map();
  tasks.forEach((task) => {
    if (task.type === "empty") {
      return;
    }
    const {
      id,
      comparisonLevel = 1,
      start: taskStart,
      end: taskEnd
    } = task;
    const childsByLevel = childTasksMap.get(comparisonLevel);
    if (!childsByLevel) {
      return;
    }
    const childs = childsByLevel.get(id);
    if (!childs) {
      return;
    }
    const notEmptyChilds = childs.filter(({ type }) => type !== "empty");
    if (notEmptyChilds.length === 0) {
      return;
    }
    let {
      start,
      end
    } = notEmptyChilds[0];
    for (let i2 = 1; i2 < notEmptyChilds.length; ++i2) {
      const {
        start: childStart,
        end: childEnd
      } = notEmptyChilds[i2];
      if (start.getTime() > childStart.getTime()) {
        start = childStart;
      }
      if (end.getTime() < childEnd.getTime()) {
        end = childEnd;
      }
    }
    const startComparisonResult = compareDates(taskStart, start);
    const endComparisonResult = compareDates(taskEnd, end);
    if (startComparisonResult !== 0 || endComparisonResult !== 0) {
      const warnings = {};
      if (startComparisonResult !== 0) {
        warnings.start = {
          isOutside: startComparisonResult > 0,
          date: start
        };
      }
      if (endComparisonResult !== 0) {
        warnings.end = {
          isOutside: endComparisonResult < 0,
          date: end
        };
      }
      const resByLevel = res.get(comparisonLevel) || /* @__PURE__ */ new Map();
      resByLevel.set(id, warnings);
      res.set(comparisonLevel, resByLevel);
    }
  });
  return res;
};
const getDependencyMapAndWarnings = (tasks, visibleTasksMirror, tasksMap, mapTaskToCoordinates, fullRowHeight, isShowDependencyWarnings, isShowCriticalPath) => {
  const dependencyRes = /* @__PURE__ */ new Map();
  const dependentRes = /* @__PURE__ */ new Map();
  const marginsRes = /* @__PURE__ */ new Map();
  const isCollectMargins = isShowDependencyWarnings || isShowCriticalPath;
  tasks.forEach((task) => {
    if (task.type === "empty") {
      return;
    }
    const {
      id,
      dependencies,
      comparisonLevel = 1
    } = task;
    if (!visibleTasksMirror[id]) {
      return;
    }
    const tasksByLevel = tasksMap.get(comparisonLevel);
    if (!dependencies || !tasksByLevel) {
      return;
    }
    const coordinatesOnLevelMap = getMapTaskToCoordinatesOnLevel(task, mapTaskToCoordinates);
    const dependenciesByLevel = dependencyRes.get(comparisonLevel) || /* @__PURE__ */ new Map();
    const dependentsByLevel = dependentRes.get(comparisonLevel) || /* @__PURE__ */ new Map();
    const marginsByLevel = marginsRes.get(comparisonLevel) || /* @__PURE__ */ new Map();
    const dependenciesByTask = dependenciesByLevel.get(id) || [];
    const marginsByTask = marginsByLevel.get(id) || /* @__PURE__ */ new Map();
    const {
      y: toY
    } = getCoordinatesOnLevel(id, coordinatesOnLevelMap);
    dependencies.forEach(({
      sourceId,
      sourceTarget,
      ownTarget
    }) => {
      if (!visibleTasksMirror[sourceId]) {
        return;
      }
      const source = tasksByLevel.get(sourceId);
      if (!source) {
        console.error(`Warning: dependency with id "${sourceId}" is not found`);
        return;
      }
      if (source.type === "empty") {
        return;
      }
      const {
        y: fromY
      } = getCoordinatesOnLevel(sourceId, coordinatesOnLevelMap);
      const minY = Math.min(fromY, toY);
      const maxY = Math.max(fromY, toY);
      const containerY = (Math.floor(minY / fullRowHeight) - 1) * fullRowHeight;
      const containerHeight = maxY - containerY + fullRowHeight;
      let marginBetweenTasks = null;
      if (isCollectMargins) {
        const taskTime = ownTarget === "startOfTask" ? task.start.getTime() : task.end.getTime();
        const sourceTime = sourceTarget === "startOfTask" ? source.start.getTime() : source.end.getTime();
        marginBetweenTasks = taskTime - sourceTime;
        marginsByTask.set(sourceId, marginBetweenTasks);
      }
      const innerFromY = fromY - containerY;
      const innerToY = toY - containerY;
      dependenciesByTask.push({
        containerHeight,
        containerY,
        innerFromY,
        innerToY,
        marginBetweenTasks,
        source,
        sourceTarget,
        ownTarget
      });
      const dependentsByTask = dependentsByLevel.get(sourceId) || [];
      dependentsByTask.push({
        containerHeight,
        containerY,
        innerFromY,
        innerToY,
        marginBetweenTasks,
        dependent: task,
        dependentTarget: ownTarget,
        ownTarget: sourceTarget
      });
      dependentsByLevel.set(sourceId, dependentsByTask);
    });
    dependenciesByLevel.set(id, dependenciesByTask);
    dependencyRes.set(comparisonLevel, dependenciesByLevel);
    dependentRes.set(comparisonLevel, dependentsByLevel);
    if (isCollectMargins) {
      marginsByLevel.set(id, marginsByTask);
      marginsRes.set(comparisonLevel, marginsByLevel);
    }
  });
  return [dependencyRes, dependentRes, marginsRes];
};
const countTaskCoordinates = (task, taskToRowIndexMap, startDate, viewMode, rtl, fullRowHeight, taskHeight, taskYOffset, distances, svgWidth) => {
  const { columnWidth, rowHeight } = distances;
  const { id, comparisonLevel = 1, progress, type } = task;
  const indexesAtLevel = taskToRowIndexMap.get(comparisonLevel);
  if (!indexesAtLevel) {
    throw new Error(`Indexes at level ${comparisonLevel} are not found`);
  }
  const rowIndex = indexesAtLevel.get(id);
  if (typeof rowIndex !== "number") {
    throw new Error(`Row index for task ${id} is not found`);
  }
  const x1 = rtl ? svgWidth - taskXCoordinate(task.end, startDate, viewMode, columnWidth) : taskXCoordinate(task.start, startDate, viewMode, columnWidth);
  const x22 = rtl ? svgWidth - taskXCoordinate(task.start, startDate, viewMode, columnWidth) : taskXCoordinate(task.end, startDate, viewMode, columnWidth);
  const levelY = rowIndex * fullRowHeight + rowHeight * (comparisonLevel - 1);
  const y3 = levelY + taskYOffset;
  const [progressWidth, progressX] = type === "milestone" ? [0, x1] : progressWithByParams(x1, x22, progress, rtl);
  const taskX1 = type === "milestone" ? x1 - taskHeight * 0.5 : x1;
  const taskX2 = type === "milestone" ? x22 + taskHeight * 0.5 : x22;
  const taskWidth = type === "milestone" ? taskHeight : taskX2 - taskX1;
  const containerX = taskX1 - columnWidth;
  const containerWidth = svgWidth - containerX;
  const innerX1 = columnWidth;
  const innerX2 = columnWidth + taskWidth;
  return {
    containerWidth,
    containerX,
    innerX1,
    innerX2,
    levelY,
    progressWidth,
    progressX,
    width: taskWidth,
    x1: taskX1,
    x2: taskX2,
    y: y3
  };
};
const getMapTaskToCoordinates = (tasks, visibleTasksMirror, taskToRowIndexMap, startDate, viewMode, rtl, fullRowHeight, taskHeight, taskYOffset, distances, svgWidth) => {
  const res = /* @__PURE__ */ new Map();
  tasks.forEach((task) => {
    if (task.type === "empty") {
      return;
    }
    const { id, comparisonLevel = 1 } = task;
    if (!visibleTasksMirror[id]) {
      return;
    }
    const taskCoordinates = countTaskCoordinates(
      task,
      taskToRowIndexMap,
      startDate,
      viewMode,
      rtl,
      fullRowHeight,
      taskHeight,
      taskYOffset,
      distances,
      svgWidth
    );
    const resByLevel = res.get(comparisonLevel) || /* @__PURE__ */ new Map();
    resByLevel.set(id, taskCoordinates);
    res.set(comparisonLevel, resByLevel);
  });
  return res;
};
const collectParents = (task, tasksMap) => {
  const checkedTasks = /* @__PURE__ */ new Set();
  const res = [];
  let cur = task;
  while (task.parent != cur.id) {
    const { comparisonLevel = 1, id, parent } = cur;
    if (checkedTasks.has(id)) {
      console.error("Warning: circle of dependencies");
      return res;
    }
    checkedTasks.add(id);
    if (!parent) {
      return res;
    }
    const tasksByLevel = tasksMap.get(comparisonLevel);
    if (!tasksByLevel) {
      return res;
    }
    const parentTask = tasksByLevel.get(parent);
    if (!parentTask || parentTask.type === "empty" || !parentTask.isDisabled) {
      return res;
    }
    res.push(parentTask);
    cur = parentTask;
  }
  return res;
};
const getLatestTasks = (task, childsOnLevel, endTs, checkedTasks) => {
  const { id: taskId } = task;
  if (checkedTasks.has(taskId)) {
    console.error("Warning: circle of dependencies");
    return [];
  }
  checkedTasks.add(taskId);
  const childs = childsOnLevel.get(taskId);
  if (!childs || childs.length === 0) {
    if (task.end.getTime() >= endTs) {
      return [task];
    }
    return [];
  }
  return childs.reduce((res, child) => {
    if (child.type === "empty") {
      return res;
    }
    const childRes = getLatestTasks(child, childsOnLevel, endTs, checkedTasks);
    return [...res, ...childRes];
  }, []);
};
const collectCriticalPath = (criticalPathTasks, criticalPathDependencies, task, target, criticalTs, tasksMap, childsOnLevel, dependenciesOnLevel, dependencyMarginsOnLevel) => {
  const { id: taskId } = task;
  const taskChilds = childsOnLevel.get(taskId);
  if (!taskChilds || taskChilds.length === 0) {
    collectCriticalPathForTask(
      criticalPathTasks,
      criticalPathDependencies,
      task,
      tasksMap,
      childsOnLevel,
      dependenciesOnLevel,
      dependencyMarginsOnLevel
    );
    return;
  }
  taskChilds.forEach((childTask) => {
    if (childTask.type === "empty") {
      return;
    }
    const taskTs = target === "startOfTask" ? childTask.start.getTime() : childTask.end.getTime();
    if (taskTs >= criticalTs) {
      collectCriticalPath(
        criticalPathTasks,
        criticalPathDependencies,
        childTask,
        target,
        criticalTs,
        tasksMap,
        childsOnLevel,
        dependenciesOnLevel,
        dependencyMarginsOnLevel
      );
    }
  });
};
const collectCriticalPathForTask = (criticalPathTasks, criticalPathDependencies, task, tasksMap, childsOnLevel, dependenciesOnLevel, dependencyMarginsOnLevel) => {
  const { end, id: taskId, start } = task;
  if (criticalPathTasks.has(taskId)) {
    return;
  }
  criticalPathTasks.add(taskId);
  const startTs = start.getTime();
  const endTs = end.getTime();
  const criticalPathDependenciesForTask = criticalPathDependencies.get(taskId) || /* @__PURE__ */ new Set();
  const marginsForTask = dependencyMarginsOnLevel.get(taskId);
  const dependencies = dependenciesOnLevel.get(taskId);
  if (dependencies && marginsForTask) {
    dependencies.forEach(({ ownTarget, source, sourceTarget }) => {
      const margin = marginsForTask.get(source.id);
      if (typeof margin !== "number") {
        throw new Error("Margin for dependency is not defined");
      }
      if (margin > 0) {
        return;
      }
      if (criticalPathDependenciesForTask.has(source.id)) {
        return;
      }
      criticalPathDependenciesForTask.add(source.id);
      criticalPathDependencies.set(taskId, criticalPathDependenciesForTask);
      collectCriticalPath(
        criticalPathTasks,
        criticalPathDependencies,
        source,
        sourceTarget,
        ownTarget === "startOfTask" ? startTs : endTs,
        tasksMap,
        childsOnLevel,
        dependenciesOnLevel,
        dependencyMarginsOnLevel
      );
    });
  }
  const parents = collectParents(task, tasksMap);
  parents.forEach((parentTask) => {
    const { id: parentId } = parentTask;
    const parentDependencies = dependenciesOnLevel.get(parentId);
    if (!parentDependencies || parentDependencies.length === 0) {
      return;
    }
    const criticalPathDependenciesForParent = criticalPathDependencies.get(parentId) || /* @__PURE__ */ new Set();
    const isCheckStart = parentTask.start.getTime() >= startTs;
    const isCheckEnd = parentTask.end.getTime() <= endTs;
    parentDependencies.forEach(({ ownTarget, sourceTarget, source }) => {
      const isCheck = ownTarget === "startOfTask" ? isCheckStart : isCheckEnd;
      if (!isCheck) {
        return;
      }
      if (criticalPathDependenciesForTask.has(source.id)) {
        return;
      }
      criticalPathDependenciesForTask.add(source.id);
      criticalPathDependencies.set(parentId, criticalPathDependenciesForParent);
      const targetTs = ownTarget === "startOfTask" ? parentTask.start.getTime() : parentTask.end.getTime();
      collectCriticalPath(
        criticalPathTasks,
        criticalPathDependencies,
        source,
        sourceTarget,
        targetTs,
        tasksMap,
        childsOnLevel,
        dependenciesOnLevel,
        dependencyMarginsOnLevel
      );
    });
  });
};
const getCriticalPath = (rootTasksMap, childTasksMap, tasksMap, dependencyMarginsMap, dependencyMap) => {
  const res = /* @__PURE__ */ new Map();
  for (const [comparisonLevel, rootTasks] of rootTasksMap.entries()) {
    const criticalPathTasks = /* @__PURE__ */ new Set();
    const criticalPathDependencies = /* @__PURE__ */ new Map();
    const childsOnLevel = childTasksMap.get(comparisonLevel);
    if (childsOnLevel) {
      const dependenciesOnLevel = dependencyMap.get(comparisonLevel);
      const dependencyMarginsOnLevel = dependencyMarginsMap.get(comparisonLevel);
      rootTasks.forEach((task) => {
        if (task.type === "empty") {
          return;
        }
        const endTs = task.end.getTime();
        const latestTasks = getLatestTasks(
          task,
          childsOnLevel,
          endTs,
          /* @__PURE__ */ new Set()
        );
        if (!dependenciesOnLevel || !dependencyMarginsOnLevel) {
          latestTasks.forEach(({ id: taskId }) => {
            criticalPathTasks.add(taskId);
          });
          return;
        }
        latestTasks.forEach((task2) => {
          collectCriticalPathForTask(
            criticalPathTasks,
            criticalPathDependencies,
            task2,
            tasksMap,
            childsOnLevel,
            dependenciesOnLevel,
            dependencyMarginsOnLevel
          );
        });
      });
    }
    res.set(comparisonLevel, {
      tasks: criticalPathTasks,
      dependencies: criticalPathDependencies
    });
  }
  return res;
};
const getMapTaskTo = (indexesOnLevel, taskId, level, collectedIndex, childTasksOnLevel) => {
  const childs = childTasksOnLevel.get(taskId);
  if (childs && childs.length > 0) {
    childs.forEach(({
      id: childId
    }, index2) => {
      const childIndex = `${collectedIndex}.${index2 + 1}`;
      indexesOnLevel.set(childId, [level, childIndex]);
      getMapTaskTo(
        indexesOnLevel,
        childId,
        level + 1,
        childIndex,
        childTasksOnLevel
      );
    });
  }
};
const getMapTaskToNestedIndex = (childTasksMap, rootTasksMap) => {
  const res = /* @__PURE__ */ new Map();
  for (const [comparisonLevel, rootTasks] of rootTasksMap.entries()) {
    const indexesOnLevel = /* @__PURE__ */ new Map();
    const childTasksOnLevel = childTasksMap.get(comparisonLevel) || /* @__PURE__ */ new Map();
    rootTasks.forEach(({ id: rootId }, index2) => {
      const rootIndex = `${index2 + 1}`;
      indexesOnLevel.set(rootId, [0, rootIndex]);
      getMapTaskTo(
        indexesOnLevel,
        rootId,
        1,
        rootIndex,
        childTasksOnLevel
      );
    });
    res.set(comparisonLevel, indexesOnLevel);
  }
  return res;
};
const collectChildren = (arrayRes, mirrorRes, task, childTasksOnLevel) => {
  const { comparisonLevel = 1 } = task;
  arrayRes.push(task);
  if (comparisonLevel === 1) {
    mirrorRes[task.id] = true;
  }
  if (task.type === "empty" || task.hideChildren) {
    return;
  }
  const childs = childTasksOnLevel.get(task.id);
  if (childs && childs.length > 0) {
    childs.forEach((childTask) => {
      collectChildren(arrayRes, mirrorRes, childTask, childTasksOnLevel);
    });
  }
};
const collectVisibleTasks = (childTasksMap, rootTasksMap) => {
  const arrayRes = [];
  const mirrorRes = {};
  for (const [comparisonLevel, rootTasks] of rootTasksMap.entries()) {
    const childTasksOnLevel = childTasksMap.get(comparisonLevel) || /* @__PURE__ */ new Map();
    rootTasks.forEach((task) => {
      collectChildren(arrayRes, mirrorRes, task, childTasksOnLevel);
    });
  }
  return [arrayRes, mirrorRes];
};
const checkTaskHasWarning = (dependencyMarginsForTask) => {
  for (let value of dependencyMarginsForTask.values()) {
    if (value < 0) {
      return true;
    }
  }
  return false;
};
const getTaskToHasDependencyWarningMap = (dependencyMarginsMap) => {
  const res = /* @__PURE__ */ new Map();
  for (const [comparisonLevel, marginsByLevel] of dependencyMarginsMap.entries()) {
    const resAtLevel = /* @__PURE__ */ new Set();
    for (const [taskId, dependencyMarginsForTask] of marginsByLevel.entries()) {
      if (checkTaskHasWarning(dependencyMarginsForTask)) {
        resAtLevel.add(taskId);
      }
    }
    res.set(comparisonLevel, resAtLevel);
  }
  return res;
};
const fillDependentTasksForTask = (resSet, task, dependentMap) => {
  const { id: taskId, comparisonLevel = 1 } = task;
  const dependentMapAtLevel = dependentMap.get(comparisonLevel);
  if (!dependentMapAtLevel) {
    return;
  }
  const dependents = dependentMapAtLevel.get(taskId);
  if (!dependents) {
    return;
  }
  dependents.forEach(({ dependent }) => {
    resSet.add(dependent);
  });
};
const getDependentTasks = (changeAction, dependentMap) => {
  const resSet = /* @__PURE__ */ new Set();
  switch (changeAction.type) {
    case "add-childs":
      fillDependentTasksForTask(resSet, changeAction.parent, dependentMap);
      break;
    case "change":
    case "change_start_and_end":
      fillDependentTasksForTask(resSet, changeAction.task, dependentMap);
      break;
    case "delete":
      changeAction.tasks.forEach((task) => {
        fillDependentTasksForTask(resSet, task, dependentMap);
      });
      break;
    case "move-before":
      fillDependentTasksForTask(resSet, changeAction.target, dependentMap);
      break;
    case "move-after":
      fillDependentTasksForTask(resSet, changeAction.target, dependentMap);
      break;
    case "move-inside":
      fillDependentTasksForTask(resSet, changeAction.parent, dependentMap);
      break;
    default:
      throw new Error(
        `Unknown change action: ${changeAction.type}`
      );
  }
  return [...resSet];
};
const getTaskIndex = (task, mapTaskToGlobalIndex) => {
  const { id: taskId, comparisonLevel = 1 } = task;
  const taskIndexMapAtLevel = mapTaskToGlobalIndex.get(comparisonLevel);
  if (!taskIndexMapAtLevel) {
    console.error(`Warning: tasks at level ${comparisonLevel} are not found`);
  }
  const taskIndex = taskIndexMapAtLevel ? taskIndexMapAtLevel.get(taskId) : void 0;
  if (typeof taskIndex !== "number") {
    console.error(`Warning: index for task ${taskId} is not found`);
  }
  return {
    task,
    index: typeof taskIndex === "number" ? taskIndex : -1
  };
};
const getTaskIndexes = (changeAction, mapTaskToGlobalIndex) => {
  switch (changeAction.type) {
    case "add-childs":
      return [getTaskIndex(changeAction.parent, mapTaskToGlobalIndex)];
    case "change":
    case "change_start_and_end":
      return [getTaskIndex(changeAction.task, mapTaskToGlobalIndex)];
    case "delete":
      return changeAction.tasks.map(
        (task) => getTaskIndex(task, mapTaskToGlobalIndex)
      );
    case "move-before":
      return [getTaskIndex(changeAction.target, mapTaskToGlobalIndex)];
    case "move-after":
      return [getTaskIndex(changeAction.target, mapTaskToGlobalIndex)];
    case "move-inside":
      return [getTaskIndex(changeAction.parent, mapTaskToGlobalIndex)];
    default:
      throw new Error(
        `Unknown change action: ${changeAction.type}`
      );
  }
};
const changeStartAndEndDescendants = ({
  adjustTaskToWorkingDates: adjustTaskToWorkingDates2,
  changedTask,
  descendants,
  mapTaskToGlobalIndex,
  originalTask
}) => {
  const diff = differenceInMilliseconds(changedTask.start, originalTask.start);
  const mapTaskToGlobalIndexAtLevel = mapTaskToGlobalIndex.get(
    changedTask.comparisonLevel || 1
  );
  if (!mapTaskToGlobalIndexAtLevel) {
    throw new Error("Tasks are not found in the current level");
  }
  return descendants.reduce((res, task) => {
    if (task.type === "empty") {
      return res;
    }
    const index2 = mapTaskToGlobalIndexAtLevel.get(task.id);
    if (typeof index2 !== "number") {
      throw new Error("Global index for the task is not found");
    }
    const preChangedTask = {
      ...task,
      end: addMilliseconds(task.end, diff),
      start: addMilliseconds(task.start, diff)
    };
    const adjustedTask = adjustTaskToWorkingDates2({
      action: "move",
      changedTask: preChangedTask,
      originalTask: task,
      roundDate: (date) => {
        return date;
      }
    });
    res.push([adjustedTask.start, adjustedTask.end, task, index2]);
    return res;
  }, []);
};
const fillDescendantsForTask = (res, task, childTasksAtLevelMap, isCollectEmpty) => {
  const childs = childTasksAtLevelMap.get(task.id);
  if (!childs) {
    return;
  }
  childs.forEach((child) => {
    if (child.type === "empty") {
      if (isCollectEmpty) {
        res.push(child);
      }
      return;
    }
    res.push(child);
    fillDescendantsForTask(res, child, childTasksAtLevelMap, isCollectEmpty);
  });
};
const getAllDescendants = (task, childTasksMap, isCollectEmpty) => {
  const {
    comparisonLevel = 1
  } = task;
  const childTasksAtLevelMap = childTasksMap.get(comparisonLevel);
  if (!childTasksAtLevelMap) {
    return [];
  }
  const res = [];
  fillDescendantsForTask(res, task, childTasksAtLevelMap, isCollectEmpty);
  return res;
};
const collectSuggestedParents = (changeAction, tasksMap) => {
  switch (changeAction.type) {
    case "add-childs":
      return [
        changeAction.parent,
        ...collectParents(changeAction.parent, tasksMap)
      ];
    case "change":
    case "change_start_and_end":
      return collectParents(changeAction.task, tasksMap);
    case "delete": {
      const resSet = /* @__PURE__ */ new Set();
      changeAction.tasks.forEach((task) => {
        const parents = collectParents(task, tasksMap);
        parents.forEach((parentTask) => {
          resSet.add(parentTask);
        });
      });
      return [...resSet];
    }
    case "move-before":
      return [
        ...collectParents(changeAction.target, tasksMap),
        ...collectParents(changeAction.taskForMove, tasksMap)
      ];
    case "move-after":
      return [
        ...collectParents(changeAction.target, tasksMap),
        ...collectParents(changeAction.taskForMove, tasksMap)
      ];
    case "move-inside": {
      const resSet = /* @__PURE__ */ new Set([changeAction.parent]);
      collectParents(changeAction.parent, tasksMap).forEach((parentTask) => {
        resSet.add(parentTask);
      });
      changeAction.childs.forEach((child) => {
        collectParents(child, tasksMap).forEach((parentTask) => {
          resSet.add(parentTask);
        });
      });
      return [...resSet];
    }
    default:
      throw new Error(
        `Unknown change action: ${changeAction.type}`
      );
  }
};
const getChangeTaskMetadata = ({
  adjustTaskToWorkingDates: adjustTaskToWorkingDates2,
  changeAction,
  childTasksMap,
  dependentMap,
  isMoveChildsWithParent,
  isUpdateDisabledParentsOnChange,
  mapTaskToGlobalIndex,
  tasksMap
}) => {
  const parentSuggestedTasks = isUpdateDisabledParentsOnChange ? collectSuggestedParents(changeAction, tasksMap) : [];
  const parentSuggestions = parentSuggestedTasks.map(
    (parentTask) => getSuggestedStartEndChangesFromDirectChildren(
      parentTask,
      changeAction,
      tasksMap,
      mapTaskToGlobalIndex
    )
  );
  const descendants = isMoveChildsWithParent && changeAction.type === "change_start_and_end" ? getAllDescendants(changeAction.task, childTasksMap, false) : [];
  const descendantSuggestions = changeAction.type === "change_start_and_end" ? changeStartAndEndDescendants({
    adjustTaskToWorkingDates: adjustTaskToWorkingDates2,
    changedTask: changeAction.changedTask,
    descendants,
    mapTaskToGlobalIndex,
    originalTask: changeAction.originalTask
  }) : [];
  const suggestedTasks = [...parentSuggestedTasks, ...descendants];
  const suggestions = [...parentSuggestions, ...descendantSuggestions];
  const taskIndexes = getTaskIndexes(changeAction, mapTaskToGlobalIndex);
  const dependentTasks = getDependentTasks(changeAction, dependentMap);
  return [dependentTasks, taskIndexes, suggestedTasks, suggestions];
};
const getSuggestedStartEndChangesFromDirectChildren = (parentTask, changeAction, tasksMap, mapTaskToGlobalIndex) => {
  const { id, comparisonLevel = 1 } = parentTask;
  let start = parentTask.start;
  let end = parentTask.end;
  const indexesByLevel = mapTaskToGlobalIndex.get(comparisonLevel);
  const index2 = indexesByLevel ? indexesByLevel.get(id) : -1;
  const resIndex = typeof index2 === "number" ? index2 : -1;
  const id2Task = tasksMap.get(comparisonLevel);
  const tasks = Array.from(id2Task.values()).filter(
    ({ type }) => type !== "empty"
  );
  const directChildren = tasks.filter((task) => {
    if (changeAction.type == "delete" && changeAction.tasks.map((t2) => t2.id).includes(task.id))
      return false;
    return task.parent && parentTask.id == task.parent;
  }).map((child) => {
    const type = changeAction.type;
    if (type == "change" || type == "change_start_and_end") {
      if (child.id === changeAction.task.id) {
        if (changeAction.task.type !== "empty") {
          return changeAction.task;
        }
      }
    }
    return child;
  });
  if (directChildren.length > 0) {
    start = directChildren[0].start;
    end = directChildren[0].end;
  }
  directChildren.forEach((task) => {
    if (task.parent && parentTask.id == task.parent) {
      const type = changeAction.type;
      if (type != "delete") {
        if (task.start.getTime() < start.getTime()) {
          start = task.start;
        }
        if (task.end.getTime() > end.getTime()) {
          end = task.end;
        }
      }
    }
  });
  return [start, end, parentTask, resIndex];
};
const checkIsDescendant = (maybeParent, maybeDescendant, tasksMap) => {
  const checkedTasks = /* @__PURE__ */ new Set();
  const {
    comparisonLevel = 1
  } = maybeDescendant;
  if ((maybeParent.comparisonLevel || 1) !== comparisonLevel) {
    return false;
  }
  const tasksOnLevel = tasksMap.get(comparisonLevel);
  if (!tasksOnLevel) {
    throw new Error(`Tasks on level ${comparisonLevel} are not found`);
  }
  let cur = maybeDescendant;
  while (true) {
    const {
      id,
      parent
    } = cur;
    if (!parent) {
      return false;
    }
    if (parent === maybeParent.id) {
      return true;
    }
    if (checkedTasks.has(id)) {
      console.error("Warning: circle of dependencies");
      return false;
    }
    checkedTasks.add(id);
    const parentTask = tasksOnLevel.get(parent);
    if (!parentTask || parentTask.type === "empty") {
      return false;
    }
    cur = parentTask;
  }
};
const getRelationCircleByCoordinates = (svgP, tasks, taskHalfHeight, relationCircleOffset, relationCircleRadius, rtl, mapTaskToCoordinatesOnLevel) => {
  const { x: x3, y: y3 } = svgP;
  for (let i2 = 0, l2 = tasks.length; i2 < l2; ++i2) {
    const task = tasks[i2];
    if (task.type !== "empty") {
      const taskCoordinates = getCoordinatesOnLevel(
        task.id,
        mapTaskToCoordinatesOnLevel
      );
      if (y3 >= taskCoordinates.y + taskHalfHeight - relationCircleRadius && y3 <= taskCoordinates.y + taskHalfHeight + relationCircleRadius) {
        if (x3 >= taskCoordinates.x1 - relationCircleOffset - relationCircleRadius && x3 <= taskCoordinates.x1 - relationCircleOffset + relationCircleRadius) {
          return [task, rtl ? "endOfTask" : "startOfTask"];
        }
        if (x3 >= taskCoordinates.x2 + relationCircleOffset - relationCircleRadius && x3 <= taskCoordinates.x2 + relationCircleOffset + relationCircleRadius) {
          return [task, rtl ? "startOfTask" : "endOfTask"];
        }
      }
    }
  }
  return null;
};
const useCreateRelation = ({
  distances: { relationCircleOffset, relationCircleRadius },
  ganttSVGRef,
  mapTaskToCoordinates,
  mapTaskToGlobalIndex,
  onRelationChange,
  rtl,
  taskHalfHeight,
  tasksMap,
  visibleTasks
}) => {
  const [ganttRelationEvent, setGanttRelationEvent] = useState(null);
  const handleBarRelationStart = useCallback(
    (extremity, task) => {
      const coordinates = getTaskCoordinates(task, mapTaskToCoordinates);
      const startX = extremity === "startOfTask" !== rtl ? coordinates.x1 - 10 : coordinates.x2 + 10;
      const startY = coordinates.y + taskHalfHeight;
      setGanttRelationEvent({
        extremity,
        task,
        startX,
        startY,
        endX: startX,
        endY: startY
      });
    },
    [taskHalfHeight, mapTaskToCoordinates, rtl]
  );
  const startRelationExtremity = ganttRelationEvent == null ? void 0 : ganttRelationEvent.extremity;
  const startRelationTask = ganttRelationEvent == null ? void 0 : ganttRelationEvent.task;
  useEffect(() => {
    if (!onRelationChange || !startRelationExtremity || !startRelationTask) {
      return void 0;
    }
    const svgNode = ganttSVGRef.current;
    if (!svgNode) {
      return void 0;
    }
    const point = svgNode.createSVGPoint();
    const handleMove = (clientX, clientY) => {
      point.x = clientX;
      point.y = clientY;
      const ctm = svgNode.getScreenCTM();
      if (!ctm) {
        return;
      }
      const svgP = point.matrixTransform(ctm.inverse());
      setGanttRelationEvent((prevValue) => {
        if (!prevValue) {
          return null;
        }
        return {
          ...prevValue,
          endX: svgP.x,
          endY: svgP.y
        };
      });
    };
    const handleMouseMove = (event) => {
      const { clientX, clientY } = event;
      handleMove(clientX, clientY);
    };
    let lastTouch = null;
    const handleTouchMove = (event) => {
      const firstTouch = event.touches[0];
      if (firstTouch) {
        const { clientX, clientY } = firstTouch;
        lastTouch = firstTouch;
        handleMove(clientX, clientY);
      }
    };
    const handleEnd = (clientX, clientY) => {
      point.x = clientX;
      point.y = clientY;
      const ctm = svgNode.getScreenCTM();
      if (!ctm) {
        return;
      }
      const svgP = point.matrixTransform(ctm.inverse());
      const endExtremityRelationCircle = getRelationCircleByCoordinates(
        svgP,
        visibleTasks,
        taskHalfHeight,
        relationCircleOffset,
        relationCircleRadius,
        rtl,
        getMapTaskToCoordinatesOnLevel(startRelationTask, mapTaskToCoordinates)
      );
      if (endExtremityRelationCircle) {
        const [endRelationTask, endRelationExtremity] = endExtremityRelationCircle;
        const { comparisonLevel: startComparisonLevel = 1 } = startRelationTask;
        const { comparisonLevel: endComparisonLevel = 1 } = endRelationTask;
        if (startComparisonLevel === endComparisonLevel) {
          const indexesOnLevel = mapTaskToGlobalIndex.get(startComparisonLevel);
          if (!indexesOnLevel) {
            throw new Error(
              `Indexes are not found for level ${startComparisonLevel}`
            );
          }
          const startIndex = indexesOnLevel.get(startRelationTask.id);
          if (typeof startIndex !== "number") {
            throw new Error(
              `Index is not found for task ${startRelationTask.id}`
            );
          }
          const endIndex = indexesOnLevel.get(endRelationTask.id);
          if (typeof endIndex !== "number") {
            throw new Error(
              `Index is not found for task ${endRelationTask.id}`
            );
          }
          const isOneDescendant = checkIsDescendant(startRelationTask, endRelationTask, tasksMap) || checkIsDescendant(endRelationTask, startRelationTask, tasksMap);
          onRelationChange(
            [startRelationTask, startRelationExtremity, startIndex],
            [endRelationTask, endRelationExtremity, endIndex],
            isOneDescendant
          );
        }
      }
      setGanttRelationEvent(null);
    };
    const handleMouseUp = (event) => {
      const { clientX, clientY } = event;
      handleEnd(clientX, clientY);
    };
    const handleTouchEnd = () => {
      if (lastTouch) {
        const { clientX, clientY } = lastTouch;
        handleEnd(clientX, clientY);
      }
    };
    svgNode.addEventListener("mousemove", handleMouseMove);
    svgNode.addEventListener("touchmove", handleTouchMove);
    svgNode.addEventListener("mouseup", handleMouseUp);
    svgNode.addEventListener("touchend", handleTouchEnd);
    return () => {
      svgNode.removeEventListener("mousemove", handleMouseMove);
      svgNode.removeEventListener("touchmove", handleTouchMove);
      svgNode.removeEventListener("mouseup", handleMouseUp);
      svgNode.removeEventListener("touchend", handleTouchEnd);
    };
  }, [
    ganttSVGRef,
    rtl,
    startRelationExtremity,
    startRelationTask,
    setGanttRelationEvent,
    mapTaskToCoordinates,
    visibleTasks,
    tasksMap,
    taskHalfHeight,
    relationCircleOffset,
    relationCircleRadius,
    onRelationChange
  ]);
  return [ganttRelationEvent, handleBarRelationStart];
};
const ROW_DRAG_TYPE = "@@gannt/ROW_DRAG";
const SCROLL_STEP = 10;
const ONE_HOUR_DURATION = 1e3 * 3600 * 1;
const ONE_DAY_DURATION = 1e3 * 3600 * 24;
const roundTaskDates = (task, roundDate, action, dateMoveStep) => {
  switch (task.type) {
    case "milestone":
      return {
        ...task,
        end: roundDate(task.end, action, "endOfTask"),
        start: roundDate(task.start, action, "endOfTask")
      };
    default:
      let start = roundDate(task.start, action, "startOfTask");
      let end = roundDate(task.end, action, "endOfTask");
      if (action == "start" && start.getTime() == end.getTime()) {
        start = decrementDate(
          start,
          action,
          roundDate,
          "startOfTask",
          dateMoveStep,
          true
        );
      } else if (action == "end" && start.getTime() == end.getTime()) {
        end = incrementDate(
          end,
          action,
          roundDate,
          "endOfTask",
          dateMoveStep,
          true
        );
      }
      return {
        ...task,
        start,
        end
      };
  }
};
const incrementDate = (date, action, roundDate, dateExtremity, dateMoveStep, limitDateMoveToOneDay) => {
  const stepTime = getStepTime(dateMoveStep);
  let incrementedDate = date;
  if (limitDateMoveToOneDay && stepTime > ONE_DAY_DURATION) {
    incrementedDate = new Date(date.getTime() + ONE_DAY_DURATION);
  } else {
    incrementedDate = new Date(date.getTime() + stepTime);
    incrementedDate = roundDate(incrementedDate, action, dateExtremity);
  }
  return incrementedDate;
};
const decrementDate = (date, action, roundDate, dateExtremity, dateMoveStep, limitDateMoveToOneDay) => {
  const stepTime = getStepTime(dateMoveStep);
  let decrementedDate = date;
  if (limitDateMoveToOneDay && stepTime > ONE_DAY_DURATION) {
    decrementedDate = new Date(date.getTime() - ONE_DAY_DURATION);
  } else {
    decrementedDate = new Date(date.getTime() - stepTime);
    decrementedDate = roundDate(decrementedDate, action, dateExtremity);
  }
  return decrementedDate;
};
const getStepTime = (dateMoveStep) => {
  let stepTime = ONE_HOUR_DURATION;
  const value = dateMoveStep.value;
  const dimension = dateMoveStep.timeUnit;
  if (dimension == GanttDateRoundingTimeUnit.DAY) {
    stepTime = 1e3 * 3600 * 24 * value;
  } else if (dimension == GanttDateRoundingTimeUnit.HOUR) {
    stepTime = 1e3 * 3600 * value;
  } else if (dimension == GanttDateRoundingTimeUnit.MINUTE) {
    stepTime = 1e3 * 60 * 24 * value;
  }
  return stepTime;
};
const SCROLL_DELAY = 25;
const SIDE_SCROLL_AREA_WIDTH = 70;
const getNextCoordinates = (task, prevValue, nextX, rtl) => {
  const { action, additionalLeftSpace, initialCoordinates, startX } = prevValue;
  switch (action) {
    case "end": {
      const nextX2 = Math.max(nextX, initialCoordinates.x1);
      const x2Diff = nextX2 - initialCoordinates.x2;
      const progressWidth = (nextX2 - initialCoordinates.x1) * task.progress * 0.01;
      if (rtl) {
        return [
          {
            ...prevValue.coordinates,
            innerX2: nextX2 + additionalLeftSpace,
            progressWidth,
            progressX: initialCoordinates.progressX + x2Diff,
            width: initialCoordinates.width + x2Diff,
            x2: nextX2 - additionalLeftSpace
          },
          x2Diff
        ];
      }
      return [
        {
          ...prevValue.coordinates,
          innerX2: nextX2 + additionalLeftSpace,
          progressWidth,
          width: initialCoordinates.width + x2Diff,
          x2: nextX2 - additionalLeftSpace
        },
        x2Diff
      ];
    }
    case "start": {
      const nextX1 = Math.min(nextX, initialCoordinates.x2);
      const x1Diff = nextX1 - initialCoordinates.x1;
      const progressWidth = (initialCoordinates.x2 - nextX1) * task.progress * 0.01;
      if (rtl) {
        return [
          {
            ...prevValue.coordinates,
            innerX1: nextX1 + additionalLeftSpace,
            progressWidth,
            progressX: initialCoordinates.progressX - x1Diff,
            width: initialCoordinates.width - x1Diff,
            x1: nextX1
          },
          x1Diff
        ];
      }
      return [
        {
          ...prevValue.coordinates,
          innerX1: nextX1 + additionalLeftSpace,
          progressX: nextX1,
          progressWidth,
          width: initialCoordinates.width - x1Diff,
          x1: nextX1
        },
        x1Diff
      ];
    }
    case "progress": {
      const nextProgressEndX = Math.min(
        Math.max(nextX, initialCoordinates.x1),
        initialCoordinates.x2
      );
      if (rtl) {
        return [
          {
            ...prevValue.coordinates,
            progressX: nextProgressEndX,
            progressWidth: initialCoordinates.x2 - nextProgressEndX
          },
          0
        ];
      }
      return [
        {
          ...prevValue.coordinates,
          progressWidth: nextProgressEndX - initialCoordinates.x1
        },
        0
      ];
    }
    case "move": {
      const diff = nextX - startX;
      const nextX1 = initialCoordinates.x1 + diff;
      const nextX2 = initialCoordinates.x2 + diff;
      return [
        {
          ...prevValue.coordinates,
          innerX1: nextX1 + additionalLeftSpace,
          innerX2: nextX2 + additionalLeftSpace,
          progressX: initialCoordinates.progressX + diff,
          x1: nextX1,
          x2: nextX2
        },
        diff
      ];
    }
    default:
      return [prevValue.coordinates, prevValue.coordinatesDiff];
  }
};
const getNextTsDiff = (changedTask, prevValue, rtl) => {
  const { action, originalTask: task } = prevValue;
  switch (action) {
    case "end":
      if (rtl) {
        return changedTask.start.getTime() - task.start.getTime();
      }
      return changedTask.end.getTime() - task.end.getTime();
    case "start":
      if (rtl) {
        return changedTask.end.getTime() - task.end.getTime();
      }
      return changedTask.start.getTime() - task.start.getTime();
    case "progress":
      return 0;
    case "move":
      return changedTask.start.getTime() - task.start.getTime();
    default:
      return prevValue.tsDiff;
  }
};
const useTaskDrag = ({
  childTasksMap,
  dependentMap,
  ganttSVGRef,
  mapTaskToCoordinates,
  mapTaskToGlobalIndex,
  onDateChange,
  onProgressChange,
  roundDate,
  dateMoveStep,
  rtl,
  scrollToLeftStep,
  scrollToRightStep,
  scrollX,
  setScrollXProgrammatically,
  svgClientWidth,
  svgWidth,
  tasksMap,
  timeStep,
  xStep
}) => {
  const [changeInProgress, setChangeInProgress] = useState(null);
  const changeInProgressTask = changeInProgress == null ? void 0 : changeInProgress.originalTask;
  const isChangeInProgress = Boolean(changeInProgress);
  const handleTaskDragStart = useCallback(
    (action, task, clientX, taskRootNode) => {
      var _a;
      if (changeInProgress) {
        return;
      }
      const svgNode = ganttSVGRef.current;
      if (!svgNode) {
        return;
      }
      const point = svgNode.createSVGPoint();
      point.x = clientX;
      const cursor = point.matrixTransform((_a = svgNode.getScreenCTM()) == null ? void 0 : _a.inverse());
      const coordinates = getTaskCoordinates(task, mapTaskToCoordinates);
      setChangeInProgress({
        action,
        additionalLeftSpace: 0,
        additionalRightSpace: 0,
        changedTask: task,
        coordinates: {
          ...coordinates
          // containerX: 0,
          // containerWidth: svgWidth,
          // innerX1: coordinates.x1,
          // innerX2: coordinates.x2,
        },
        coordinatesDiff: 0,
        initialCoordinates: coordinates,
        lastClientX: cursor.x,
        startX: cursor.x,
        originalTask: task,
        taskRootNode,
        tsDiff: 0
      });
    },
    [changeInProgress, ganttSVGRef, mapTaskToCoordinates, svgWidth]
  );
  const recountOnMove = useCallback(
    (nextX) => {
      const changeInProgressLatest = changeInProgress;
      if (!changeInProgressLatest) {
        return;
      }
      const { originalTask: task, additionalLeftSpace } = changeInProgressLatest;
      setChangeInProgress((prevValue) => {
        if (!prevValue) {
          return null;
        }
        const [nextCoordinates, coordinatesDiff] = getNextCoordinates(
          task,
          prevValue,
          nextX - additionalLeftSpace,
          rtl
        );
        const { changedTask: newChangedTask } = handleTaskBySVGMouseEvent(
          prevValue.action,
          task,
          prevValue.initialCoordinates,
          nextCoordinates,
          xStep,
          timeStep,
          rtl
        );
        return {
          ...prevValue,
          changedTask: newChangedTask,
          coordinates: nextCoordinates,
          coordinatesDiff,
          lastClientX: nextX,
          tsDiff: getNextTsDiff(newChangedTask, prevValue, rtl)
        };
      });
    },
    [changeInProgress, rtl, svgWidth]
  );
  useEffect(() => {
    if (!isChangeInProgress) {
      return void 0;
    }
    const intervalId = setInterval(() => {
      const currentChangeInProgress = changeInProgress;
      if (!currentChangeInProgress || scrollX === null) {
        return;
      }
      const { action, lastClientX } = currentChangeInProgress;
      if (scrollX > lastClientX - SIDE_SCROLL_AREA_WIDTH) {
        switch (action) {
          case "start":
          case "move":
            if (scrollX > 0) {
              recountOnMove(lastClientX - SCROLL_STEP);
              scrollToLeftStep();
            } else {
              setChangeInProgress((prevValue) => {
                if (!prevValue) {
                  return null;
                }
                const nextCoordinates = {
                  ...prevValue.coordinates,
                  containerX: prevValue.coordinates.containerX - SCROLL_STEP,
                  containerWidth: prevValue.coordinates.containerWidth + SCROLL_STEP,
                  innerX2: prevValue.action === "start" ? prevValue.coordinates.innerX2 + SCROLL_STEP : prevValue.coordinates.innerX2,
                  progressX: prevValue.coordinates.progressX - SCROLL_STEP,
                  width: prevValue.action === "start" ? prevValue.coordinates.width + SCROLL_STEP : prevValue.coordinates.width,
                  x1: prevValue.coordinates.x1 - SCROLL_STEP,
                  x2: prevValue.action === "move" ? prevValue.coordinates.x2 - SCROLL_STEP : prevValue.coordinates.x2
                };
                const { changedTask: newChangedTask } = handleTaskBySVGMouseEvent(
                  prevValue.action,
                  prevValue.originalTask,
                  prevValue.initialCoordinates,
                  nextCoordinates,
                  xStep,
                  timeStep,
                  rtl
                );
                return {
                  ...prevValue,
                  additionalLeftSpace: prevValue.additionalLeftSpace + SCROLL_STEP,
                  changedTask: newChangedTask,
                  coordinates: nextCoordinates,
                  coordinatesDiff: prevValue.coordinatesDiff - SCROLL_STEP,
                  tsDiff: getNextTsDiff(newChangedTask, prevValue, rtl)
                };
              });
            }
            return;
          case "end":
            if (scrollX > 0) {
              recountOnMove(lastClientX - SCROLL_STEP);
              scrollToLeftStep();
            }
            return;
          default:
            return;
        }
      }
      if (svgClientWidth === null) {
        return;
      }
      if (scrollX + svgClientWidth < lastClientX + SIDE_SCROLL_AREA_WIDTH) {
        switch (action) {
          case "end":
          case "move":
            if (svgWidth > scrollX + svgClientWidth) {
              recountOnMove(lastClientX + SCROLL_STEP);
              scrollToRightStep();
            } else {
              setChangeInProgress((prevValue) => {
                if (!prevValue) {
                  return null;
                }
                const nextCoordinates = {
                  ...prevValue.coordinates,
                  containerWidth: prevValue.coordinates.containerWidth + SCROLL_STEP,
                  innerX1: prevValue.action === "move" ? prevValue.coordinates.innerX1 + SCROLL_STEP : prevValue.coordinates.innerX1,
                  innerX2: prevValue.coordinates.innerX2 + SCROLL_STEP,
                  progressX: prevValue.coordinates.progressX + SCROLL_STEP,
                  width: prevValue.action === "end" ? prevValue.coordinates.width + SCROLL_STEP : prevValue.coordinates.width,
                  x1: prevValue.action === "move" ? prevValue.coordinates.x1 + SCROLL_STEP : prevValue.coordinates.x1,
                  x2: prevValue.coordinates.x2 + SCROLL_STEP
                };
                const { changedTask: newChangedTask } = handleTaskBySVGMouseEvent(
                  prevValue.action,
                  prevValue.originalTask,
                  prevValue.initialCoordinates,
                  nextCoordinates,
                  xStep,
                  timeStep,
                  rtl
                );
                return {
                  ...prevValue,
                  additionalRightSpace: prevValue.additionalRightSpace + SCROLL_STEP,
                  changedTask: newChangedTask,
                  coordinates: nextCoordinates,
                  coordinatesDiff: prevValue.coordinatesDiff + SCROLL_STEP,
                  lastClientX: prevValue.lastClientX + SCROLL_STEP,
                  tsDiff: getNextTsDiff(newChangedTask, prevValue, rtl)
                };
              });
            }
            return;
          case "start":
            if (svgWidth > scrollX + svgClientWidth) {
              recountOnMove(lastClientX + SCROLL_STEP);
              scrollToRightStep();
            }
            return;
          default:
            return;
        }
      }
    }, SCROLL_DELAY);
    return () => {
      clearInterval(intervalId);
    };
  }, [
    changeInProgress,
    isChangeInProgress,
    recountOnMove,
    scrollToLeftStep,
    scrollToRightStep,
    scrollX,
    svgClientWidth,
    svgWidth
  ]);
  const additionalRightSpace = changeInProgress == null ? void 0 : changeInProgress.additionalRightSpace;
  useEffect(() => {
    if (additionalRightSpace) {
      setScrollXProgrammatically((scrollX || 0) + (svgClientWidth || 0));
    }
  }, [
    additionalRightSpace,
    scrollX,
    setScrollXProgrammatically,
    svgClientWidth
  ]);
  useEffect(() => {
    const svgNode = ganttSVGRef.current;
    const point = svgNode.createSVGPoint();
    const handleMove = (clientX) => {
      var _a;
      if (!point) {
        return;
      }
      point.x = clientX;
      const cursor = point.matrixTransform((_a = svgNode.getScreenCTM()) == null ? void 0 : _a.inverse());
      const nextX = cursor.x;
      recountOnMove(nextX);
    };
    const handleMouseMove = (event) => {
      event.preventDefault();
      handleMove(event.clientX);
    };
    const handleTouchMove = (event) => {
      event.preventDefault();
      const firstTouch = event.touches[0];
      if (firstTouch) {
        handleMove(firstTouch.clientX);
      }
    };
    const handleUp = async (event) => {
      const changeInProgressLatest = changeInProgress;
      if (!changeInProgressLatest || !point) {
        return;
      }
      event.preventDefault();
      const { action, originalTask: task } = changeInProgressLatest;
      const { isChanged, changedTask: newChangedTask } = handleTaskBySVGMouseEvent(
        action,
        task,
        changeInProgressLatest.initialCoordinates,
        changeInProgressLatest.coordinates,
        xStep,
        timeStep,
        rtl
      );
      setChangeInProgress(null);
      if (!isChanged) {
        return;
      }
      if (action === "progress") {
        onProgressChange(newChangedTask);
        return;
      }
      const roundedChangedTask = roundTaskDates(
        newChangedTask,
        roundDate,
        action,
        dateMoveStep
      );
      onDateChange(action, roundedChangedTask, task);
    };
    svgNode.addEventListener("mousemove", handleMouseMove);
    svgNode.addEventListener("touchmove", handleTouchMove);
    svgNode.addEventListener("mouseup", handleUp);
    svgNode.addEventListener("touchend", handleUp);
    return () => {
      svgNode.removeEventListener("mousemove", handleMouseMove);
      svgNode.removeEventListener("touchmove", handleTouchMove);
      svgNode.removeEventListener("mouseup", handleUp);
      svgNode.removeEventListener("touchend", handleUp);
    };
  }, [
    changeInProgress,
    changeInProgressTask,
    childTasksMap,
    dependentMap,
    ganttSVGRef,
    mapTaskToGlobalIndex,
    onDateChange,
    onProgressChange,
    recountOnMove,
    roundDate,
    rtl,
    setChangeInProgress,
    tasksMap,
    timeStep,
    xStep
  ]);
  return [changeInProgress, handleTaskDragStart];
};
const min = Math.min;
const max = Math.max;
const round = Math.round;
const createCoords = (v2) => ({
  x: v2,
  y: v2
});
const oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
const oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
  return ["top", "bottom"].includes(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, (alignment) => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ["left", "right"];
  const rl = ["right", "left"];
  const tb = ["top", "bottom"];
  const bt = ["bottom", "top"];
  switch (side) {
    case "top":
    case "bottom":
      if (rtl)
        return isStart ? rl : lr;
      return isStart ? lr : rl;
    case "left":
    case "right":
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === "start", rtl);
  if (alignment) {
    list = list.map((side) => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, (side) => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x: x3,
    y: y3,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y3,
    left: x3,
    right: x3 + width,
    bottom: y3 + height,
    x: x3,
    y: y3
  };
}
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
const computePosition$1 = async (reference, floating, config) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x: x3,
    y: y3
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i2 = 0; i2 < validMiddleware.length; i2++) {
    const {
      name,
      fn
    } = validMiddleware[i2];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x: x3,
      y: y3,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platform2,
      elements: {
        reference,
        floating
      }
    });
    x3 = nextX != null ? nextX : x3;
    y3 = nextY != null ? nextY : y3;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform2.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x: x3,
          y: y3
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i2 = -1;
    }
  }
  return {
    x: x3,
    y: y3,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x: x3,
    y: y3,
    platform: platform2,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === "floating" ? {
    x: x3,
    y: y3,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating));
  const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}
const flip = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "flip",
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform2,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = "bestFit",
        fallbackAxisSideDirection = "none",
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];
      if (!overflows.every((side2) => side2 <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }
        let resetPlacement = (_overflowsData$filter = overflowsData.filter((d4) => d4.overflows[0] <= 0).sort((a4, b3) => a4.overflows[1] - b3.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case "bestFit": {
              var _overflowsData$filter2;
              const placement2 = (_overflowsData$filter2 = overflowsData.filter((d4) => {
                if (hasFallbackAxisSideDirection) {
                  const currentSideAxis = getSideAxis(d4.placement);
                  return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  currentSideAxis === "y";
                }
                return true;
              }).map((d4) => [d4.placement, d4.overflows.filter((overflow2) => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a4, b3) => a4[1] - b3[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
            case "initialPlacement":
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
async function convertValueToCoords(state, options) {
  const {
    placement,
    platform: platform2,
    elements
  } = state;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === "y";
  const mainAxisMulti = ["left", "top"].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === "number" ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === "number") {
    crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
const offset = function(options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: "offset",
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x: x3,
        y: y3,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x3 + diffCoords.x,
        y: y3 + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};
const shift = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "shift",
    options,
    async fn(state) {
      const {
        x: x3,
        y: y3,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: (_ref) => {
            let {
              x: x4,
              y: y4
            } = _ref;
            return {
              x: x4,
              y: y4
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x: x3,
        y: y3
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === "y" ? "top" : "left";
        const maxSide = mainAxis === "y" ? "bottom" : "right";
        const min2 = mainAxisCoord + overflow[minSide];
        const max2 = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min2, mainAxisCoord, max2);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === "y" ? "top" : "left";
        const maxSide = crossAxis === "y" ? "bottom" : "right";
        const min2 = crossAxisCoord + overflow[minSide];
        const max2 = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min2, crossAxisCoord, max2);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x3,
          y: limitedCoords.y - y3,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis
          }
        }
      };
    }
  };
};
function n(t2) {
  var e2;
  return (null == (e2 = t2.ownerDocument) ? void 0 : e2.defaultView) || window;
}
function o(t2) {
  return n(t2).getComputedStyle(t2);
}
const l = Math.round;
function c2(t2) {
  const e2 = o(t2);
  let n2 = parseFloat(e2.width), i2 = parseFloat(e2.height);
  const r = t2.offsetWidth, c3 = t2.offsetHeight, s4 = l(n2) !== r || l(i2) !== c3;
  return s4 && (n2 = r, i2 = c3), { width: n2, height: i2, fallback: s4 };
}
function s3(t2) {
  return h3(t2) ? (t2.nodeName || "").toLowerCase() : "";
}
let f;
function u2() {
  if (f)
    return f;
  const t2 = navigator.userAgentData;
  return t2 && Array.isArray(t2.brands) ? (f = t2.brands.map((t3) => t3.brand + "/" + t3.version).join(" "), f) : navigator.userAgent;
}
function a3(t2) {
  return t2 instanceof n(t2).HTMLElement;
}
function d3(t2) {
  return t2 instanceof n(t2).Element;
}
function h3(t2) {
  return t2 instanceof n(t2).Node;
}
function p(t2) {
  if ("undefined" == typeof ShadowRoot)
    return false;
  return t2 instanceof n(t2).ShadowRoot || t2 instanceof ShadowRoot;
}
function g(t2) {
  const { overflow: e2, overflowX: n2, overflowY: i2, display: r } = o(t2);
  return /auto|scroll|overlay|hidden|clip/.test(e2 + i2 + n2) && !["inline", "contents"].includes(r);
}
function x2() {
  return !/^((?!chrome|android).)*safari/i.test(u2());
}
function w2(t2) {
  return ["html", "body", "#document"].includes(s3(t2));
}
function v(t2) {
  return d3(t2) ? t2 : t2.contextElement;
}
const b2 = { x: 1, y: 1 };
function L2(t2) {
  const e2 = v(t2);
  if (!a3(e2))
    return b2;
  const n2 = e2.getBoundingClientRect(), { width: o2, height: i2, fallback: r } = c2(e2);
  let s4 = (r ? l(n2.width) : n2.width) / o2, f2 = (r ? l(n2.height) : n2.height) / i2;
  return s4 && Number.isFinite(s4) || (s4 = 1), f2 && Number.isFinite(f2) || (f2 = 1), { x: s4, y: f2 };
}
function E2(t2, e2, o2, i2) {
  var r, l2;
  void 0 === e2 && (e2 = false), void 0 === o2 && (o2 = false);
  const c3 = t2.getBoundingClientRect(), s4 = v(t2);
  let f2 = b2;
  e2 && (i2 ? d3(i2) && (f2 = L2(i2)) : f2 = L2(t2));
  const u3 = s4 ? n(s4) : window, a4 = !x2() && o2;
  let h4 = (c3.left + (a4 && (null == (r = u3.visualViewport) ? void 0 : r.offsetLeft) || 0)) / f2.x, p2 = (c3.top + (a4 && (null == (l2 = u3.visualViewport) ? void 0 : l2.offsetTop) || 0)) / f2.y, g2 = c3.width / f2.x, m3 = c3.height / f2.y;
  if (s4) {
    const t3 = n(s4), e3 = i2 && d3(i2) ? n(i2) : i2;
    let o3 = t3.frameElement;
    for (; o3 && i2 && e3 !== t3; ) {
      const t4 = L2(o3), e4 = o3.getBoundingClientRect(), i3 = getComputedStyle(o3);
      e4.x += (o3.clientLeft + parseFloat(i3.paddingLeft)) * t4.x, e4.y += (o3.clientTop + parseFloat(i3.paddingTop)) * t4.y, h4 *= t4.x, p2 *= t4.y, g2 *= t4.x, m3 *= t4.y, h4 += e4.x, p2 += e4.y, o3 = n(o3).frameElement;
    }
  }
  return { width: g2, height: m3, top: p2, right: h4 + g2, bottom: p2 + m3, left: h4, x: h4, y: p2 };
}
function R2(t2) {
  return ((h3(t2) ? t2.ownerDocument : t2.document) || window.document).documentElement;
}
function F(t2) {
  if ("html" === s3(t2))
    return t2;
  const e2 = t2.assignedSlot || t2.parentNode || p(t2) && t2.host || R2(t2);
  return p(e2) ? e2.host : e2;
}
function W(t2) {
  const e2 = F(t2);
  return w2(e2) ? e2.ownerDocument.body : a3(e2) && g(e2) ? e2 : W(e2);
}
function D2(t2, e2) {
  var o2;
  void 0 === e2 && (e2 = []);
  const i2 = W(t2), r = i2 === (null == (o2 = t2.ownerDocument) ? void 0 : o2.body), l2 = n(i2);
  return r ? e2.concat(l2, l2.visualViewport || [], g(i2) ? i2 : []) : e2.concat(i2, D2(i2));
}
function z2(t2, e2, n2, o2) {
  void 0 === o2 && (o2 = {});
  const { ancestorScroll: i2 = true, ancestorResize: r = true, elementResize: l2 = true, animationFrame: c3 = false } = o2, s4 = i2 && !c3, f2 = s4 || r ? [...d3(t2) ? D2(t2) : t2.contextElement ? D2(t2.contextElement) : [], ...D2(e2)] : [];
  f2.forEach((t3) => {
    s4 && t3.addEventListener("scroll", n2, { passive: true }), r && t3.addEventListener("resize", n2);
  });
  let u3, a4 = null;
  if (l2) {
    let o3 = true;
    a4 = new ResizeObserver(() => {
      o3 || n2(), o3 = false;
    }), d3(t2) && !c3 && a4.observe(t2), d3(t2) || !t2.contextElement || c3 || a4.observe(t2.contextElement), a4.observe(e2);
  }
  let h4 = c3 ? E2(t2) : null;
  return c3 && function e3() {
    const o3 = E2(t2);
    !h4 || o3.x === h4.x && o3.y === h4.y && o3.width === h4.width && o3.height === h4.height || n2();
    h4 = o3, u3 = requestAnimationFrame(e3);
  }(), n2(), () => {
    var t3;
    f2.forEach((t4) => {
      s4 && t4.removeEventListener("scroll", n2), r && t4.removeEventListener("resize", n2);
    }), null == (t3 = a4) || t3.disconnect(), a4 = null, c3 && cancelAnimationFrame(u3);
  };
}
function hasWindow() {
  return typeof window !== "undefined";
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow$1(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow$1(value).Node;
}
function isElement$1(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow$1(value).Element;
}
function isHTMLElement$1(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow$1(value).HTMLElement;
}
function isShadowRoot$1(value) {
  if (!hasWindow() || typeof ShadowRoot === "undefined") {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow$1(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$1(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !["inline", "contents"].includes(display);
}
function isTableElement(element) {
  return ["table", "td", "th"].includes(getNodeName(element));
}
function isTopLayer(element) {
  return [":popover-open", ":modal"].some((selector) => {
    try {
      return element.matches(selector);
    } catch (e2) {
      return false;
    }
  });
}
function isContainingBlock(elementOrCss) {
  const webkit = isWebKit();
  const css = isElement$1(elementOrCss) ? getComputedStyle$1(elementOrCss) : elementOrCss;
  return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || ["transform", "perspective", "filter"].some((value) => (css.willChange || "").includes(value)) || ["paint", "layout", "strict", "content"].some((value) => (css.contain || "").includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement$1(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === "undefined" || !CSS.supports)
    return false;
  return CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(node) {
  return ["html", "body", "#document"].includes(getNodeName(node));
}
function getComputedStyle$1(element) {
  return getWindow$1(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement$1(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode(node) {
  if (getNodeName(node) === "html") {
    return node;
  }
  const result = (
    // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot$1(node) && node.host || // Fallback.
    getDocumentElement(node)
  );
  return isShadowRoot$1(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement$1(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow$1(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}
function getCssDimensions(element) {
  const css = getComputedStyle$1(element);
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement$1(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}
function unwrapElement(element) {
  return !isElement$1(element) ? element.contextElement : element;
}
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement$1(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x3 = ($ ? round(rect.width) : rect.width) / width;
  let y3 = ($ ? round(rect.height) : rect.height) / height;
  if (!x3 || !Number.isFinite(x3)) {
    x3 = 1;
  }
  if (!y3 || !Number.isFinite(y3)) {
    y3 = 1;
  }
  return {
    x: x3,
    y: y3
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow$1(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow$1(element)) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement$1(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x3 = (clientRect.left + visualOffsets.x) / scale.x;
  let y3 = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow$1(domElement);
    const offsetWin = offsetParent && isElement$1(offsetParent) ? getWindow$1(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle$1(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x3 *= iframeScale.x;
      y3 *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x3 += left;
      y3 += top;
      currentWin = getWindow$1(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x: x3,
    y: y3
  });
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === "fixed";
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement$1(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
  };
}
function getClientRects(element) {
  return Array.from(element.getClientRects());
}
function getWindowScrollBarX(element, rect) {
  const leftScroll = getNodeScroll(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x3 = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y3 = -scroll.scrollTop;
  if (getComputedStyle$1(body).direction === "rtl") {
    x3 += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x: x3,
    y: y3
  };
}
function getViewportRect(element, strategy) {
  const win = getWindow$1(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x3 = 0;
  let y3 = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
      x3 = visualViewport.offsetLeft;
      y3 = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x: x3,
    y: y3
  };
}
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement$1(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x3 = left * scale.x;
  const y3 = top * scale.y;
  return {
    width,
    height,
    x: x3,
    y: y3
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport") {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement$1(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      ...clippingAncestor,
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement$1(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle$1(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter((el) => isElement$1(el) && getNodeName(el) !== "body");
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$1(element).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element) : element;
  while (isElement$1(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$1(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === "fixed") {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && ["absolute", "fixed"].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      result = result.filter((ancestor) => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}
function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === "fixed";
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  let htmlX = 0;
  let htmlY = 0;
  if (documentElement && !isOffsetParentAnElement && !isFixed) {
    const htmlRect = documentElement.getBoundingClientRect();
    htmlY = htmlRect.top + scroll.scrollTop;
    htmlX = htmlRect.left + scroll.scrollLeft - // RTL <body> scrollbar.
    getWindowScrollBarX(documentElement, htmlRect);
  }
  const x3 = rect.left + scroll.scrollLeft - offsets.x - htmlX;
  const y3 = rect.top + scroll.scrollTop - offsets.y - htmlY;
  return {
    x: x3,
    y: y3,
    width: rect.width,
    height: rect.height
  };
}
function isStaticPositioned(element) {
  return getComputedStyle$1(element).position === "static";
}
function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement$1(element) || getComputedStyle$1(element).position === "fixed") {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  let rawOffsetParent = element.offsetParent;
  if (getDocumentElement(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}
function getOffsetParent(element, polyfill) {
  const win = getWindow$1(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement$1(element)) {
    let svgOffsetParent = getParentNode(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement$1(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}
const getElementRects = async function(data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};
function isRTL(element) {
  return getComputedStyle$1(element).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement: isElement$1,
  isRTL
};
const computePosition = (reference, floating, options) => {
  const cache = /* @__PURE__ */ new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};
var index$1 = typeof document !== "undefined" ? useLayoutEffect : useEffect;
function deepEqual(a4, b3) {
  if (a4 === b3) {
    return true;
  }
  if (typeof a4 !== typeof b3) {
    return false;
  }
  if (typeof a4 === "function" && a4.toString() === b3.toString()) {
    return true;
  }
  let length, i2, keys;
  if (a4 && b3 && typeof a4 == "object") {
    if (Array.isArray(a4)) {
      length = a4.length;
      if (length != b3.length)
        return false;
      for (i2 = length; i2-- !== 0; ) {
        if (!deepEqual(a4[i2], b3[i2])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a4);
    length = keys.length;
    if (length !== Object.keys(b3).length) {
      return false;
    }
    for (i2 = length; i2-- !== 0; ) {
      if (!Object.prototype.hasOwnProperty.call(b3, keys[i2])) {
        return false;
      }
    }
    for (i2 = length; i2-- !== 0; ) {
      const key = keys[i2];
      if (key === "_owner" && a4.$$typeof) {
        continue;
      }
      if (!deepEqual(a4[key], b3[key])) {
        return false;
      }
    }
    return true;
  }
  return a4 !== a4 && b3 !== b3;
}
function useLatestRef(value) {
  const ref = React.useRef(value);
  index$1(() => {
    ref.current = value;
  });
  return ref;
}
function useFloating$1(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2,
    whileElementsMounted,
    open
  } = options;
  const [data, setData] = React.useState({
    x: null,
    y: null,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = React.useState(middleware);
  if (!deepEqual(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const referenceRef = React.useRef(null);
  const floatingRef = React.useRef(null);
  const dataRef = React.useRef(data);
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform2);
  const [reference, _setReference] = React.useState(null);
  const [floating, _setFloating] = React.useState(null);
  const setReference = React.useCallback((node) => {
    if (referenceRef.current !== node) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, []);
  const setFloating = React.useCallback((node) => {
    if (floatingRef.current !== node) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, []);
  const update = React.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config.platform = platformRef.current;
    }
    computePosition(referenceRef.current, floatingRef.current, config).then((data2) => {
      const fullData = {
        ...data2,
        isPositioned: true
      };
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        ReactDOM.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef]);
  index$1(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData((data2) => ({
        ...data2,
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = React.useRef(false);
  index$1(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index$1(() => {
    if (reference && floating) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(reference, floating, update);
      } else {
        update();
      }
    }
  }, [reference, floating, update, whileElementsMountedRef]);
  const refs = React.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = React.useMemo(() => ({
    reference,
    floating
  }), [reference, floating]);
  return React.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    reference: setReference,
    floating: setFloating
  }), [data, update, refs, elements, setReference, setFloating]);
}
var index = typeof document !== "undefined" ? useLayoutEffect : useEffect;
let serverHandoffComplete = false;
let count = 0;
const genId = () => "floating-ui-" + count++;
function useFloatingId() {
  const [id, setId] = React.useState(() => serverHandoffComplete ? genId() : void 0);
  index(() => {
    if (id == null) {
      setId(genId());
    }
  }, []);
  React.useEffect(() => {
    if (!serverHandoffComplete) {
      serverHandoffComplete = true;
    }
  }, []);
  return id;
}
const useReactId = React[/* @__PURE__ */ "useId".toString()];
const useId = useReactId || useFloatingId;
function createPubSub() {
  const map = /* @__PURE__ */ new Map();
  return {
    emit(event, data) {
      var _map$get;
      (_map$get = map.get(event)) == null ? void 0 : _map$get.forEach((handler) => handler(data));
    },
    on(event, listener) {
      map.set(event, [...map.get(event) || [], listener]);
    },
    off(event, listener) {
      map.set(event, (map.get(event) || []).filter((l2) => l2 !== listener));
    }
  };
}
const FloatingNodeContext = /* @__PURE__ */ React.createContext(null);
const FloatingTreeContext = /* @__PURE__ */ React.createContext(null);
const useFloatingParentNodeId = () => {
  var _React$useContext;
  return ((_React$useContext = React.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
const useFloatingTree = () => React.useContext(FloatingTreeContext);
function getDocument(node) {
  return (node == null ? void 0 : node.ownerDocument) || document;
}
function getPlatform() {
  const uaData = navigator.userAgentData;
  if (uaData != null && uaData.platform) {
    return uaData.platform;
  }
  return navigator.platform;
}
function getUserAgent() {
  const uaData = navigator.userAgentData;
  if (uaData && Array.isArray(uaData.brands)) {
    return uaData.brands.map((_ref) => {
      let {
        brand,
        version
      } = _ref;
      return brand + "/" + version;
    }).join(" ");
  }
  return navigator.userAgent;
}
function getWindow(value) {
  return getDocument(value).defaultView || window;
}
function isElement(value) {
  return value ? value instanceof getWindow(value).Element : false;
}
function isHTMLElement(value) {
  return value ? value instanceof getWindow(value).HTMLElement : false;
}
function isShadowRoot(node) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  const OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}
function isVirtualClick(event) {
  if (event.mozInputSource === 0 && event.isTrusted) {
    return true;
  }
  const androidRe = /Android/i;
  if ((androidRe.test(getPlatform()) || androidRe.test(getUserAgent())) && event.pointerType) {
    return event.type === "click" && event.buttons === 1;
  }
  return event.detail === 0 && !event.pointerType;
}
function isVirtualPointerEvent(event) {
  return event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType !== "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0;
}
function activeElement$1(doc) {
  let activeElement = doc.activeElement;
  while (((_activeElement = activeElement) == null ? void 0 : (_activeElement$shadow = _activeElement.shadowRoot) == null ? void 0 : _activeElement$shadow.activeElement) != null) {
    var _activeElement, _activeElement$shadow;
    activeElement = activeElement.shadowRoot.activeElement;
  }
  return activeElement;
}
function contains(parent, child) {
  if (!parent || !child) {
    return false;
  }
  const rootNode = child.getRootNode && child.getRootNode();
  if (parent.contains(child)) {
    return true;
  } else if (rootNode && isShadowRoot(rootNode)) {
    let next = child;
    do {
      if (next && parent === next) {
        return true;
      }
      next = next.parentNode || next.host;
    } while (next);
  }
  return false;
}
function getChildren(nodes, id) {
  let allChildren = nodes.filter((node) => {
    var _node$context;
    return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
  }) || [];
  let currentChildren = allChildren;
  while (currentChildren.length) {
    currentChildren = nodes.filter((node) => {
      var _currentChildren;
      return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n2) => {
        var _node$context2;
        return node.parentId === n2.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
      });
    }) || [];
    allChildren = allChildren.concat(currentChildren);
  }
  return allChildren;
}
function getTarget(event) {
  if ("composedPath" in event) {
    return event.composedPath()[0];
  }
  return event.target;
}
const useInsertionEffect = React[/* @__PURE__ */ "useInsertionEffect".toString()];
const useSafeInsertionEffect = useInsertionEffect || ((fn) => fn());
function useEvent(callback) {
  const ref = React.useRef(() => {
    if (process.env.NODE_ENV !== "production") {
      throw new Error("Cannot call an event handler while rendering.");
    }
  });
  useSafeInsertionEffect(() => {
    ref.current = callback;
  });
  return React.useCallback(function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current == null ? void 0 : ref.current(...args);
  }, []);
}
function isEventTargetWithin(event, node) {
  if (node == null) {
    return false;
  }
  if ("composedPath" in event) {
    return event.composedPath().includes(node);
  }
  const e2 = event;
  return e2.target != null && node.contains(e2.target);
}
const bubbleHandlerKeys = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
};
const captureHandlerKeys = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
};
const normalizeBubblesProp = function(bubbles) {
  var _bubbles$escapeKey, _bubbles$outsidePress;
  if (bubbles === void 0) {
    bubbles = true;
  }
  return {
    escapeKeyBubbles: typeof bubbles === "boolean" ? bubbles : (_bubbles$escapeKey = bubbles.escapeKey) != null ? _bubbles$escapeKey : true,
    outsidePressBubbles: typeof bubbles === "boolean" ? bubbles : (_bubbles$outsidePress = bubbles.outsidePress) != null ? _bubbles$outsidePress : true
  };
};
const useDismiss = function(_ref, _temp) {
  let {
    open,
    onOpenChange,
    events,
    nodeId,
    elements: {
      reference,
      domReference,
      floating
    },
    dataRef
  } = _ref;
  let {
    enabled = true,
    escapeKey = true,
    outsidePress: unstable_outsidePress = true,
    outsidePressEvent = "pointerdown",
    referencePress = false,
    referencePressEvent = "pointerdown",
    ancestorScroll = false,
    bubbles = true
  } = _temp === void 0 ? {} : _temp;
  const tree = useFloatingTree();
  const nested = useFloatingParentNodeId() != null;
  const outsidePressFn = useEvent(typeof unstable_outsidePress === "function" ? unstable_outsidePress : () => false);
  const outsidePress = typeof unstable_outsidePress === "function" ? outsidePressFn : unstable_outsidePress;
  const insideReactTreeRef = React.useRef(false);
  const {
    escapeKeyBubbles,
    outsidePressBubbles
  } = normalizeBubblesProp(bubbles);
  React.useEffect(() => {
    if (!open || !enabled) {
      return;
    }
    dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
    dataRef.current.__outsidePressBubbles = outsidePressBubbles;
    function onKeyDown(event) {
      if (event.key === "Escape") {
        const children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
          let shouldDismiss = true;
          children.forEach((child) => {
            var _child$context;
            if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
              shouldDismiss = false;
              return;
            }
          });
          if (!shouldDismiss) {
            return;
          }
        }
        events.emit("dismiss", {
          type: "escapeKey",
          data: {
            returnFocus: {
              preventScroll: false
            }
          }
        });
        onOpenChange(false);
      }
    }
    function onOutsidePress(event) {
      const insideReactTree = insideReactTreeRef.current;
      insideReactTreeRef.current = false;
      if (insideReactTree) {
        return;
      }
      if (typeof outsidePress === "function" && !outsidePress(event)) {
        return;
      }
      const target = getTarget(event);
      if (isHTMLElement(target) && floating) {
        const win = floating.ownerDocument.defaultView || window;
        const canScrollX = target.scrollWidth > target.clientWidth;
        const canScrollY = target.scrollHeight > target.clientHeight;
        let xCond = canScrollY && event.offsetX > target.clientWidth;
        if (canScrollY) {
          const isRTL2 = win.getComputedStyle(target).direction === "rtl";
          if (isRTL2) {
            xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
          }
        }
        if (xCond || canScrollX && event.offsetY > target.clientHeight) {
          return;
        }
      }
      const targetIsInsideChildren = tree && getChildren(tree.nodesRef.current, nodeId).some((node) => {
        var _node$context;
        return isEventTargetWithin(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
      });
      if (isEventTargetWithin(event, floating) || isEventTargetWithin(event, domReference) || targetIsInsideChildren) {
        return;
      }
      const children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
      if (children.length > 0) {
        let shouldDismiss = true;
        children.forEach((child) => {
          var _child$context2;
          if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
            shouldDismiss = false;
            return;
          }
        });
        if (!shouldDismiss) {
          return;
        }
      }
      events.emit("dismiss", {
        type: "outsidePress",
        data: {
          returnFocus: nested ? {
            preventScroll: true
          } : isVirtualClick(event) || isVirtualPointerEvent(event)
        }
      });
      onOpenChange(false);
    }
    function onScroll() {
      onOpenChange(false);
    }
    const doc = getDocument(floating);
    escapeKey && doc.addEventListener("keydown", onKeyDown);
    outsidePress && doc.addEventListener(outsidePressEvent, onOutsidePress);
    let ancestors = [];
    if (ancestorScroll) {
      if (isElement(domReference)) {
        ancestors = getOverflowAncestors(domReference);
      }
      if (isElement(floating)) {
        ancestors = ancestors.concat(getOverflowAncestors(floating));
      }
      if (!isElement(reference) && reference && reference.contextElement) {
        ancestors = ancestors.concat(getOverflowAncestors(reference.contextElement));
      }
    }
    ancestors = ancestors.filter((ancestor) => {
      var _doc$defaultView;
      return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
    });
    ancestors.forEach((ancestor) => {
      ancestor.addEventListener("scroll", onScroll, {
        passive: true
      });
    });
    return () => {
      escapeKey && doc.removeEventListener("keydown", onKeyDown);
      outsidePress && doc.removeEventListener(outsidePressEvent, onOutsidePress);
      ancestors.forEach((ancestor) => {
        ancestor.removeEventListener("scroll", onScroll);
      });
    };
  }, [dataRef, floating, domReference, reference, escapeKey, outsidePress, outsidePressEvent, events, tree, nodeId, open, onOpenChange, ancestorScroll, enabled, escapeKeyBubbles, outsidePressBubbles, nested]);
  React.useEffect(() => {
    insideReactTreeRef.current = false;
  }, [outsidePress, outsidePressEvent]);
  return React.useMemo(() => {
    if (!enabled) {
      return {};
    }
    return {
      reference: {
        [bubbleHandlerKeys[referencePressEvent]]: () => {
          if (referencePress) {
            events.emit("dismiss", {
              type: "referencePress",
              data: {
                returnFocus: false
              }
            });
            onOpenChange(false);
          }
        }
      },
      floating: {
        [captureHandlerKeys[outsidePressEvent]]: () => {
          insideReactTreeRef.current = true;
        }
      }
    };
  }, [enabled, events, referencePress, outsidePressEvent, referencePressEvent, onOpenChange]);
};
const useFocus = function(_ref, _temp) {
  let {
    open,
    onOpenChange,
    dataRef,
    events,
    refs,
    elements: {
      floating,
      domReference
    }
  } = _ref;
  let {
    enabled = true,
    keyboardOnly = true
  } = _temp === void 0 ? {} : _temp;
  const pointerTypeRef = React.useRef("");
  const blockFocusRef = React.useRef(false);
  const timeoutRef = React.useRef();
  React.useEffect(() => {
    if (!enabled) {
      return;
    }
    const doc = getDocument(floating);
    const win = doc.defaultView || window;
    function onBlur() {
      if (!open && isHTMLElement(domReference) && domReference === activeElement$1(getDocument(domReference))) {
        blockFocusRef.current = true;
      }
    }
    win.addEventListener("blur", onBlur);
    return () => {
      win.removeEventListener("blur", onBlur);
    };
  }, [floating, domReference, open, enabled]);
  React.useEffect(() => {
    if (!enabled) {
      return;
    }
    function onDismiss(payload) {
      if (payload.type === "referencePress" || payload.type === "escapeKey") {
        blockFocusRef.current = true;
      }
    }
    events.on("dismiss", onDismiss);
    return () => {
      events.off("dismiss", onDismiss);
    };
  }, [events, enabled]);
  React.useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);
  return React.useMemo(() => {
    if (!enabled) {
      return {};
    }
    return {
      reference: {
        onPointerDown(_ref2) {
          let {
            pointerType
          } = _ref2;
          pointerTypeRef.current = pointerType;
          blockFocusRef.current = !!(pointerType && keyboardOnly);
        },
        onMouseLeave() {
          blockFocusRef.current = false;
        },
        onFocus(event) {
          var _dataRef$current$open;
          if (blockFocusRef.current) {
            return;
          }
          if (event.type === "focus" && ((_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type) === "mousedown" && dataRef.current.openEvent && isEventTargetWithin(dataRef.current.openEvent, domReference)) {
            return;
          }
          dataRef.current.openEvent = event.nativeEvent;
          onOpenChange(true);
        },
        onBlur(event) {
          blockFocusRef.current = false;
          const relatedTarget = event.relatedTarget;
          const movedToFocusGuard = isElement(relatedTarget) && relatedTarget.hasAttribute("data-floating-ui-focus-guard") && relatedTarget.getAttribute("data-type") === "outside";
          timeoutRef.current = setTimeout(() => {
            if (contains(refs.floating.current, relatedTarget) || contains(domReference, relatedTarget) || movedToFocusGuard) {
              return;
            }
            onOpenChange(false);
          });
        }
      }
    };
  }, [enabled, keyboardOnly, domReference, refs, dataRef, onOpenChange]);
};
const useRole = function(_ref, _temp) {
  let {
    open
  } = _ref;
  let {
    enabled = true,
    role = "dialog"
  } = _temp === void 0 ? {} : _temp;
  const rootId = useId();
  const referenceId = useId();
  return React.useMemo(() => {
    const floatingProps = {
      id: rootId,
      role
    };
    if (!enabled) {
      return {};
    }
    if (role === "tooltip") {
      return {
        reference: {
          "aria-describedby": open ? rootId : void 0
        },
        floating: floatingProps
      };
    }
    return {
      reference: {
        "aria-expanded": open ? "true" : "false",
        "aria-haspopup": role === "alertdialog" ? "dialog" : role,
        "aria-controls": open ? rootId : void 0,
        ...role === "listbox" && {
          role: "combobox"
        },
        ...role === "menu" && {
          id: referenceId
        }
      },
      floating: {
        ...floatingProps,
        ...role === "menu" && {
          "aria-labelledby": referenceId
        }
      }
    };
  }, [enabled, role, open, rootId, referenceId]);
};
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    open = false,
    onOpenChange: unstable_onOpenChange,
    nodeId
  } = options;
  const position = useFloating$1(options);
  const tree = useFloatingTree();
  const domReferenceRef = React.useRef(null);
  const dataRef = React.useRef({});
  const events = React.useState(() => createPubSub())[0];
  const [domReference, setDomReference] = React.useState(null);
  const setPositionReference = React.useCallback((node) => {
    const positionReference = isElement(node) ? {
      getBoundingClientRect: () => node.getBoundingClientRect(),
      contextElement: node
    } : node;
    position.refs.setReference(positionReference);
  }, [position.refs]);
  const setReference = React.useCallback((node) => {
    if (isElement(node) || node === null) {
      domReferenceRef.current = node;
      setDomReference(node);
    }
    if (isElement(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    node !== null && !isElement(node)) {
      position.refs.setReference(node);
    }
  }, [position.refs]);
  const refs = React.useMemo(() => ({
    ...position.refs,
    setReference,
    setPositionReference,
    domReference: domReferenceRef
  }), [position.refs, setReference, setPositionReference]);
  const elements = React.useMemo(() => ({
    ...position.elements,
    domReference
  }), [position.elements, domReference]);
  const onOpenChange = useEvent(unstable_onOpenChange);
  const context = React.useMemo(() => ({
    ...position,
    refs,
    elements,
    dataRef,
    nodeId,
    events,
    open,
    onOpenChange
  }), [position, nodeId, events, open, onOpenChange, refs, elements]);
  index(() => {
    const node = tree == null ? void 0 : tree.nodesRef.current.find((node2) => node2.id === nodeId);
    if (node) {
      node.context = context;
    }
  });
  return React.useMemo(() => ({
    ...position,
    context,
    refs,
    reference: setReference,
    positionReference: setPositionReference
  }), [position, refs, context, setReference, setPositionReference]);
}
function mergeProps(userProps, propsList, elementKey) {
  const map = /* @__PURE__ */ new Map();
  return {
    ...elementKey === "floating" && {
      tabIndex: -1
    },
    ...userProps,
    ...propsList.map((value) => value ? value[elementKey] : null).concat(userProps).reduce((acc, props) => {
      if (!props) {
        return acc;
      }
      Object.entries(props).forEach((_ref) => {
        let [key, value] = _ref;
        if (key.indexOf("on") === 0) {
          if (!map.has(key)) {
            map.set(key, []);
          }
          if (typeof value === "function") {
            var _map$get;
            (_map$get = map.get(key)) == null ? void 0 : _map$get.push(value);
            acc[key] = function() {
              var _map$get2;
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.forEach((fn) => fn(...args));
            };
          }
        } else {
          acc[key] = value;
        }
      });
      return acc;
    }, {})
  };
}
const useInteractions = function(propsList) {
  if (propsList === void 0) {
    propsList = [];
  }
  const deps = propsList;
  const getReferenceProps = React.useCallback(
    (userProps) => mergeProps(userProps, propsList, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    deps
  );
  const getFloatingProps = React.useCallback(
    (userProps) => mergeProps(userProps, propsList, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    deps
  );
  const getItemProps = React.useCallback(
    (userProps) => mergeProps(userProps, propsList, "item"),
    // Granularly check for `item` changes, because the `getItemProps` getter
    // should be as referentially stable as possible since it may be passed as
    // a prop to many components. All `item` key values must therefore be
    // memoized.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    propsList.map((key) => key == null ? void 0 : key.item)
  );
  return React.useMemo(() => ({
    getReferenceProps,
    getFloatingProps,
    getItemProps
  }), [getReferenceProps, getFloatingProps, getItemProps]);
};
const useTaskTooltip = (changeInProgress) => {
  const [hoverTooltipTask, setHoverTooltipTask] = useState(null);
  const [hoverTooltipEl, setHoverTooltipEl] = useState(null);
  const tooltipTask = useMemo(() => {
    if (changeInProgress) {
      return changeInProgress.changedTask;
    }
    return hoverTooltipTask;
  }, [changeInProgress, hoverTooltipTask]);
  const tooltipEl = useMemo(() => {
    if (changeInProgress) {
      return changeInProgress.taskRootNode;
    }
    return hoverTooltipEl;
  }, [changeInProgress, hoverTooltipEl]);
  const {
    x: x3,
    y: y3,
    strategy,
    refs: { setFloating, setReference },
    context
  } = useFloating({
    open: Boolean(tooltipTask),
    middleware: [offset(10), flip(), shift()],
    whileElementsMounted: z2
  });
  const focus = useFocus(context);
  const dismiss = useDismiss(context);
  const role = useRole(context, { role: "tooltip" });
  const { getReferenceProps, getFloatingProps } = useInteractions([
    focus,
    dismiss,
    role
  ]);
  useEffect(() => {
    if (!tooltipTask) {
      return void 0;
    }
    let updateId = null;
    const update = () => {
      context.update();
      updateId = requestAnimationFrame(update);
    };
    updateId = requestAnimationFrame(update);
    return () => {
      if (updateId) {
        cancelAnimationFrame(updateId);
      }
    };
  }, [context, tooltipTask]);
  const onChangeTooltipTask = useCallback(
    (nextTask, element) => {
      setHoverTooltipTask(nextTask);
      setHoverTooltipEl(element);
    },
    [setReference]
  );
  useEffect(() => {
    setReference(tooltipEl);
  }, [tooltipEl]);
  return {
    tooltipTask,
    tooltipX: x3,
    tooltipY: y3,
    tooltipStrategy: strategy,
    setFloatingRef: setFloating,
    getReferenceProps,
    getFloatingProps,
    onChangeTooltipTask
  };
};
const useVerticalScrollbars = () => {
  const ganttTaskContentRef = useRef(null);
  const taskListContentRef = useRef(null);
  const setScrollYProgrammatically = (nextScrollY) => {
    if (taskListContentRef.current) {
      taskListContentRef.current.scrollTop = nextScrollY;
    }
  };
  const onScrollVertically = (event) => {
    if (event.currentTarget === ganttTaskContentRef.current) {
      taskListContentRef.current.scrollTop = ganttTaskContentRef.current.scrollTop;
      ganttTaskContentRef.current.scrollTop = taskListContentRef.current.scrollTop;
    } else {
      ganttTaskContentRef.current.scrollTop = taskListContentRef.current.scrollTop;
      taskListContentRef.current.scrollTop = ganttTaskContentRef.current.scrollTop;
    }
  };
  return [
    ganttTaskContentRef,
    taskListContentRef,
    setScrollYProgrammatically,
    onScrollVertically
  ];
};
const useHorizontalScrollbars = () => {
  const [scrollX, setScrollX] = useState(0);
  const ganttTaskRootRef = useRef(null);
  const isLockedRef = useRef(false);
  const setScrollXProgrammatically = useCallback((nextScrollX) => {
    const scrollEl = ganttTaskRootRef.current;
    if (!scrollEl) {
      return;
    }
    isLockedRef.current = true;
    if (ganttTaskRootRef.current) {
      ganttTaskRootRef.current.scrollLeft = nextScrollX;
    }
    setScrollX(scrollEl.scrollLeft);
    setTimeout(() => {
      isLockedRef.current = false;
    }, 300);
  }, []);
  const onVerticalScrollbarScrollX = useCallback(
    (event) => {
      if (isLockedRef.current) {
        return;
      }
      const nextScrollX = event.currentTarget.scrollLeft;
      if (ganttTaskRootRef.current) {
        ganttTaskRootRef.current.scrollLeft = nextScrollX;
      }
      setScrollX(nextScrollX);
    },
    []
  );
  const scrollToLeftStep = useCallback(() => {
    setScrollXProgrammatically(scrollX - SCROLL_STEP);
  }, [setScrollXProgrammatically, scrollX]);
  const scrollToRightStep = useCallback(() => {
    setScrollXProgrammatically(scrollX + SCROLL_STEP);
  }, [setScrollXProgrammatically, scrollX]);
  return [
    ganttTaskRootRef,
    scrollX,
    setScrollXProgrammatically,
    onVerticalScrollbarScrollX,
    scrollToLeftStep,
    scrollToRightStep
  ];
};
const useGetTaskCurrentState = ({
  adjustTaskToWorkingDates: adjustTaskToWorkingDates2,
  changeInProgress,
  isAdjustToWorkingDates,
  isMoveChildsWithParent,
  isUpdateDisabledParentsOnChange,
  mapTaskToCoordinates,
  roundDate,
  tasksMap,
  dateMoveStep
}) => {
  const getTaskCurrentState = useCallback(
    (currentOriginalTask) => {
      const taskIsChanged = changeInProgress && (changeInProgress.changedTask.start != currentOriginalTask.start || changeInProgress.changedTask.end != currentOriginalTask.end);
      if (taskIsChanged) {
        if (changeInProgress.originalTask === currentOriginalTask) {
          const roundedTask = roundTaskDates(
            changeInProgress.changedTask,
            roundDate,
            changeInProgress.action,
            dateMoveStep
          );
          const roundTaskIsDifferentFromOriginal = roundedTask.start != currentOriginalTask.start || roundedTask.end != currentOriginalTask.end;
          if (isAdjustToWorkingDates && roundTaskIsDifferentFromOriginal) {
            return adjustTaskToWorkingDates2({
              action: changeInProgress.action,
              changedTask: roundedTask,
              originalTask: currentOriginalTask,
              roundDate
            });
          }
          return roundedTask;
        }
        if (isMoveChildsWithParent && changeInProgress.action === "move" && checkIsDescendant(
          changeInProgress.originalTask,
          currentOriginalTask,
          tasksMap
        )) {
          const { tsDiff } = changeInProgress;
          const movedTask = {
            ...currentOriginalTask,
            end: addMilliseconds(currentOriginalTask.end, tsDiff),
            start: addMilliseconds(currentOriginalTask.start, tsDiff)
          };
          const roundedTask = roundTaskDates(
            movedTask,
            roundDate,
            changeInProgress.action,
            dateMoveStep
          );
          const roundTaskIsDifferentFromOriginal = roundedTask.start != currentOriginalTask.start || roundedTask.end != currentOriginalTask.end;
          if (isAdjustToWorkingDates && roundTaskIsDifferentFromOriginal) {
            return adjustTaskToWorkingDates2({
              action: changeInProgress.action,
              changedTask: roundedTask,
              originalTask: currentOriginalTask,
              roundDate
            });
          }
          return roundedTask;
        }
        if (isUpdateDisabledParentsOnChange && currentOriginalTask.isDisabled && currentOriginalTask.id == changeInProgress.originalTask.parent && checkIsDescendant(
          currentOriginalTask,
          changeInProgress.originalTask,
          tasksMap
        )) {
          const childrenTasks = Array.from(
            tasksMap.get(currentOriginalTask.comparisonLevel || 1).values()
          ).filter((task) => {
            return task.parent == currentOriginalTask.id && task.type !== "empty";
          }).map((task) => task);
          const startDates = childrenTasks.map((task) => {
            if (task.id == changeInProgress.changedTask.id) {
              return getTaskCurrentState(task).start;
            } else {
              return task.start;
            }
          });
          const endDates = childrenTasks.map((task) => {
            if (task.id == changeInProgress.changedTask.id) {
              return getTaskCurrentState(task).end;
            } else {
              return task.end;
            }
          });
          return {
            ...currentOriginalTask,
            start: min$1(startDates),
            end: max$1(endDates)
          };
        }
      }
      const progressIsChanged = changeInProgress && changeInProgress.originalTask === currentOriginalTask && changeInProgress.changedTask.progress != currentOriginalTask.progress;
      if (progressIsChanged) {
        return {
          ...currentOriginalTask,
          progress: changeInProgress.changedTask.progress
        };
      }
      return currentOriginalTask;
    },
    [
      adjustTaskToWorkingDates2,
      changeInProgress,
      isAdjustToWorkingDates,
      isMoveChildsWithParent,
      isUpdateDisabledParentsOnChange,
      mapTaskToCoordinates,
      roundDate,
      tasksMap
    ]
  );
  return getTaskCurrentState;
};
const initialValue = {};
const useSelection = (taskToRowIndexMap, rowIndexToTaskMap, checkTaskIdExists) => {
  const [cutIdsMirror, setCutIdsMirror] = useState(initialValue);
  const [copyIdsMirror, setCopyIdsMirror] = useState(initialValue);
  const [selectedIdsMirror, setSelectedIdsMirror] = useState(initialValue);
  const lastSelectedIdRef = useRef(null);
  const selectTask = useCallback((taskId) => {
    setCutIdsMirror(initialValue);
    setSelectedIdsMirror({
      [taskId]: true
    });
    lastSelectedIdRef.current = taskId;
  }, []);
  const toggleTask = useCallback((taskId) => {
    setCutIdsMirror(initialValue);
    setSelectedIdsMirror((prevValue) => {
      if (prevValue[taskId]) {
        const nextValue = {
          ...prevValue
        };
        delete nextValue[taskId];
        return nextValue;
      }
      return {
        ...prevValue,
        [taskId]: true
      };
    });
    lastSelectedIdRef.current = taskId;
  }, []);
  const selectTasksFromLastSelected = useCallback(
    (taskId) => {
      const lastSelectedId = lastSelectedIdRef.current;
      if (lastSelectedId === null) {
        toggleTask(taskId);
        return;
      }
      const indexesAtLevel = taskToRowIndexMap.get(1);
      if (!indexesAtLevel) {
        throw new Error("Indexes are not found at level 1");
      }
      const tasksAtLevel = rowIndexToTaskMap.get(1);
      if (!tasksAtLevel) {
        throw new Error("Tasks are not found at level 1");
      }
      const lastSelectedIndex = indexesAtLevel.get(lastSelectedId);
      if (typeof lastSelectedIndex !== "number") {
        toggleTask(taskId);
        return;
      }
      const currentSelectedIndex = indexesAtLevel.get(taskId);
      if (typeof currentSelectedIndex !== "number") {
        throw new Error(`Index is not found for task "${taskId}"`);
      }
      if (lastSelectedIndex === currentSelectedIndex) {
        toggleTask(taskId);
        return;
      }
      setCutIdsMirror(initialValue);
      const minIndex = Math.min(lastSelectedIndex, currentSelectedIndex);
      const maxIndex = Math.max(lastSelectedIndex, currentSelectedIndex);
      setSelectedIdsMirror((prevValue) => {
        const nextValue = {
          ...prevValue
        };
        for (let i2 = minIndex; i2 <= maxIndex; ++i2) {
          const task = tasksAtLevel.get(i2);
          if (task) {
            nextValue[task.id] = true;
          }
        }
        return nextValue;
      });
      lastSelectedIdRef.current = taskId;
    },
    [rowIndexToTaskMap, taskToRowIndexMap, toggleTask]
  );
  const resetSelectedTasks = useCallback(() => {
    setCutIdsMirror(initialValue);
    setSelectedIdsMirror(initialValue);
    lastSelectedIdRef.current = null;
  }, []);
  const selectTaskOnMouseDown = useCallback(
    (taskId, event) => {
      if (event.shiftKey) {
        event.preventDefault();
        selectTasksFromLastSelected(taskId);
        return;
      }
      if (event.ctrlKey) {
        toggleTask(taskId);
        return;
      }
      selectTask(taskId);
    },
    [selectTask, selectTasksFromLastSelected, toggleTask]
  );
  const cutTask = useCallback((task) => {
    setCutIdsMirror({
      [task.id]: true
    });
    setSelectedIdsMirror(initialValue);
  }, []);
  const cutSelectedTasks = useCallback(() => {
    setCutIdsMirror(selectedIdsMirror);
    setSelectedIdsMirror(initialValue);
  }, [selectedIdsMirror]);
  const copyTask = useCallback((task) => {
    setCopyIdsMirror({
      [task.id]: true
    });
  }, []);
  const copySelectedTasks = useCallback(() => {
    setCopyIdsMirror(selectedIdsMirror);
  }, [selectedIdsMirror]);
  const checkHasCopyTasks = useCallback(
    () => Object.keys(copyIdsMirror).some((taskId) => checkTaskIdExists(taskId, 1)),
    [checkTaskIdExists, copyIdsMirror]
  );
  const checkHasCutTasks = useCallback(
    () => Object.keys(cutIdsMirror).some((taskId) => checkTaskIdExists(taskId, 1)),
    [checkTaskIdExists, cutIdsMirror]
  );
  return {
    checkHasCopyTasks,
    checkHasCutTasks,
    copyIdsMirror,
    copySelectedTasks,
    copyTask,
    cutIdsMirror,
    cutSelectedTasks,
    cutTask,
    resetSelectedTasks,
    selectTask,
    selectTaskOnMouseDown,
    selectTasksFromLastSelected,
    selectedIdsMirror,
    toggleTask
  };
};
const viewModesForDetectHolidays = /* @__PURE__ */ new Set([
  ViewMode.Day,
  ViewMode.HalfDay,
  ViewMode.QuarterDay,
  ViewMode.Hour
]);
const defaultCheckIsHoliday = (date, minTaskDate, dateSetup) => {
  if (!viewModesForDetectHolidays.has(dateSetup.viewMode)) {
    return false;
  }
  if (dateSetup.isUnknownDates) {
    const daysDiff = differenceInDays(date, minTaskDate);
    const rest = daysDiff % 7;
    if (daysDiff >= 0) {
      return rest === 5 || rest === 6;
    }
    return rest === -1 || rest === -2;
  }
  return isWeekend(date);
};
const defaultRoundEndDate = (date, viewMode) => {
  switch (viewMode) {
    case ViewMode.Hour: {
      const end = endOfHour(date);
      const diff = differenceInMinutes(end, date);
      if (diff < 30) {
        return end;
      }
      return subHours(end, 1);
    }
    case ViewMode.QuarterDay: {
      const end = endOfDay(date);
      const diff = differenceInHours(end, date);
      if (diff < 3) {
        return end;
      }
      if (diff < 9) {
        return subHours(end, 6);
      }
      if (diff < 15) {
        return subHours(end, 12);
      }
      if (diff < 21) {
        return subHours(end, 18);
      }
      return subDays(end, 1);
    }
    case ViewMode.HalfDay: {
      const end = endOfDay(date);
      const diff = differenceInHours(end, date);
      if (diff < 6) {
        return end;
      }
      if (diff < 18) {
        return subHours(end, 12);
      }
      return subDays(end, 1);
    }
    case ViewMode.Day: {
      const end = endOfDay(date);
      const diff = differenceInHours(end, date);
      if (diff < 12) {
        return end;
      }
      return subDays(end, 1);
    }
    case ViewMode.Week: {
      const end = endOfISOWeek(date);
      const diff = differenceInDays(end, date);
      if (diff < 4) {
        return end;
      }
      return subWeeks(end, 1);
    }
    case ViewMode.Month: {
      const end = endOfMonth(date);
      const diff = differenceInDays(end, date);
      if (diff < 15) {
        return end;
      }
      return subMonths(end, 1);
    }
    case ViewMode.QuarterYear: {
      const end = endOfQuarter(date);
      const diff = differenceInMonths(end, date);
      if (diff < 1.5) {
        return end;
      }
      return subQuarters(end, 1);
    }
    case ViewMode.Year: {
      const end = endOfYear(date);
      const diff = differenceInMonths(end, date);
      if (diff < 6) {
        return end;
      }
      return subYears(end, 1);
    }
    default:
      throw new Error(`Unknown viewMode: ${viewMode}`);
  }
};
const defaultRoundStartDate = (date, viewMode) => {
  switch (viewMode) {
    case ViewMode.Hour: {
      const start = startOfHour(date);
      const diff = differenceInMinutes(date, start);
      if (diff < 30) {
        return start;
      }
      return addHours(start, 1);
    }
    case ViewMode.QuarterDay: {
      const start = startOfDay(date);
      const diff = differenceInHours(date, start);
      if (diff < 3) {
        return start;
      }
      if (diff < 9) {
        return addHours(start, 6);
      }
      if (diff < 15) {
        return addHours(start, 12);
      }
      if (diff < 21) {
        return addHours(start, 18);
      }
      return addDays(start, 1);
    }
    case ViewMode.HalfDay: {
      const start = startOfDay(date);
      const diff = differenceInHours(date, start);
      if (diff < 6) {
        return start;
      }
      if (diff < 18) {
        return addHours(start, 12);
      }
      return addDays(start, 1);
    }
    case ViewMode.Day: {
      const start = startOfDay(date);
      const diff = differenceInHours(date, start);
      if (diff < 12) {
        return start;
      }
      return addDays(start, 1);
    }
    case ViewMode.Week: {
      const start = startOfISOWeek(date);
      const diff = differenceInDays(date, start);
      if (diff < 4) {
        return start;
      }
      return addWeeks(start, 1);
    }
    case ViewMode.Month: {
      const start = startOfMonth(date);
      const diff = differenceInDays(date, start);
      if (diff < 15) {
        return start;
      }
      return addMonths(start, 1);
    }
    case ViewMode.Year: {
      const start = startOfYear(date);
      const diff = differenceInMonths(date, start);
      if (diff < 6) {
        return start;
      }
      return addYears(start, 1);
    }
    default:
      throw new Error(`Unknown viewMode: ${viewMode}`);
  }
};
const defaultRoundDate = (date, viewMode, dateExtremity) => {
  if (dateExtremity == "startOfTask") {
    return defaultRoundStartDate(date, viewMode);
  } else {
    return defaultRoundEndDate(date, viewMode);
  }
};
const useContextMenu = (wrapperRef) => {
  const [contextMenu, setContextMenu] = useState({
    task: null,
    x: 0,
    y: 0
  });
  const handleOpenContextMenu = useCallback((task, clientX, clientY) => {
    const wrapperNode = wrapperRef.current;
    if (!wrapperNode) {
      return;
    }
    const {
      top,
      left
    } = wrapperNode.getBoundingClientRect();
    setContextMenu({
      task,
      x: clientX - left,
      y: clientY - top
    });
  }, [wrapperRef]);
  const handleCloseContextMenu = useCallback(() => {
    setContextMenu({
      task: null,
      x: 0,
      y: 0
    });
  }, []);
  return {
    contextMenu,
    handleCloseContextMenu,
    handleOpenContextMenu
  };
};
const menuOption = "_menuOption_1uedq_1";
const icon = "_icon_1uedq_14";
const label = "_label_1uedq_18";
const styles = {
  menuOption,
  icon,
  label
};
function MenuOption({
  colors: { contextMenuTextColor },
  distances: {
    contextMenuIconWidth,
    contextMenuOptionHeight,
    contextMenuSidePadding
  },
  handleAction,
  option,
  option: { icon: icon2, label: label2 }
}) {
  const onClick = useCallback(() => {
    handleAction(option);
  }, [handleAction, option]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: styles.menuOption,
      style: {
        height: contextMenuOptionHeight,
        paddingLeft: contextMenuSidePadding,
        paddingRight: contextMenuSidePadding,
        color: contextMenuTextColor
      },
      onClick,
      children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            className: styles.icon,
            style: {
              width: contextMenuIconWidth
            },
            children: icon2
          }
        ),
        /* @__PURE__ */ jsx("div", { className: styles.label, children: label2 })
      ]
    }
  );
}
function ContextMenu({
  checkHasCopyTasks,
  checkHasCutTasks,
  colors,
  colors: { contextMenuBgColor, contextMenuBoxShadow },
  contextMenu: { task, x: x3, y: y3 },
  distances,
  handleAction,
  handleCloseContextMenu,
  options
}) {
  const optionsForRender = useMemo(() => {
    if (!task) {
      return [];
    }
    const meta = {
      task,
      checkHasCopyTasks,
      checkHasCutTasks
    };
    return options.filter(({ checkIsAvailable }) => {
      if (!checkIsAvailable) {
        return true;
      }
      return checkIsAvailable(meta);
    });
  }, [task, checkHasCopyTasks, checkHasCutTasks, options]);
  const handleOptionAction = useCallback(
    (option) => {
      handleCloseContextMenu();
      if (!task) {
        return;
      }
      handleAction(task, option.action);
    },
    [handleAction, handleCloseContextMenu, task]
  );
  const {
    x: menuX,
    y: menuY,
    strategy,
    refs: { setFloating, setReference },
    context
  } = useFloating({
    open: Boolean(task),
    placement: "bottom-start",
    middleware: [flip(), shift()],
    whileElementsMounted: z2
  });
  useEffect(() => {
    if (task) {
      context.update();
    }
  }, [task, x3, y3]);
  const focus = useFocus(context);
  const dismiss = useDismiss(context);
  const role = useRole(context, { role: "tooltip" });
  const { getReferenceProps, getFloatingProps } = useInteractions([
    focus,
    dismiss,
    role
  ]);
  const floatingRef = useRef();
  const setFloatingRef = useCallback(
    (el) => {
      floatingRef.current = el || void 0;
      setFloating(el);
    },
    [setFloating]
  );
  return /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(
      "div",
      {
        ...getReferenceProps(),
        style: {
          position: "absolute",
          left: x3,
          top: y3
        },
        ref: setReference
      }
    ),
    task && /* @__PURE__ */ jsx(
      "div",
      {
        ref: setFloatingRef,
        style: {
          position: strategy,
          top: menuY ?? 0,
          left: menuX ?? 0,
          width: "max-content",
          backgroundColor: contextMenuBgColor,
          boxShadow: contextMenuBoxShadow
        },
        ...getFloatingProps(),
        children: optionsForRender.map((option, index2) => /* @__PURE__ */ jsx(
          MenuOption,
          {
            colors,
            distances,
            handleAction: handleOptionAction,
            option
          },
          index2
        ))
      }
    )
  ] });
}
const getParentTasks = (selectedTasks, tasksMap) => {
  const res = [];
  selectedTasks.forEach((maybeDescendant) => {
    let isDescendant = selectedTasks.some((maybeParent) => {
      if (maybeParent === maybeDescendant || maybeParent.type === "empty") {
        return false;
      }
      return checkIsDescendant(maybeParent, maybeDescendant, tasksMap);
    });
    if (!isDescendant) {
      res.push(maybeDescendant);
    }
  });
  return res;
};
const getSelectedTasks = (selectedIdsMirror, tasksMap) => {
  const res = [];
  const tasksAtFirstLevel = tasksMap.get(1);
  if (tasksAtFirstLevel) {
    Object.keys(selectedIdsMirror).forEach((taskId) => {
      const task = tasksAtFirstLevel.get(taskId);
      if (task) {
        res.push(task);
      }
    });
  }
  return res;
};
const fillDescendants = (res, task, childAtLevelMap) => {
  res.push(task);
  const childs = childAtLevelMap.get(task.id);
  if (!childs) {
    return;
  }
  childs.forEach((childTask) => {
    fillDescendants(res, childTask, childAtLevelMap);
  });
};
const getTasksWithDescendants = (parentTasks, childByLevelMap) => {
  const res = [];
  parentTasks.forEach((task) => {
    const {
      comparisonLevel = 1
    } = task;
    const childAtLevelMap = childByLevelMap.get(comparisonLevel);
    if (!childAtLevelMap) {
      return;
    }
    fillDescendants(res, task, childAtLevelMap);
  });
  return res;
};
const createGetters = (mirror, tasksMap, childTasksMap) => {
  let selectedTasks = null;
  let parentTasks = null;
  let tasksWithDescendants = null;
  const getSelectedTasksWithCache = () => {
    if (selectedTasks) {
      return selectedTasks;
    }
    selectedTasks = getSelectedTasks(mirror, tasksMap);
    return selectedTasks;
  };
  const getParentTasksWithCache = () => {
    if (parentTasks) {
      return parentTasks;
    }
    const selectedTasksRes = getSelectedTasksWithCache();
    parentTasks = getParentTasks(selectedTasksRes, tasksMap);
    return parentTasks;
  };
  const getTasksWithDescendantsWithCache = () => {
    if (tasksWithDescendants) {
      return tasksWithDescendants;
    }
    const parentTasksRes = getParentTasksWithCache();
    tasksWithDescendants = getTasksWithDescendants(
      parentTasksRes,
      childTasksMap
    );
    return tasksWithDescendants;
  };
  return {
    getParentTasksWithCache,
    getSelectedTasksWithCache,
    getTasksWithDescendantsWithCache
  };
};
const useHandleAction = ({
  checkTaskIdExists,
  childTasksMap,
  copyIdsMirror,
  copySelectedTasks,
  copyTask,
  cutIdsMirror,
  cutSelectedTasks,
  cutTask,
  handleAddChilds,
  handleDeleteTasks,
  handleMoveTasksInside,
  makeCopies,
  resetSelectedTasks,
  selectedIdsMirror,
  tasksMap
}) => {
  const handleAction = useCallback(
    (task, action) => {
      const {
        getParentTasksWithCache,
        getSelectedTasksWithCache,
        getTasksWithDescendantsWithCache
      } = createGetters(selectedIdsMirror, tasksMap, childTasksMap);
      const {
        getParentTasksWithCache: getCutParentTasksWithCache,
        getSelectedTasksWithCache: getCutTasksWithCache
      } = createGetters(cutIdsMirror, tasksMap, childTasksMap);
      const {
        getParentTasksWithCache: getCopyParentTasksWithCache,
        getSelectedTasksWithCache: getCopyTasksWithCache,
        getTasksWithDescendantsWithCache: getCopyTasksWithDescendantsWithCache
      } = createGetters(copyIdsMirror, tasksMap, childTasksMap);
      action({
        checkTaskIdExists,
        copySelectedTasks,
        copyTask,
        cutSelectedTasks,
        cutTask,
        getCopyParentTasks: getCopyTasksWithCache,
        getCopyTasks: getCopyParentTasksWithCache,
        getCopyTasksWithDescendants: getCopyTasksWithDescendantsWithCache,
        getCutParentTasks: getCutParentTasksWithCache,
        getCutTasks: getCutTasksWithCache,
        getParentTasks: getParentTasksWithCache,
        getSelectedTasks: getSelectedTasksWithCache,
        getTasksWithDescendants: getTasksWithDescendantsWithCache,
        handleAddChilds,
        handleDeleteTasks,
        handleMoveTasksInside,
        makeCopies,
        resetSelectedTasks,
        task
      });
    },
    [
      checkTaskIdExists,
      copyIdsMirror,
      copySelectedTasks,
      copyTask,
      cutIdsMirror,
      cutSelectedTasks,
      cutTask,
      handleAddChilds,
      handleDeleteTasks,
      handleMoveTasksInside,
      makeCopies,
      resetSelectedTasks,
      selectedIdsMirror,
      tasksMap
    ]
  );
  return handleAction;
};
const defaultGetCopiedTaskId = (task, checkExists) => {
  const {
    id
  } = task;
  const prefix = `${id}_copy`;
  for (let i2 = 1; ; ++i2) {
    const nextName = i2 === 1 ? prefix : `${prefix}(${i2})`;
    if (!checkExists(nextName)) {
      return nextName;
    }
  }
};
const copyTasks = (tasks, getCopiedTaskId, checkExistsAtLevel) => {
  const idToCopiedIdMap = /* @__PURE__ */ new Map();
  tasks.forEach((originalTask) => {
    const {
      comparisonLevel = 1
    } = originalTask;
    const idToCopiedIdAtLevelMap = idToCopiedIdMap.get(comparisonLevel) || /* @__PURE__ */ new Map();
    idToCopiedIdAtLevelMap.set(
      originalTask.id,
      getCopiedTaskId(originalTask, (taskId) => checkExistsAtLevel(taskId, comparisonLevel))
    );
    idToCopiedIdMap.set(comparisonLevel, idToCopiedIdAtLevelMap);
  });
  return tasks.map((originalTask) => {
    const {
      id: originalId,
      comparisonLevel = 1,
      parent
    } = originalTask;
    const idToCopiedIdAtLevelMap = idToCopiedIdMap.get(comparisonLevel);
    if (!idToCopiedIdAtLevelMap) {
      throw new Error(`Ids are not found at level ${comparisonLevel}`);
    }
    const newId = idToCopiedIdAtLevelMap.get(originalId);
    if (!newId) {
      throw new Error(`NEw id is not found for task "${originalId}"`);
    }
    const nextParent = parent ? idToCopiedIdAtLevelMap.get(parent) : void 0;
    if (originalTask.type === "empty") {
      return {
        ...originalTask,
        id: newId,
        parent: nextParent
      };
    }
    const {
      dependencies
    } = originalTask;
    return {
      ...originalTask,
      id: newId,
      dependencies: dependencies ? dependencies.map((dependency) => {
        const mappedId = idToCopiedIdAtLevelMap.get(dependency.sourceId);
        if (mappedId) {
          return {
            ...dependency,
            sourceId: mappedId
          };
        }
        return dependency;
      }) : void 0,
      parent: nextParent
    };
  });
};
const copyOption = {
  action: ({
    copySelectedTasks,
    copyTask,
    getParentTasks: getParentTasks2,
    task
  }) => {
    const parentTasks = getParentTasks2();
    if (parentTasks.includes(task)) {
      copySelectedTasks();
    } else {
      copyTask(task);
    }
  },
  label: "Copy"
};
const cutOption = {
  action: ({
    cutSelectedTasks,
    cutTask,
    getSelectedTasks: getSelectedTasks2,
    task
  }) => {
    const selectedTasks = getSelectedTasks2();
    if (selectedTasks.length > 0) {
      cutSelectedTasks();
      return;
    }
    cutTask(task);
  },
  icon: "✂",
  label: "Cut"
};
const pasteOption = {
  action: ({
    getCopyParentTasks,
    getCopyTasksWithDescendants,
    getCutParentTasks,
    handleAddChilds,
    handleMoveTasksInside,
    makeCopies,
    resetSelectedTasks: resetSelectedTasksAction,
    task
  }) => {
    if (task.type !== "project" && task.type !== "task") {
      return;
    }
    const cutParentTasks = getCutParentTasks();
    if (cutParentTasks.length > 0) {
      handleMoveTasksInside(task, cutParentTasks);
      resetSelectedTasksAction();
      return;
    }
    const copyParentTasks = getCopyParentTasks();
    if (copyParentTasks.length > 0) {
      const tasksForCopy = getCopyTasksWithDescendants();
      const copiedTasks = makeCopies(tasksForCopy);
      handleAddChilds(task, copiedTasks);
      resetSelectedTasksAction();
    }
  },
  checkIsAvailable: ({
    checkHasCopyTasks,
    checkHasCutTasks,
    task
  }) => {
    if (task.type === "empty" || task.type === "milestone") {
      return false;
    }
    if (!checkHasCopyTasks() && !checkHasCutTasks()) {
      return false;
    }
    return true;
  },
  label: "Paste"
};
const deleteOption = {
  action: ({
    getTasksWithDescendants: getTasksWithDescendants2,
    handleDeleteTasks,
    resetSelectedTasks: resetSelectedTasksAction,
    task
  }) => {
    const tasksWithDescendants = getTasksWithDescendants2();
    handleDeleteTasks(
      tasksWithDescendants.length === 0 ? [task] : tasksWithDescendants
    );
    resetSelectedTasksAction();
  },
  icon: "×",
  label: "Delete"
};
const countHolidays = (startDate, endDate, checkIsHoliday) => {
  let holidayCount = checkIsHoliday(startDate, "startOfTask") ? 1 : 0;
  let currentStartDate = new Date(startDate);
  currentStartDate.setHours(0);
  currentStartDate.setMinutes(0);
  currentStartDate.setSeconds(0);
  currentStartDate.setDate(currentStartDate.getDate() + 1);
  let currentEndDate = new Date(endDate);
  currentEndDate.setHours(0);
  currentEndDate.setMinutes(0);
  currentEndDate.setSeconds(0);
  while (currentStartDate <= currentEndDate) {
    if (checkIsHoliday(new Date(currentStartDate.getTime()), "endOfTask")) {
      holidayCount++;
    }
    currentStartDate.setDate(currentStartDate.getDate() + 1);
  }
  return holidayCount;
};
const adjustTaskToWorkingDates = ({
  action,
  changedTask,
  checkIsHoliday,
  getNextWorkingDate: getNextWorkingDate2,
  getPreviousWorkingDate: getPreviousWorkingDate2,
  originalTask,
  dateMoveStep
}) => {
  switch (changedTask.type) {
    case "milestone":
      if (checkIsHoliday(
        new Date(changedTask.start.getTime() + 1e3 * 3600),
        "startOfTask"
      )) {
        const nextWorkingDate = getNextWorkingDate2(
          changedTask.start,
          action,
          "startOfTask"
        );
        return {
          ...changedTask,
          start: nextWorkingDate,
          end: nextWorkingDate
        };
      }
      return changedTask;
    default:
      switch (action) {
        case "end": {
          if (checkIsHoliday(changedTask.end, "endOfTask")) {
            const moveEndDelta = changedTask.end.getTime() - originalTask.end.getTime();
            const endDate = moveEndDelta < 0 ? getPreviousWorkingDate2(changedTask.end, action, "endOfTask") : getNextWorkingDate2(changedTask.end, action, "endOfTask");
            return {
              ...changedTask,
              end: endDate
            };
          }
          return changedTask;
        }
        case "start": {
          if (checkIsHoliday(
            new Date(changedTask.start.getTime() + 1e3 * 3600),
            "startOfTask"
          )) {
            const moveStartDelta = changedTask.start.getTime() - originalTask.start.getTime();
            return {
              ...changedTask,
              start: moveStartDelta > 0 ? getNextWorkingDate2(changedTask.start, action, "startOfTask") : getPreviousWorkingDate2(
                changedTask.start,
                action,
                "startOfTask"
              )
            };
          }
          return changedTask;
        }
        case "move": {
          let newStart = changedTask.start;
          let newEnd = changedTask.end;
          const moveDelta = changedTask.start.getTime() - originalTask.start.getTime();
          if (moveDelta !== 0) {
            const durationWithoutHolidays = getDuration(
              originalTask.start,
              originalTask.end,
              checkIsHoliday
            );
            const stepTime = Math.max(
              getStepTime(dateMoveStep),
              ONE_HOUR_DURATION
            );
            const movingToTheRight = moveDelta >= 0;
            if (movingToTheRight) {
              if (checkIsHoliday(changedTask.start, "startOfTask")) {
                newStart = getNextWorkingDate2(
                  changedTask.start,
                  action,
                  "startOfTask"
                );
              }
              newEnd = new Date(newStart.getTime() + durationWithoutHolidays);
              if (checkIsHoliday(newEnd, "endOfTask")) {
                newEnd = getNextWorkingDate2(newStart, action, "endOfTask");
              }
              let newDurationWithoutHolidays = getDuration(
                newStart,
                newEnd,
                checkIsHoliday
              );
              while (newDurationWithoutHolidays < durationWithoutHolidays || checkIsHoliday(newEnd, "endOfTask")) {
                newEnd = new Date(newEnd.getTime() + stepTime);
                newDurationWithoutHolidays = getDuration(
                  newStart,
                  newEnd,
                  checkIsHoliday
                );
              }
            } else {
              if (checkIsHoliday(changedTask.end, "endOfTask")) {
                newEnd = getPreviousWorkingDate2(
                  changedTask.end,
                  action,
                  "endOfTask"
                );
              }
              newStart = new Date(newEnd.getTime() - durationWithoutHolidays);
              if (checkIsHoliday(newStart, "startOfTask")) {
                newStart = getPreviousWorkingDate2(
                  newStart,
                  action,
                  "startOfTask"
                );
              }
              let newDurationWithoutHolidays = getDuration(
                newStart,
                newEnd,
                checkIsHoliday
              );
              while (newDurationWithoutHolidays < durationWithoutHolidays) {
                newStart = new Date(newStart.getTime() - stepTime);
                newDurationWithoutHolidays = getDuration(
                  newStart,
                  newEnd,
                  checkIsHoliday
                );
              }
            }
          }
          return {
            ...changedTask,
            start: newStart,
            end: newEnd
          };
        }
        default:
          return changedTask;
      }
  }
};
const getDuration = (startDate, endDate, checkIsHoliday) => {
  const newHolidaysLength = countHolidays(startDate, endDate, checkIsHoliday);
  const newDurationWithoutHolidays = endDate.getTime() - startDate.getTime() - newHolidaysLength * ONE_DAY_DURATION;
  return newDurationWithoutHolidays;
};
const getNextWorkingDate = (date, action, roundDate, dateExtremity, checkIsHoliday, dateMoveStep) => {
  let currentDate = incrementDate(
    date,
    action,
    roundDate,
    dateExtremity,
    dateMoveStep,
    false
  );
  while (checkIsHoliday(currentDate, dateExtremity)) {
    const incrementedDate = incrementDate(
      currentDate,
      action,
      roundDate,
      dateExtremity,
      dateMoveStep,
      true
    );
    if (incrementedDate <= currentDate) {
      break;
    } else {
      currentDate = incrementedDate;
    }
  }
  return currentDate;
};
const getPreviousWorkingDate = (date, action, roundDate, dateExtremity, checkIsHoliday, dateMoveStep) => {
  let currentDate = decrementDate(
    date,
    action,
    roundDate,
    dateExtremity,
    dateMoveStep,
    false
  );
  while (checkIsHoliday(currentDate, dateExtremity)) {
    const decrementedDate = decrementDate(
      currentDate,
      action,
      roundDate,
      dateExtremity,
      dateMoveStep,
      true
    );
    if (decrementedDate >= currentDate) {
      break;
    } else {
      currentDate = decrementedDate;
    }
  }
  return currentDate;
};
const useHolidays = ({
  checkIsHolidayProp,
  dateSetup,
  isAdjustToWorkingDates,
  minTaskDate,
  roundDate,
  dateMoveStep
}) => {
  const checkIsHoliday = useCallback(
    (date, dateExtremity) => checkIsHolidayProp(date, minTaskDate, dateSetup, dateExtremity),
    [checkIsHolidayProp, dateSetup, minTaskDate]
  );
  const getNextWorkingDate$1 = (date, action, dateExtremity) => getNextWorkingDate(
    date,
    action,
    roundDate,
    dateExtremity,
    checkIsHoliday,
    dateMoveStep
  );
  const getPreviousWorkingDate$1 = (date, action, dateExtremity) => getPreviousWorkingDate(
    date,
    action,
    roundDate,
    dateExtremity,
    checkIsHoliday,
    dateMoveStep
  );
  const adjustTaskToWorkingDates$1 = ({
    action,
    changedTask,
    originalTask
  }) => {
    const nbDaysTimeStep = getStepTime(dateMoveStep) / (1e3 * 3600 * 24);
    if (isAdjustToWorkingDates && nbDaysTimeStep <= 2) {
      return adjustTaskToWorkingDates({
        action,
        changedTask,
        checkIsHoliday,
        getNextWorkingDate: getNextWorkingDate$1,
        getPreviousWorkingDate: getPreviousWorkingDate$1,
        originalTask,
        dateMoveStep
      });
    }
    return changedTask;
  };
  return {
    checkIsHoliday,
    adjustTaskToWorkingDates: adjustTaskToWorkingDates$1
  };
};
const defaultColors = {
  arrowColor: "grey",
  arrowCriticalColor: "#ff0000",
  arrowWarningColor: "#ffbc00",
  barLabelColor: "#000",
  barLabelWhenOutsideColor: "#555",
  barProgressColor: "#a3a3ff",
  barProgressCriticalColor: "#ff1919",
  barProgressSelectedColor: "#8282f5",
  barProgressSelectedCriticalColor: "#ff0000",
  barBackgroundColor: "#b8c2cc",
  barBackgroundCriticalColor: "#ff6363",
  barBackgroundSelectedColor: "#aeb8c2",
  barBackgroundSelectedCriticalColor: "#ff8e8e",
  groupProgressColor: "#2dbb2e",
  groupProgressCriticalColor: "#2dbb2e",
  groupProgressSelectedColor: "#28a329",
  groupProgressSelectedCriticalColor: "#28a329",
  groupBackgroundColor: "#006bc1",
  groupBackgroundCriticalColor: "#006bc1",
  groupBackgroundSelectedColor: "#407fbf",
  groupBackgroundSelectedCriticalColor: "#407fbf",
  projectProgressColor: "#7db59a",
  projectProgressCriticalColor: "#7db59a",
  projectProgressSelectedColor: "#59a985",
  projectProgressSelectedCriticalColor: "#59a985",
  projectBackgroundColor: "#fac465",
  projectBackgroundCriticalColor: "#fac465",
  projectBackgroundSelectedColor: "#f7bb53",
  projectBackgroundSelectedCriticalColor: "#f7bb53",
  milestoneBackgroundColor: "#f1c453",
  milestoneBackgroundCriticalColor: "#ff8e8e",
  milestoneBackgroundSelectedColor: "#f29e4c",
  milestoneBackgroundSelectedCriticalColor: "#ff0000",
  evenTaskBackgroundColor: "#f5f5f5",
  oddTaskBackgroundColor: "#fff",
  holidayBackgroundColor: "rgba(233, 233, 233, 0.3)",
  selectedTaskBackgroundColor: "rgba(252, 248, 227, 0.5)",
  taskDragColor: "#7474ff",
  todayColor: "rgba(252, 248, 227, 0.5)",
  contextMenuBoxShadow: "rgb(0 0 0 / 25%) 1px 1px 5px 1px",
  contextMenuBgColor: "#fff",
  contextMenuTextColor: "inherit"
};
const defaultDateFormats = {
  dateColumnFormat: "E, d MMMM yyyy",
  dayBottomHeaderFormat: "E, d",
  dayTopHeaderFormat: "E, d",
  hourBottomHeaderFormat: "HH",
  monthBottomHeaderFormat: "LLL",
  monthTopHeaderFormat: "LLLL"
};
const defaultDistances = {
  actionColumnWidth: 40,
  arrowIndent: 20,
  barCornerRadius: 3,
  barFill: 60,
  columnWidth: 60,
  contextMenuIconWidth: 20,
  contextMenuOptionHeight: 25,
  contextMenuSidePadding: 10,
  dateCellWidth: 220,
  dependenciesCellWidth: 120,
  dependencyFixHeight: 20,
  dependencyFixIndent: 50,
  dependencyFixWidth: 20,
  expandIconWidth: 20,
  handleWidth: 8,
  headerHeight: 50,
  minimumRowDisplayed: 4,
  nestedTaskNameOffset: 20,
  relationCircleOffset: 10,
  relationCircleRadius: 5,
  rowHeight: 50,
  taskWarningOffset: 35,
  titleCellWidth: 220
};
const MINIMUM_DISPLAYED_TIME_UNIT = 30;
const Gantt = ({
  TaskListHeader = TaskListHeaderDefault,
  TaskListTable = TaskListTableDefault,
  TooltipContent = StandardTooltipContent,
  ContextualPalette,
  TaskDependencyContextualPalette,
  authorizedRelations = [
    "startToStart",
    "startToEnd",
    "endToStart",
    "endToEnd"
  ],
  canMoveTasks = true,
  canResizeColumns = true,
  checkIsHoliday: checkIsHolidayProp = defaultCheckIsHoliday,
  colors = defaultColors,
  columns: columnsProp = void 0,
  comparisonLevels = 1,
  contextMenuOptions: contextMenuOptionsProp = void 0,
  dateFormats: dateFormatsProp = void 0,
  dateLocale = enDateLocale,
  distances: distancesProp = void 0,
  enableTableListContextMenu = false,
  fixEndPosition: fixEndPositionProp = void 0,
  fixStartPosition: fixStartPositionProp = void 0,
  fontFamily = "Arial, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue",
  fontSize = "14px",
  getCopiedTaskId = defaultGetCopiedTaskId,
  icons = void 0,
  isDeleteDependencyOnDoubleClick = true,
  isMoveChildsWithParent = true,
  isUpdateDisabledParentsOnChange = true,
  isShowChildOutOfParentWarnings = false,
  isShowCriticalPath = false,
  isShowDependencyWarnings = false,
  isShowTaskNumbers = true,
  isUnknownDates = false,
  isAdjustToWorkingDates = true,
  onAddTask = void 0,
  onAddTaskClick = void 0,
  onArrowDoubleClick: onArrowDoubleClickProp = void 0,
  onChangeExpandState = void 0,
  onChangeTasks = void 0,
  onClick = void 0,
  onDateChange: onDateChangeProp = void 0,
  onDelete = void 0,
  onDoubleClick = void 0,
  onEditTask = void 0,
  onEditTaskClick = void 0,
  onFixDependencyPosition: onFixDependencyPositionProp = void 0,
  onMoveTaskBefore = void 0,
  onMoveTaskAfter = void 0,
  onMoveTaskInside = void 0,
  onProgressChange: onProgressChangeProp = void 0,
  onRelationChange: onRelationChangeProp = void 0,
  onResizeColumn = void 0,
  onWheel,
  preStepsCount = 1,
  renderBottomHeader = void 0,
  renderTopHeader = void 0,
  roundDate: roundDateProp = defaultRoundDate,
  dateMoveStep = { value: 1, timeUnit: GanttDateRoundingTimeUnit.DAY },
  rtl = false,
  tasks,
  timeStep = 3e5,
  viewDate,
  viewMode = ViewMode.Day
}) => {
  const ganttSVGRef = useRef(null);
  const wrapperRef = useRef(null);
  const taskListRef = useRef(null);
  const { contextMenu, handleCloseContextMenu, handleOpenContextMenu } = useContextMenu(wrapperRef);
  const [
    ganttTaskContentRef,
    taskListContentRef,
    setScrollYProgrammatically,
    onScrollVertically
  ] = useVerticalScrollbars();
  const [
    ganttTaskRootRef,
    scrollX,
    setScrollXProgrammatically,
    onVerticalScrollbarScrollX,
    scrollToLeftStep,
    scrollToRightStep
  ] = useHorizontalScrollbars();
  const roundDate = useCallback(
    (date, action, dateExtremity) => roundDateProp(date, viewMode, dateExtremity, action),
    [roundDateProp, viewMode]
  );
  const [currentViewDate, setCurrentViewDate] = useState(
    void 0
  );
  const [sortedTasks, setSortedTasks] = useState(
    () => [...tasks].sort(sortTasks)
  );
  useEffect(() => {
    setSortedTasks([...tasks].sort(sortTasks));
  }, [tasks]);
  const [childTasksMap, rootTasksMap] = useMemo(
    () => getChildsAndRoots(sortedTasks, null),
    [sortedTasks]
  );
  const [visibleTasks, visibleTasksMirror] = useMemo(
    () => collectVisibleTasks(childTasksMap, rootTasksMap),
    [childTasksMap, rootTasksMap]
  );
  const tasksMap = useMemo(() => getTasksMap(tasks), [tasks]);
  const checkTaskIdExists = useCallback(
    (newId, comparisonLevel = 1) => {
      const tasksAtLevelMap = tasksMap.get(comparisonLevel);
      if (!tasksAtLevelMap) {
        return false;
      }
      return tasksAtLevelMap.has(newId);
    },
    [tasksMap]
  );
  const makeCopies = useCallback(
    (tasksForCopy) => copyTasks(tasksForCopy, getCopiedTaskId, checkTaskIdExists),
    [checkTaskIdExists, getCopiedTaskId]
  );
  const mapTaskToGlobalIndex = useMemo(
    () => getMapTaskToGlobalIndex(tasks),
    [tasks]
  );
  const getTaskGlobalIndexByRef = useCallback(
    (task) => {
      const { id, comparisonLevel = 1 } = task;
      const indexesByLevel = mapTaskToGlobalIndex.get(comparisonLevel);
      if (!indexesByLevel) {
        return -1;
      }
      const res = indexesByLevel.get(id);
      if (typeof res === "number") {
        return res;
      }
      return -1;
    },
    [mapTaskToGlobalIndex]
  );
  const mapTaskToNestedIndex = useMemo(
    () => getMapTaskToNestedIndex(childTasksMap, rootTasksMap),
    [childTasksMap, rootTasksMap]
  );
  const childOutOfParentWarnings = useMemo(() => {
    if (!isShowChildOutOfParentWarnings) {
      return null;
    }
    return getChildOutOfParentWarnings(tasks, childTasksMap);
  }, [tasks, childTasksMap, isShowChildOutOfParentWarnings]);
  const distances = useMemo(
    () => ({
      ...defaultDistances,
      ...distancesProp
    }),
    [distancesProp]
  );
  const fullRowHeight = useMemo(
    () => distances.rowHeight * comparisonLevels,
    [distances, comparisonLevels]
  );
  const renderedRowIndexes = useOptimizedList(
    ganttTaskContentRef,
    "scrollTop",
    distances.rowHeight
  );
  const colorStyles = useMemo(
    () => ({
      ...defaultColors,
      ...colors
    }),
    [colors]
  );
  const taskHeight = useMemo(
    () => distances.rowHeight * distances.barFill / 100,
    [distances]
  );
  const taskYOffset = useMemo(
    () => (distances.rowHeight - taskHeight) / 2,
    [distances, taskHeight]
  );
  const taskHalfHeight = useMemo(
    () => Math.round(taskHeight / 2),
    [taskHeight]
  );
  const maxLevelLength = useMemo(() => {
    let maxLength = 0;
    const countByLevel = {};
    visibleTasks.forEach(({ comparisonLevel = 1 }) => {
      if (!countByLevel[comparisonLevel]) {
        countByLevel[comparisonLevel] = 0;
      }
      ++countByLevel[comparisonLevel];
      if (comparisonLevel <= comparisonLevels && maxLength < countByLevel[comparisonLevel]) {
        maxLength = countByLevel[comparisonLevel];
      }
    });
    return maxLength;
  }, [visibleTasks, comparisonLevels]);
  const ganttFullHeight = useMemo(
    () => maxLevelLength * fullRowHeight,
    [maxLevelLength, fullRowHeight]
  );
  const [taskToRowIndexMap, rowIndexToTaskMap, mapGlobalRowIndexToTask] = useMemo(
    () => getMapTaskToRowIndex(visibleTasks, comparisonLevels),
    [visibleTasks, comparisonLevels]
  );
  const {
    checkHasCopyTasks,
    checkHasCutTasks,
    copyIdsMirror,
    copySelectedTasks,
    copyTask,
    cutIdsMirror,
    cutSelectedTasks,
    cutTask,
    resetSelectedTasks,
    selectTaskOnMouseDown,
    selectedIdsMirror
  } = useSelection(taskToRowIndexMap, rowIndexToTaskMap, checkTaskIdExists);
  const [startDate, minTaskDate, datesLength] = useMemo(
    () => ganttDateRange(visibleTasks, viewMode, preStepsCount),
    [visibleTasks, viewMode, preStepsCount]
  );
  const getDate = useCallback(
    (index2) => getDateByOffset(startDate, index2, viewMode),
    [startDate, viewMode]
  );
  const dateFormats2 = useMemo(
    () => ({
      ...defaultDateFormats,
      ...dateFormatsProp
    }),
    [dateFormatsProp]
  );
  const dateSetup = useMemo(
    () => ({
      dateFormats: dateFormats2,
      dateLocale,
      isUnknownDates,
      preStepsCount,
      viewMode
    }),
    [dateFormats2, dateLocale, isUnknownDates, preStepsCount, viewMode]
  );
  const { checkIsHoliday, adjustTaskToWorkingDates: adjustTaskToWorkingDates2 } = useHolidays({
    checkIsHolidayProp,
    dateSetup,
    isAdjustToWorkingDates,
    minTaskDate,
    roundDate,
    dateMoveStep
  });
  const svgWidth = useMemo(
    () => Math.max(MINIMUM_DISPLAYED_TIME_UNIT, datesLength) * distances.columnWidth,
    [datesLength, distances]
  );
  const renderedColumnIndexes = useOptimizedList(
    ganttTaskRootRef,
    "scrollLeft",
    distances.columnWidth
  );
  const svgClientWidth = renderedColumnIndexes && renderedColumnIndexes[4];
  const countTaskCoordinates$1 = useCallback(
    (task) => countTaskCoordinates(
      task,
      taskToRowIndexMap,
      startDate,
      viewMode,
      rtl,
      fullRowHeight,
      taskHeight,
      taskYOffset,
      distances,
      svgWidth
    ),
    [
      taskToRowIndexMap,
      startDate,
      viewMode,
      rtl,
      fullRowHeight,
      taskHeight,
      taskYOffset,
      distances,
      svgWidth
    ]
  );
  const mapTaskToCoordinates = useMemo(
    () => getMapTaskToCoordinates(
      tasks,
      visibleTasksMirror,
      taskToRowIndexMap,
      startDate,
      viewMode,
      rtl,
      fullRowHeight,
      taskHeight,
      taskYOffset,
      distances,
      svgWidth
    ),
    [
      distances,
      fullRowHeight,
      taskToRowIndexMap,
      rtl,
      startDate,
      svgWidth,
      taskHeight,
      tasks,
      taskYOffset,
      viewMode,
      visibleTasksMirror
    ]
  );
  const scrollToTask = useCallback(
    (task) => {
      const { x1 } = getTaskCoordinates(task, mapTaskToCoordinates);
      setScrollXProgrammatically(x1 - 100);
    },
    [mapTaskToCoordinates, setScrollXProgrammatically]
  );
  const [dependencyMap, dependentMap, dependencyMarginsMap] = useMemo(
    () => getDependencyMapAndWarnings(
      tasks,
      visibleTasksMirror,
      tasksMap,
      mapTaskToCoordinates,
      fullRowHeight,
      isShowDependencyWarnings,
      isShowCriticalPath
    ),
    [
      tasks,
      visibleTasksMirror,
      tasksMap,
      mapTaskToCoordinates,
      fullRowHeight,
      isShowDependencyWarnings,
      isShowCriticalPath
    ]
  );
  const criticalPaths = useMemo(() => {
    if (isShowCriticalPath) {
      return getCriticalPath(
        rootTasksMap,
        childTasksMap,
        tasksMap,
        dependencyMarginsMap,
        dependencyMap
      );
    }
    return null;
  }, [
    isShowCriticalPath,
    rootTasksMap,
    childTasksMap,
    tasksMap,
    dependencyMarginsMap,
    dependencyMap
  ]);
  const taskToHasDependencyWarningMap = useMemo(() => {
    if (!isShowDependencyWarnings) {
      return null;
    }
    return getTaskToHasDependencyWarningMap(dependencyMarginsMap);
  }, [dependencyMarginsMap, isShowDependencyWarnings]);
  useEffect(() => {
    if (rtl) {
      setScrollXProgrammatically(datesLength * distances.columnWidth);
    }
  }, [datesLength, distances, rtl, setScrollXProgrammatically, scrollX]);
  useEffect(() => {
    if (viewDate && !currentViewDate || viewDate && (currentViewDate == null ? void 0 : currentViewDate.valueOf()) !== viewDate.valueOf()) {
      const index2 = getDatesDiff(viewDate, startDate, viewMode);
      if (index2 < 0) {
        return;
      }
      setCurrentViewDate(viewDate);
      setScrollXProgrammatically(distances.columnWidth * index2);
    }
  }, [
    currentViewDate,
    distances,
    setCurrentViewDate,
    setScrollXProgrammatically,
    startDate,
    viewDate,
    viewMode
  ]);
  useEffect(() => {
    const handleWheel = (event) => {
      if (onWheel) {
        onWheel(event);
      }
    };
    const wrapperNode = wrapperRef.current;
    if (wrapperNode) {
      wrapperNode.addEventListener("wheel", handleWheel, {
        passive: false
      });
    }
    return () => {
      if (wrapperNode) {
        wrapperNode.removeEventListener("wheel", handleWheel);
      }
    };
  }, [wrapperRef, onWheel]);
  const handleKeyDown = (event) => {
    const { columnWidth, rowHeight } = distances;
    event.preventDefault();
    let newScrollY = ganttTaskContentRef.current.scrollTop;
    let newScrollX = scrollX;
    let isX = true;
    switch (event.key) {
      case "Down":
      case "ArrowDown":
        newScrollY += rowHeight;
        isX = false;
        break;
      case "Up":
      case "ArrowUp":
        newScrollY -= rowHeight;
        isX = false;
        break;
      case "Left":
      case "ArrowLeft":
        newScrollX -= columnWidth;
        break;
      case "Right":
      case "ArrowRight":
        newScrollX += columnWidth;
        break;
    }
    if (isX) {
      if (newScrollX < 0) {
        newScrollX = 0;
      } else if (newScrollX > svgWidth) {
        newScrollX = svgWidth;
      }
      setScrollXProgrammatically(newScrollX);
    } else {
      setScrollYProgrammatically(newScrollY);
    }
  };
  const handleExpanderClick = useCallback(
    (clickedTask) => {
      if (onChangeExpandState) {
        onChangeExpandState({
          ...clickedTask,
          hideChildren: !clickedTask.hideChildren
        });
      } else {
        setSortedTasks((prev) => {
          return prev.map((task) => {
            if (clickedTask.id === task.id) {
              return { ...task, hideChildren: !clickedTask.hideChildren };
            }
            return task;
          });
        });
      }
    },
    [onChangeExpandState]
  );
  const onCollapseAll = () => {
    setSortedTasks(
      (prev) => prev.map((task) => ({ ...task, hideChildren: true }))
    );
  };
  const onExpandFirstLevel = () => {
    setSortedTasks(
      (prev) => prev.map((task) => {
        if (!task.parent) {
          return { ...task, hideChildren: false };
        }
        return { ...task, hideChildren: true };
      })
    );
  };
  const onExpandAll = () => {
    setSortedTasks(
      (prev) => prev.map((task) => ({ ...task, hideChildren: false }))
    );
  };
  const getMetadata = useCallback(
    (changeAction) => getChangeTaskMetadata({
      adjustTaskToWorkingDates: adjustTaskToWorkingDates2,
      changeAction,
      childTasksMap,
      dependentMap,
      mapTaskToGlobalIndex,
      isUpdateDisabledParentsOnChange,
      isMoveChildsWithParent,
      tasksMap
    }),
    [
      adjustTaskToWorkingDates2,
      childTasksMap,
      dependentMap,
      isMoveChildsWithParent,
      isUpdateDisabledParentsOnChange,
      mapTaskToGlobalIndex,
      tasksMap
    ]
  );
  const prepareSuggestions = useCallback(
    (suggestions) => {
      const prevTasks = [...tasks];
      const nextTasks = prevTasks;
      suggestions.forEach(([start, end, task, index2]) => {
        nextTasks[index2] = {
          ...task,
          start,
          end
        };
      });
      return nextTasks;
    },
    [tasks]
  );
  const handleEditTask = useCallback(
    (task) => {
      if (!onEditTaskClick && (!onEditTask || !onChangeTasks)) {
        return;
      }
      const { id, comparisonLevel = 1 } = task;
      const indexesOnLevel = mapTaskToGlobalIndex.get(comparisonLevel);
      if (!indexesOnLevel) {
        throw new Error(`Indexes are not found for level ${comparisonLevel}`);
      }
      const taskIndex = indexesOnLevel.get(id);
      if (typeof taskIndex !== "number") {
        throw new Error(`Index is not found for task ${id}`);
      }
      if (onEditTaskClick) {
        onEditTaskClick(
          task,
          taskIndex,
          (changedTask) => getMetadata({
            type: "change",
            task: changedTask
          })
        );
      } else if (onEditTask && onChangeTasks) {
        onEditTask(task).then((nextTask) => {
          if (!nextTask) {
            return;
          }
          const [, , , suggestions] = getMetadata({
            type: "change",
            task: nextTask
          });
          const withSuggestions = prepareSuggestions(suggestions);
          withSuggestions[taskIndex] = nextTask;
          onChangeTasks(withSuggestions, {
            type: "edit_task"
          });
        });
      }
    },
    [
      onChangeTasks,
      onEditTask,
      onEditTaskClick,
      getMetadata,
      mapTaskToGlobalIndex,
      prepareSuggestions
    ]
  );
  const handleAddChilds = useCallback(
    (parent, descendants) => {
      if (!onChangeTasks) {
        return;
      }
      const addedIdsMap = /* @__PURE__ */ new Map();
      descendants.forEach((descendant) => {
        const { id: descendantId, comparisonLevel = 1 } = descendant;
        const addedIdsAtLevelSet = addedIdsMap.get(comparisonLevel) || /* @__PURE__ */ new Set();
        addedIdsAtLevelSet.add(descendantId);
        addedIdsMap.set(comparisonLevel, addedIdsAtLevelSet);
      });
      const [addedChildsByLevelMap, addedRootsByLevelMap] = getChildsAndRoots(
        descendants,
        (descendant) => {
          const { comparisonLevel = 1, parent: parent2 } = descendant;
          if (!parent2) {
            return true;
          }
          const addedIdsAtLevelSet = addedIdsMap.get(comparisonLevel);
          if (!addedIdsAtLevelSet) {
            throw new Error(`Ids are not found at level ${comparisonLevel}`);
          }
          return !addedIdsAtLevelSet.has(parent2);
        }
      );
      const [, [{ index: taskIndex }], , suggestions] = getMetadata({
        type: "add-childs",
        parent,
        addedIdsMap,
        addedChildsByLevelMap,
        addedRootsByLevelMap,
        descendants
      });
      const withSuggestions = prepareSuggestions(suggestions);
      descendants.forEach((descendant, index2) => {
        const { parent: parentId, comparisonLevel = 1 } = descendant;
        const addedIdsAtLevelSet = addedIdsMap.get(comparisonLevel);
        if (!addedIdsAtLevelSet) {
          throw new Error(`Ids are not found at level ${comparisonLevel}`);
        }
        const nextTask = !parentId || !addedIdsAtLevelSet.has(parentId) ? {
          ...descendant,
          parent: parent.id
        } : descendant;
        withSuggestions.splice(taskIndex + 1 + index2, 0, nextTask);
      });
      onChangeTasks(withSuggestions, {
        type: "add_tasks"
      });
    },
    [onChangeTasks, getMetadata, prepareSuggestions]
  );
  const handleAddTask = useCallback(
    (task) => {
      if (onAddTaskClick) {
        onAddTaskClick(
          task,
          (newTask) => getMetadata({
            type: "add-childs",
            parent: task,
            descendants: [newTask],
            addedIdsMap: /* @__PURE__ */ new Map([
              [newTask.comparisonLevel || 1, /* @__PURE__ */ new Set([newTask.id])]
            ]),
            addedChildsByLevelMap: /* @__PURE__ */ new Map([
              [newTask.comparisonLevel || 1, /* @__PURE__ */ new Map()]
            ]),
            addedRootsByLevelMap: /* @__PURE__ */ new Map([
              [newTask.comparisonLevel || 1, [newTask]]
            ])
          })
        );
      } else if (onAddTask && onChangeTasks) {
        onAddTask(task).then((nextTask) => {
          if (!nextTask) {
            return;
          }
          handleAddChilds(task, [nextTask]);
        });
      }
    },
    [
      handleAddChilds,
      onAddTask,
      onAddTaskClick,
      onChangeTasks,
      getMetadata,
      prepareSuggestions
    ]
  );
  const xStep = useMemo(() => {
    const secondDate = getDateByOffset(startDate, 1, viewMode);
    const dateDelta = secondDate.getTime() - startDate.getTime() - secondDate.getTimezoneOffset() * 60 * 1e3 + startDate.getTimezoneOffset() * 60 * 1e3;
    const newXStep = timeStep * distances.columnWidth / dateDelta;
    return newXStep;
  }, [distances, startDate, timeStep, viewMode]);
  const onDateChange = useCallback(
    (action, changedTask, originalTask) => {
      const adjustedTask = adjustTaskToWorkingDates2({
        action,
        changedTask,
        originalTask,
        roundDate
      });
      const changeAction = action === "move" ? {
        type: "change_start_and_end",
        task: adjustedTask,
        changedTask,
        originalTask
      } : {
        type: "change",
        task: adjustedTask
      };
      const [dependentTasks, taskIndexes, parents, suggestions] = getMetadata(changeAction);
      const taskIndex = taskIndexes[0].index;
      if (onDateChangeProp) {
        onDateChangeProp(
          adjustedTask,
          dependentTasks,
          taskIndex,
          parents,
          suggestions
        );
      }
      if (onChangeTasks) {
        const withSuggestions = prepareSuggestions(suggestions);
        withSuggestions[taskIndex] = adjustedTask;
        onChangeTasks(withSuggestions, {
          type: "date_change"
        });
      }
    },
    [
      adjustTaskToWorkingDates2,
      getMetadata,
      prepareSuggestions,
      onChangeTasks,
      onDateChangeProp
    ]
  );
  const onProgressChange = useCallback(
    (task) => {
      const [dependentTasks, taskIndexes] = getMetadata({
        type: "change",
        task
      });
      const taskIndex = taskIndexes[0].index;
      if (onProgressChangeProp) {
        onProgressChangeProp(task, dependentTasks, taskIndex);
      }
      if (onChangeTasks) {
        const nextTasks = [...tasks];
        nextTasks[taskIndex] = task;
        onChangeTasks(nextTasks, {
          type: "progress_change"
        });
      }
    },
    [getMetadata, onChangeTasks, onProgressChangeProp, childTasksMap]
  );
  const [changeInProgress, handleTaskDragStart] = useTaskDrag({
    childTasksMap,
    dependentMap,
    ganttSVGRef,
    mapTaskToCoordinates,
    mapTaskToGlobalIndex,
    onDateChange,
    onProgressChange,
    rtl,
    roundDate,
    dateMoveStep,
    scrollToLeftStep,
    scrollToRightStep,
    scrollX,
    setScrollXProgrammatically,
    svgClientWidth,
    svgWidth,
    tasksMap,
    timeStep,
    xStep
  });
  const {
    tooltipTask,
    tooltipX,
    tooltipY,
    tooltipStrategy,
    setFloatingRef,
    getFloatingProps,
    onChangeTooltipTask
  } = useTaskTooltip(changeInProgress);
  const handleDeleteTasks = useCallback(
    (tasksForDelete) => {
      if (!onDelete && !onChangeTasks) {
        return;
      }
      onChangeTooltipTask(null, null);
      const deletedIdsMap = /* @__PURE__ */ new Map();
      tasksForDelete.forEach((task) => {
        const { id: taskId, comparisonLevel = 1 } = task;
        const deletedIdsAtLevel = deletedIdsMap.get(comparisonLevel) || /* @__PURE__ */ new Set();
        deletedIdsAtLevel.add(taskId);
        deletedIdsMap.set(comparisonLevel, deletedIdsAtLevel);
      });
      const [dependentTasks, taskIndexes, parents, suggestions] = getMetadata({
        type: "delete",
        tasks: tasksForDelete,
        deletedIdsMap
      });
      if (onDelete) {
        onDelete(
          tasksForDelete,
          dependentTasks,
          taskIndexes,
          parents,
          suggestions
        );
      }
      if (onChangeTasks) {
        let withSuggestions = prepareSuggestions(suggestions);
        suggestions.forEach(([start, end, task, index2]) => {
          withSuggestions[index2] = {
            ...task,
            start,
            end
          };
        });
        const deletedIndexesSet = new Set(
          taskIndexes.map(({ index: index2 }) => index2)
        );
        withSuggestions = withSuggestions.filter(
          (_, index2) => !deletedIndexesSet.has(index2)
        );
        onChangeTasks(withSuggestions, {
          type: "delete_task",
          payload: {
            tasks: tasksForDelete,
            taskIndexes: [...deletedIndexesSet]
          }
        });
      }
    },
    [
      getMetadata,
      onChangeTasks,
      onDelete,
      prepareSuggestions,
      onChangeTooltipTask
    ]
  );
  const handleMoveTaskAfter = useCallback(
    (target, taskForMove) => {
      if (!onMoveTaskAfter && !onChangeTasks) {
        return;
      }
      onChangeTooltipTask(null, null);
      const [dependentTasks, taskIndexes, parents, suggestions] = getMetadata({
        type: "move-after",
        target,
        taskForMove
      });
      const taskIndex = taskIndexes[0].index;
      const { id, comparisonLevel = 1 } = taskForMove;
      const indexesOnLevel = mapTaskToGlobalIndex.get(comparisonLevel);
      if (!indexesOnLevel) {
        throw new Error(`Indexes are not found for level ${comparisonLevel}`);
      }
      const taskForMoveIndex = indexesOnLevel.get(id);
      if (typeof taskForMoveIndex !== "number") {
        throw new Error(`Index is not found for task ${id}`);
      }
      if (onMoveTaskAfter) {
        onMoveTaskAfter(
          target,
          taskForMove,
          dependentTasks,
          taskIndex,
          taskForMoveIndex,
          parents,
          suggestions
        );
      }
      if (onChangeTasks) {
        const withSuggestions = prepareSuggestions(suggestions);
        const isMovedTaskBefore = taskForMoveIndex < taskIndex;
        withSuggestions.splice(taskForMoveIndex, 1);
        withSuggestions.splice(
          isMovedTaskBefore ? taskIndex : taskIndex + 1,
          0,
          {
            ...taskForMove,
            parent: target.parent
          }
        );
        onChangeTasks(withSuggestions, {
          type: "move_task_after"
        });
      }
    },
    [
      getMetadata,
      onChangeTasks,
      onMoveTaskAfter,
      mapTaskToGlobalIndex,
      prepareSuggestions,
      onChangeTooltipTask
    ]
  );
  const handleMoveTaskBefore = useCallback(
    (target, taskForMove) => {
      if (!onMoveTaskBefore && !onChangeTasks) {
        return;
      }
      onChangeTooltipTask(null, null);
      const [dependentTasks, taskIndexes, parents, suggestions] = getMetadata({
        type: "move-before",
        target,
        taskForMove
      });
      const taskIndex = taskIndexes[0].index;
      const { id, comparisonLevel = 1 } = taskForMove;
      const indexesOnLevel = mapTaskToGlobalIndex.get(comparisonLevel);
      if (!indexesOnLevel) {
        throw new Error(`Indexes are not found for level ${comparisonLevel}`);
      }
      const taskForMoveIndex = indexesOnLevel.get(id);
      if (typeof taskForMoveIndex !== "number") {
        throw new Error(`Index is not found for task ${id}`);
      }
      if (onMoveTaskBefore) {
        onMoveTaskBefore(
          target,
          taskForMove,
          dependentTasks,
          taskIndex,
          taskForMoveIndex,
          parents,
          suggestions
        );
      }
      if (onChangeTasks) {
        const withSuggestions = prepareSuggestions(suggestions);
        const isMovedTaskBefore = taskForMoveIndex < taskIndex;
        withSuggestions.splice(taskForMoveIndex, 1);
        withSuggestions.splice(
          isMovedTaskBefore ? taskIndex - 1 : taskIndex,
          0,
          {
            ...taskForMove,
            parent: target.parent
          }
        );
        onChangeTasks(withSuggestions, {
          type: "move_task_before"
        });
      }
    },
    [
      getMetadata,
      onChangeTasks,
      onMoveTaskBefore,
      mapTaskToGlobalIndex,
      prepareSuggestions,
      onChangeTooltipTask
    ]
  );
  const handleMoveTasksInside = useCallback(
    (parent, childs) => {
      if (!onMoveTaskInside && !onChangeTasks) {
        return;
      }
      onChangeTooltipTask(null, null);
      const { comparisonLevel = 1 } = parent;
      const indexesAtLevel = mapTaskToGlobalIndex.get(comparisonLevel);
      if (!indexesAtLevel) {
        throw new Error(`Indexes are not found at level ${comparisonLevel}`);
      }
      const childIndexes = [];
      const movedIdsMap = /* @__PURE__ */ new Map();
      childs.forEach((child) => {
        const { id: childId, comparisonLevel: childComparisonLevel = 1 } = child;
        const movedIdsAtLevelSet = movedIdsMap.get(childComparisonLevel) || /* @__PURE__ */ new Set();
        movedIdsAtLevelSet.add(childId);
        movedIdsMap.set(childComparisonLevel, movedIdsAtLevelSet);
        if (comparisonLevel !== childComparisonLevel) {
          return;
        }
        const childIndex = indexesAtLevel.get(childId);
        if (typeof childIndex !== "number") {
          return;
        }
        childIndexes.push(childIndex);
      });
      const [dependentTasks, parentIndexes, parents, suggestions] = getMetadata(
        {
          type: "move-inside",
          parent,
          childs,
          movedIdsMap
        }
      );
      const parentIndex = parentIndexes[0].index;
      if (onMoveTaskInside) {
        onMoveTaskInside(
          parent,
          childs,
          dependentTasks,
          parentIndex,
          childIndexes,
          parents,
          suggestions
        );
      }
      if (onChangeTasks) {
        let withSuggestions = prepareSuggestions(suggestions);
        const parentDisplacement = childIndexes.filter(
          (childIndex) => childIndex < parentIndex
        ).length;
        const childIndexesSet = new Set(childIndexes);
        withSuggestions = withSuggestions.filter(
          (_, index2) => !childIndexesSet.has(index2)
        );
        const startNewChildIndex = parentIndex - parentDisplacement + 1;
        childs.forEach((child, indexInChildsArray) => {
          withSuggestions.splice(startNewChildIndex + indexInChildsArray, 0, {
            ...child,
            parent: parent.id
          });
        });
        onChangeTasks(withSuggestions, {
          type: "move_task_inside"
        });
      }
    },
    [
      getMetadata,
      onChangeTasks,
      onMoveTaskInside,
      mapTaskToGlobalIndex,
      prepareSuggestions,
      onChangeTooltipTask
    ]
  );
  const fixStartPosition = useCallback(
    (task, date, index2) => {
      if (fixStartPositionProp) {
        fixStartPositionProp(task, date, index2);
      }
      if (onChangeTasks) {
        const nextTasks = [...tasks];
        nextTasks[index2] = {
          ...task,
          start: date
        };
        onChangeTasks(nextTasks, {
          type: "fix_start_position"
        });
      }
    },
    [fixStartPositionProp, onChangeTasks, tasks]
  );
  const fixEndPosition = useCallback(
    (task, date, index2) => {
      if (fixEndPositionProp) {
        fixEndPositionProp(task, date, index2);
      }
      if (onChangeTasks) {
        const nextTasks = [...tasks];
        nextTasks[index2] = {
          ...task,
          end: date
        };
        onChangeTasks(nextTasks, {
          type: "fix_end_position"
        });
      }
    },
    [fixEndPositionProp, onChangeTasks, tasks]
  );
  const onFixDependencyPosition = useCallback(
    (task, dependentTasks, taskIndex, parents, suggestions) => {
      if (onFixDependencyPositionProp) {
        onFixDependencyPositionProp(
          task,
          dependentTasks,
          taskIndex,
          parents,
          suggestions
        );
      }
      if (onChangeTasks) {
        const nextTasks = [...tasks];
        nextTasks[taskIndex] = task;
        onChangeTasks(nextTasks, {
          type: "fix_dependency_position"
        });
      }
    },
    [onFixDependencyPositionProp, onChangeTasks, tasks]
  );
  const handleFixDependency = useCallback(
    (task, delta) => {
      const { start, end } = task;
      const newStart = new Date(start.getTime() + delta);
      const newEnd = new Date(end.getTime() + delta);
      const newChangedTask = {
        ...task,
        start: newStart,
        end: newEnd
      };
      const [dependentTasks, taskIndexes, parents, suggestions] = getMetadata({
        type: "change",
        task: newChangedTask
      });
      const taskIndex = taskIndexes[0].index;
      onFixDependencyPosition(
        newChangedTask,
        dependentTasks,
        taskIndex,
        parents,
        suggestions
      );
    },
    [getMetadata, onFixDependencyPosition]
  );
  const onRelationChange = useCallback(
    (from, to, isOneDescendant) => {
      if (onRelationChangeProp) {
        onRelationChangeProp(from, to, isOneDescendant);
      }
      if (onChangeTasks) {
        if (isOneDescendant) {
          return;
        }
        const nextTasks = [...tasks];
        const [taskFrom, targetFrom, fromIndex] = from;
        const [taskTo, targetTo, toIndex] = to;
        const newDependency = {
          sourceId: taskFrom.id,
          sourceTarget: targetFrom,
          ownTarget: targetTo
        };
        nextTasks[toIndex] = {
          ...taskTo,
          dependencies: taskTo.dependencies ? [
            ...taskTo.dependencies.filter(
              ({ sourceId }) => sourceId !== taskFrom.id
            ),
            newDependency
          ] : [newDependency]
        };
        nextTasks[fromIndex] = {
          ...taskFrom,
          dependencies: taskFrom.dependencies ? taskFrom.dependencies.filter(
            ({ sourceId }) => sourceId !== taskTo.id
          ) : void 0
        };
        onChangeTasks(nextTasks, {
          type: "relation_change"
        });
      }
    },
    [onRelationChangeProp, onChangeTasks, tasks]
  );
  const onArrowDoubleClick = useCallback(
    (taskFrom, taskTo) => {
      if (!onArrowDoubleClickProp && !onChangeTasks) {
        return;
      }
      const { comparisonLevel = 1 } = taskFrom;
      const indexesOnLevel = mapTaskToGlobalIndex.get(comparisonLevel);
      if (!indexesOnLevel) {
        throw new Error(`Indexes are not found for level ${comparisonLevel}`);
      }
      const taskFromIndex = indexesOnLevel.get(taskFrom.id);
      if (typeof taskFromIndex !== "number") {
        throw new Error(`Index is not found for task ${taskFrom.id}`);
      }
      const taskToIndex = indexesOnLevel.get(taskTo.id);
      if (typeof taskToIndex !== "number") {
        throw new Error(`Index is not found for task ${taskTo.id}`);
      }
      if (onArrowDoubleClickProp) {
        onArrowDoubleClickProp(taskFrom, taskFromIndex, taskTo, taskToIndex);
      }
      if (onChangeTasks && isDeleteDependencyOnDoubleClick) {
        const nextTasks = [...tasks];
        nextTasks[taskToIndex] = {
          ...taskTo,
          dependencies: taskTo.dependencies ? taskTo.dependencies.filter(
            ({ sourceId }) => sourceId !== taskFrom.id
          ) : void 0
        };
        onChangeTasks(nextTasks, {
          type: "delete_relation",
          payload: {
            taskFrom,
            taskFromIndex,
            taskTo,
            taskToIndex
          }
        });
      }
    },
    [
      isDeleteDependencyOnDoubleClick,
      mapTaskToGlobalIndex,
      onArrowDoubleClickProp,
      onChangeTasks,
      tasks
    ]
  );
  const handleAction = useHandleAction({
    checkTaskIdExists,
    childTasksMap,
    copyIdsMirror,
    copySelectedTasks,
    copyTask,
    cutIdsMirror,
    cutSelectedTasks,
    cutTask,
    handleAddChilds,
    handleDeleteTasks,
    handleMoveTasksInside,
    makeCopies,
    resetSelectedTasks,
    selectedIdsMirror,
    tasksMap
  });
  const [ganttRelationEvent, handleBarRelationStart] = useCreateRelation({
    distances,
    ganttSVGRef,
    mapTaskToCoordinates,
    mapTaskToGlobalIndex,
    onRelationChange,
    rtl,
    taskHalfHeight,
    tasksMap,
    visibleTasks
  });
  const getTaskCurrentState = useGetTaskCurrentState({
    adjustTaskToWorkingDates: adjustTaskToWorkingDates2,
    changeInProgress,
    isAdjustToWorkingDates,
    isMoveChildsWithParent,
    isUpdateDisabledParentsOnChange,
    mapTaskToCoordinates,
    roundDate,
    tasksMap,
    dateMoveStep
  });
  const getTaskCoordinates$1 = useCallback(
    (task) => countTaskCoordinates$1(getTaskCurrentState(task)),
    [countTaskCoordinates$1, getTaskCurrentState]
  );
  const contextMenuOptions = useMemo(() => {
    if (contextMenuOptionsProp) {
      return contextMenuOptionsProp;
    }
    return [cutOption, copyOption, pasteOption, deleteOption];
  }, [contextMenuOptionsProp]);
  const tooltipTaskFromMap = useMemo(() => {
    if (!tooltipTask) {
      return null;
    }
    const { id, comparisonLevel = 1 } = tooltipTask;
    if (changeInProgress) {
      const { changedTask } = changeInProgress;
      if (changedTask.id === id && (changedTask.comparisonLevel || 1) === comparisonLevel) {
        return changedTask;
      }
    }
    const tasksMapOnLevel = tasksMap.get(comparisonLevel);
    if (!tasksMapOnLevel) {
      return null;
    }
    const resTask = tasksMapOnLevel.get(id);
    if (!resTask || resTask.type === "empty") {
      return null;
    }
    return resTask;
  }, [tooltipTask, tasksMap, changeInProgress]);
  const additionalLeftSpace = (changeInProgress == null ? void 0 : changeInProgress.additionalLeftSpace) || 0;
  const additionalRightSpace = (changeInProgress == null ? void 0 : changeInProgress.additionalRightSpace) || 0;
  const additionalStartColumns = useMemo(
    () => Math.ceil(additionalLeftSpace / distances.columnWidth),
    [additionalLeftSpace, distances]
  );
  const [defaultStartColumnIndex, defaultEndColumnIndex] = renderedColumnIndexes || [0, -1];
  const startColumnIndex = defaultStartColumnIndex - additionalStartColumns;
  const endColumnIndex = defaultEndColumnIndex - additionalStartColumns + 1;
  const fullSvgWidth = useMemo(
    () => svgWidth + additionalLeftSpace + additionalRightSpace,
    [additionalLeftSpace, additionalRightSpace, svgWidth]
  );
  const gridProps = {
    additionalLeftSpace,
    ganttFullHeight,
    columnWidth: distances.columnWidth,
    isUnknownDates,
    rtl,
    startDate,
    todayColor: colorStyles.todayColor,
    holidayBackgroundColor: colorStyles.holidayBackgroundColor,
    viewMode,
    startColumnIndex,
    endColumnIndex,
    checkIsHoliday,
    getDate,
    minTaskDate
  };
  const calendarProps = useMemo(
    () => ({
      additionalLeftSpace,
      dateSetup,
      distances,
      endColumnIndex,
      fontFamily,
      fontSize,
      fullSvgWidth,
      getDate,
      isUnknownDates,
      renderBottomHeader,
      renderTopHeader,
      rtl,
      startColumnIndex,
      colors
    }),
    [
      additionalLeftSpace,
      dateSetup,
      distances,
      endColumnIndex,
      fontFamily,
      fontSize,
      fullSvgWidth,
      getDate,
      isUnknownDates,
      renderBottomHeader,
      renderTopHeader,
      rtl,
      startColumnIndex,
      colors
    ]
  );
  const onClickTask = (task) => {
    if (onClick) {
      onClick(task);
    }
  };
  const barProps = useMemo(
    () => ({
      authorizedRelations,
      additionalLeftSpace,
      additionalRightSpace,
      childOutOfParentWarnings,
      childTasksMap,
      colorStyles,
      comparisonLevels,
      criticalPaths,
      dependencyMap,
      dependentMap,
      distances,
      fixEndPosition,
      fixStartPosition,
      fontFamily,
      fontSize,
      fullRowHeight,
      ganttRelationEvent,
      getTaskCoordinates: getTaskCoordinates$1,
      getTaskGlobalIndexByRef,
      handleBarRelationStart,
      handleDeleteTasks,
      handleFixDependency,
      handleTaskDragStart,
      isShowDependencyWarnings,
      mapGlobalRowIndexToTask,
      onArrowDoubleClick,
      onClick: onClickTask,
      onDoubleClick,
      onFixDependencyPosition,
      onProgressChange,
      onRelationChange,
      renderedRowIndexes,
      rtl,
      selectTaskOnMouseDown,
      selectedIdsMirror,
      setTooltipTask: onChangeTooltipTask,
      taskHalfHeight,
      taskHeight,
      taskToHasDependencyWarningMap,
      taskToRowIndexMap,
      taskYOffset,
      timeStep,
      visibleTasksMirror,
      ContextualPalette,
      TaskDependencyContextualPalette
    }),
    [
      additionalLeftSpace,
      additionalRightSpace,
      checkIsHoliday,
      childOutOfParentWarnings,
      childTasksMap,
      colorStyles,
      comparisonLevels,
      criticalPaths,
      dependencyMap,
      dependentMap,
      distances,
      endColumnIndex,
      fixEndPosition,
      fixStartPosition,
      fontFamily,
      fontSize,
      fullRowHeight,
      ganttRelationEvent,
      getDate,
      getTaskCoordinates$1,
      getTaskGlobalIndexByRef,
      handleBarRelationStart,
      handleDeleteTasks,
      handleTaskDragStart,
      isShowDependencyWarnings,
      mapGlobalRowIndexToTask,
      mapTaskToCoordinates,
      onArrowDoubleClick,
      onChangeTooltipTask,
      onClick,
      onDoubleClick,
      onFixDependencyPosition,
      onProgressChange,
      onRelationChange,
      renderedRowIndexes,
      rtl,
      selectTaskOnMouseDown,
      selectedIdsMirror,
      startColumnIndex,
      taskHalfHeight,
      taskHeight,
      taskToHasDependencyWarningMap,
      taskToRowIndexMap,
      taskYOffset,
      timeStep,
      visibleTasks,
      visibleTasksMirror
    ]
  );
  const tableProps = {
    TaskListHeader,
    TaskListTable,
    canMoveTasks,
    canResizeColumns,
    childTasksMap,
    colors: colorStyles,
    columnsProp,
    cutIdsMirror,
    dateSetup,
    dependencyMap,
    distances,
    fontFamily,
    fontSize,
    fullRowHeight,
    ganttFullHeight,
    getTaskCurrentState,
    handleAddTask,
    handleDeleteTasks,
    handleEditTask,
    handleMoveTaskBefore,
    handleMoveTaskAfter,
    handleMoveTasksInside,
    handleOpenContextMenu,
    icons,
    isShowTaskNumbers,
    mapTaskToNestedIndex,
    onClick: onClickTask,
    onExpanderClick: handleExpanderClick,
    selectTaskOnMouseDown,
    selectedIdsMirror,
    scrollToTask,
    taskListContentRef,
    taskListRef,
    tasks: visibleTasks,
    onResizeColumn,
    onScrollTableListContentVertically: onScrollVertically,
    onCollapseAll,
    onExpandFirstLevel,
    onExpandAll
  };
  const displayTable = !columnsProp || columnsProp.length > 0;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: styles$1.wrapper,
      onKeyDown: handleKeyDown,
      tabIndex: 0,
      ref: wrapperRef,
      "data-testid": `gantt-main`,
      style: {
        gridTemplateColumns: `${displayTable ? "max-content" : ""} auto`,
        background: colors.evenTaskBackgroundColor,
        color: colors.barLabelColor
      },
      children: [
        displayTable && /* @__PURE__ */ jsx(TaskList, { ...tableProps }),
        /* @__PURE__ */ jsx(
          TaskGantt,
          {
            barProps,
            calendarProps,
            distances,
            fullRowHeight,
            fullSvgWidth,
            ganttFullHeight,
            ganttSVGRef,
            gridProps,
            ganttTaskContentRef,
            onVerticalScrollbarScrollX,
            ganttTaskRootRef,
            onScrollGanttContentVertically: onScrollVertically,
            colors
          }
        ),
        tooltipTaskFromMap && /* @__PURE__ */ jsx(
          Tooltip,
          {
            tooltipX,
            tooltipY,
            tooltipStrategy,
            setFloatingRef,
            getFloatingProps,
            fontFamily,
            fontSize,
            task: tooltipTaskFromMap,
            TooltipContent
          }
        ),
        enableTableListContextMenu && /* @__PURE__ */ jsx(
          ContextMenu,
          {
            checkHasCopyTasks,
            checkHasCutTasks,
            colors: colorStyles,
            contextMenu,
            distances,
            handleAction,
            handleCloseContextMenu,
            options: contextMenuOptions
          }
        )
      ]
    }
  );
};
export {
  AddColumn,
  DateEndColumn,
  DateStartColumn,
  DeleteColumn,
  DependenciesColumn,
  EditColumn,
  Gantt,
  GanttDateRoundingTimeUnit,
  ROW_DRAG_TYPE,
  SCROLL_STEP,
  TitleColumn,
  ViewMode,
  copyOption,
  cutOption,
  defaultRenderBottomHeader,
  deleteOption,
  pasteOption
};
